import React, { useContext, useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Colors } from "../Constant/Color";
import { Autocomplete, Grid, Input, TextField } from "@mui/material";
import CustomButton from "./Button";
import DatePickers from "./DatePicker";
import {
  ArrowBackIosNewOutlined,
  ConstructionOutlined,
} from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import Checkbox from "./checkbox";
import { useDispatch, useSelector } from "react-redux";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

import {
  updateAllExchangeInvoice,
  updateAllInvoices,
  updateAllReturnProducts,
  updateAllReturnProductsDuplicate,
  updateCustomers,
  updateDamageItemCustomer,
  updateDayReturnInvoiceEmp,
  updateExhangeProducts,
  updateInvoice,
  updateProducts,
  updateSaleReturnCart,
} from "../Redux/LoginReduces";
import { Base_Uri, Image_Uri } from "../Constant/BaseUri";
import { daDK } from "@mui/x-data-grid";
import axios from "axios";
import CustomModal from "./modal";
import { RingLoader } from "react-spinners";
import BasicSelect from "./Dropdown";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Document,
  Page,
  Text,
  View,
  PDFViewer,
  PDFDownloadLink,
  Image,
  Font,
} from "@react-pdf/renderer";
//import MyFontRegular from "/fonts/Poppins-Medium.ttf";
//import MyFontBold from "/fonts/Poppins-Medium.ttf";
import useScanDetection from "use-scan-detection";
import { Await } from "react-router-dom";
import { SELECTED_CUSTOMER, SELECTED_INVOICES } from "../Context";
import { message } from "antd";
import Base from "antd/es/typography/Base";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  overflow: "auto",
  maxHeight: "80vh",
  transform: "translate(-50%, -50%)",
  width: { xl: "80%", lg: "90%", md: "95%", sm: "95%", xs: "98%" },
  borderRadius: "10px",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 2,
};

export default function MultipleReturnModal({
  barcodeData,
  setBarcodeRead,
  heading,
  text1,
  headingTextStyle,
  setReturnModal,
  textStyle,
  containerStyle,
  open,
  closeModal,
  buttonContainerStyle,
  buttonStyle,
  buttonStyle2,
  confirm,
}) {
  Font.register({
          family: 'MyFont',
          fonts: [
              { src: "/fonts/Poppins-Bold.ttf", fontWeight: 'bold' },
              { src: "/fonts/Poppins-Medium.ttf", fontWeight: 'normal' },
          ]
      });

  const dispatch = useDispatch();

  let textInputRef = useRef(null);

  const allReturnProducts = useSelector(
    (state) => state?.loginReducer?.allReturnProducts
  );

  const products = useSelector((state) => state.loginReducer.products);
  const customers = useSelector((state) => state.loginReducer.customers);
  const selectedCustomer = useSelector(
    (state) => state.loginReducer.selectedDamageItemCustomer
  );
  const cart = useSelector((state) => state.loginReducer.saleReturnCart);
  // const saleinvoices = useSelector((state) => state.loginReducer.allInvoices);
  // const exchangeInvoices = useSelector(
  //   (state) => state?.loginReducer?.allExchangeInvoice
  // );

  const [saleinvoices, setSaleinvoices] = useState([]);
  const [exchangeInvoices, setExchangeInvoices] = useState([]);

  const [showIMEI, setShowIMEI] = useState(false);

  const invoices = [...saleinvoices, ...exchangeInvoices];

  const vatRate = useSelector((state) => state.loginReducer.vat)?.vatRate;
  const vatNumber = useSelector((state) => state.loginReducer.vat)?.vatNumber;

  const vat = useSelector((state) => state.loginReducer.vat);
  const companyNumber = useSelector(
    (state) => state.loginReducer.vat
  )?.companyNumber;
  const userData = useSelector((state) => state.loginReducer.updatedState);

  const [searchProducts, setSearchProducts] = useState([]);
  const [searchCustomers, setSearchCustomers] = useState([]);
  const [searchInvoices, setSearchInvoices] = useState([]);
  const [customerInvoice, setCustomerInvoices] = useState("");
  const [searchCustomerInvoice, setSearchCustomerInvoice] = useState("");
  const { selectedInvoice, setSelectedInvoice } = useContext(SELECTED_INVOICES);
  const [loading, setLoading] = useState(false);
  const [confirmModalVisible, setConfirmModalVisible] = useState(false);
  const [emailLoading, setEmailLoading] = useState(false);
  const [successfulTransactionModal, setSuccessfulTransactionModal] =
    useState(false);
  const [refHover, setRefHover] = useState(false);
  const [text, setText] = useState("");
  const [selectedSearch, setSelectedSearch] = useState("customers");
  const [returnInvoice, setReturnInvoice] = useState("");
  const [lessAmount, setLessAmount] = useState(false);
  const [deductCreditBalance, setDeductCreditBalance] = useState({
    selected: false,
  });
  const { selectCustomerId, setSelectedCustomerId } =
    useContext(SELECTED_CUSTOMER);
  const [productStatus, setProductStatus] = useState([
    "Unused/Change of mind",
    "Faulty",
    "Damaged",
  ]);
  const [invoiceLoading, setInvoiceLoading] = useState(false);

  const [deductBalanceOptions, setDeductBalanceOptions] = useState([
    "Quotation",
    "Invoice",
  ]);

  const [selectedDeductBalanceOption, setSelectedDeductBalanceOption] =
    useState("select");

  const [pdfDownloadView, setPdfDownloadView] = useState(false);

  const [exchangeLoading, setExchangeLoading] = useState(false);

  const [refundCash, setRefundCash] = useState({
    selected: false,
  });

  const [refundCard, setRefundCard] = useState({
    selected: false,
  });

  const [exchangeProduct, setExchangeProduct] = useState({
    selected: false,
  });

  const [byCurrentPrice, setByCurrentPrice] = useState({
    selected: false,
  });

  const width = window.innerWidth;

  // const getAllInvoices = async (id) => {

  //   setInvoiceLoading(true);

  //   let data = await sessionStorage.getItem("userData");
  //   data = JSON.parse(data);
  //   let token = data;

  //   axios
  //     .get(`${Base_Uri}getAllInvoices?customerId=${id}`, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         "Content-Type": "application/json", // Include other headers as needed
  //       },
  //     })
  //     .then((res) => {
  //       if (!res?.status) {
  //         setInvoiceLoading(false);
  //         message.info(res.message);
  //         return;
  //       }

  //       let { data } = res.data;
  //       data =
  //         data &&
  //         data.length > 0 &&
  //         data.map((e, i) => {
  //           return {
  //             ...e,
  //             id: e._id,
  //           };
  //         });

  //       setInvoiceLoading(false);
  //       setSaleinvoices(data && data.length > 0 ? data : [])
  //       return (data && data.length > 0 ? data : [])
  //       // dispatch(updateAllInvoices(data && data.length > 0 ? data : []));
  //       // resolve(data)
  //     })
  //     .catch((error) => {
  //       // reject(error)

  //       setInvoiceLoading(false);
  //       console.log(error, "error");
  //     });
  //   // });
  // };

  // const getAllExchangeInvoices = async (id) => {
  //   setExchangeLoading(true);
  //   let data = await sessionStorage.getItem("userData");
  //   data = JSON.parse(data);
  //   let token = data;

  //   axios
  //     .get(`${Base_Uri}getAllExchangeInvoices?customerId=${id}`, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         "Content-Type": "application/json", // Include other headers as needed
  //       },
  //     })
  //     .then((res) => {
  //       if (!res?.status) {
  //         message.info(res.message);
  //         setExchangeLoading(false);
  //         return;
  //       }

  //       let { data } = res.data;
  //       data =
  //         data &&
  //         data.length > 0 &&
  //         data.map((e, i) => {
  //           return {
  //             ...e,
  //             id: e._id,
  //           };
  //         });
  //       setExchangeLoading(false);
  //       setExchangeInvoices(data && data.length > 0 ? data : [])
  //       return (data && data.length > 0 ? data : [])
  //       // dispatch(updateAllExchangeInvoice(data && data.length > 0 ? data : []));
  //     })
  //     .catch((error) => {
  //       setExchangeLoading(false);
  //       console.log(error, "error");
  //     });
  // };

  // useEffect(() => {
  //   getAllInvoices();
  //   getAllExchangeInvoices();
  // }, [open]);

  const getAllInvoices = async (id) => {
    try {
      setInvoiceLoading(true);

      let data = await sessionStorage.getItem("userData");
      data = JSON.parse(data);
      let token = data;

      const res = await axios.get(
        `${Base_Uri}getAllInvoices?customerId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!res?.status) {
        message.info(res.message);
        setInvoiceLoading(false);
        return [];
      }

      let { data: responseData } = res.data;
      const mappedData = responseData?.map((e) => ({ ...e, id: e._id })) || [];

      setInvoiceLoading(false);
      setSaleinvoices(mappedData);
      return mappedData;
    } catch (error) {
      setInvoiceLoading(false);
      //console.log("getAllInvoices error", error);
      return [];
    }
  };

  const getAllExchangeInvoices = async (id) => {
    try {
      setExchangeLoading(true);

      let data = await sessionStorage.getItem("userData");
      data = JSON.parse(data);
      let token = data;

      const res = await axios.get(
        `${Base_Uri}getAllExchangeInvoices?customerId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!res?.status) {
        message.info(res.message);
        setExchangeLoading(false);
        return [];
      }

      let { data: responseData } = res.data;
      const mappedData = responseData?.map((e) => ({ ...e, id: e._id })) || [];

      setExchangeLoading(false);
      setExchangeInvoices(mappedData);
      return mappedData;
    } catch (error) {
      setExchangeLoading(false);
      //console.log("getAllExchangeInvoices error", error);
      return [];
    }
  };

  const getCurrentPrice = async () => {
    let { productDetails } = selectedInvoice;

    let selectedProducts = [];
    let returnProducts = [...productDetails];

    let promise =
      returnProducts &&
      returnProducts.length > 0 &&
      returnProducts.map(async (e, index) => {
        products &&
          products.length > 0 &&
          products.map((product) => {
            if (product._id == e?._id) {
              selectedProducts.push(product);
            }
          });
      });

    await Promise.all(promise);

    returnProducts &&
      returnProducts.length > 0 &&
      returnProducts?.map((e, i) => {
        selectedProducts &&
          selectedProducts.length > 0 &&
          selectedProducts.map((product) => {
            // Create a new object to ensure it's extensible
            if (e?._id == product?._id) {
              let updatedDetail = { ...e };
              updatedDetail.current_costprice = Number(
                product.cost_price
              ).toFixed(2);
              updatedDetail.current_retailprice = Number(
                product.retail_price
              ).toFixed(2);
              updatedDetail.current_tradeprice = Number(
                product.trade_price
              ).toFixed(2);
              updatedDetail.current_warehouseprice = Number(
                product.warehouse_price
              ).toFixed(2);
              updatedDetail.current_diamond = Number(product.diamond).toFixed(
                2
              );
              returnProducts[i] = updatedDetail; // Replace the old object with the new one
            }
          });
      });

    setSelectedInvoice({
      ...selectedInvoice,
      productDetails: returnProducts,
    });
  };

  useEffect(() => {
    if (selectedInvoice?._id) {
      getCurrentPrice();
    }
  }, [selectedInvoice?._id, products?.length]);

  const notify = (text) => toast(text);

  useEffect(() => {

      if (selectedSearch == "customers") {
        setTimeout(() => {

          textInputRef?.current?.focus();

      }, [300]);
      }else{
        textInputRef?.current?.blur();
      }

  }, [textInputRef?.current])

  const getTodayReturnInvoices = async () => {
    if (userData) {
      let data = await sessionStorage.getItem("userData");
      data = JSON.parse(data);
      let token = data;

      axios
        .get(`${Base_Uri}getReturnInvoices/${userData.id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // Include other headers as needed
          },
        })
        .then((res) => {
          if (!res?.status) {
            message.info(res.message);
            return;
          }

          let { data } = res.data;

          data =
            data &&
            data.length > 0 &&
            data.map((e, i) => {
              return {
                ...e,
                id: e._id,
              };
            });

          dispatch(updateDayReturnInvoiceEmp(data));
        })
        .catch((error) => {
          //console.log(error, "error");
        });
    }
  };

  const getCustomers = async () => {
    let token = await sessionStorage.getItem("userData");
    token = JSON.parse(token);

    axios
      .get(`${Base_Uri}getCustomers`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // Include other headers as needed
        },
      })
      .then((res) => {
        let { data } = res;

        if (data.status) {
          dispatch(updateCustomers(data.data));
        }
      })
      .catch((error) => {
        //console.log(error, "error");
      });
  };

  const getProducts = async () => {
    // setLoading(true)
    let data = await sessionStorage.getItem("userData");
    data = JSON.parse(data);
    let token = data;

    if (token) {
      axios
        .get(`${Base_Uri}getProducts`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // Include other headers as needed
          },
        })
        .then((res) => {
          let myData = res.data;

          let { data } = myData;

          if (data && data.length > 0) {
            let allProducts = [];

            for (var i = 0; i < data.length; i++) {
              let product = data[i];

              product.id = i + 1;
              product["productName"] = product?.product_name;

              if (product.status == "active") {
                product.status = "Active";
              }

              allProducts.push(product);
            }

            dispatch(updateProducts(allProducts));
          }
        })
        .catch((error) => {
          //console.log(error, "error");
          // setLoading(false)
        });
    }
  };

  const handleDecreaseProduct = (product, type) => {
    if (type == "exchange") {
      let updateProducts = selectedInvoice?.returnProductDetails?.map(
        (e, i) => {
          if (e.id == product.id) {
            return {
              ...e,
              DamageQty: product.DamageQty
                ? product.DamageQty - 1
                : product.saleQty - 1,
            };
          } else {
            return e;
          }
        }
      );

      let invoice = {
        ...selectedInvoice,
        returnProductDetails: updateProducts,
      };

      setSelectedInvoice(invoice);

      return;
    }

    let updateProducts = selectedInvoice.productDetails.map((e, i) => {
      if (e.id == product.id) {
        return {
          ...e,
          DamageQty: product.DamageQty
            ? product.DamageQty - 1
            : product.saleQty - 1,
        };
      } else {
        return e;
      }
    });

    let invoice = { ...selectedInvoice, productDetails: updateProducts };

    setSelectedInvoice(invoice);
  };
  const handleDecreaseProduct2 = (invoices, product, type) => {
    if (type == "exchange") {
      let updateProducts = invoices?.returnProductDetails?.map((e, i) => {
        if (e.id == product._id) {
          return {
            ...e,
            DamageQty: product.DamageQty
              ? product.DamageQty - 1
              : product.saleQty - 1,
          };
        } else {
          return e;
        }
      });

      setSearchCustomerInvoice((prev) =>
        prev.map((inv) =>
          inv.invoiceNumber === invoices.invoiceNumber
            ? { ...inv, returnProductDetails: updateProducts }
            : inv
        )
      );

      return;
    }
//console.log(invoices.productDetails,"invoices.productDetails")
    let updateProducts = invoices.productDetails.map((e, i) => {
      if (e.id == product._id) {
        return {
          ...e,
          DamageQty: product.DamageQty
            ? product.DamageQty - 1
            : product.saleQty - 1,
        };
      } else {
        return e;
      }
    });
//console.log(updateProducts,"updateProducts")

    setSearchCustomerInvoice((prev) =>
      prev.map((inv) =>
        inv.invoiceNumber === invoices.invoiceNumber
          ? { ...inv, productDetails: updateProducts }
          : inv
      )
    );
  };
  const handleDeleteProduct = (product) => {
    let newCart = cart.filter((e, i) => {
      return e._id !== product._id;
    });
    dispatch(updateSaleReturnCart(newCart));
    setText("");
    setSearchProducts([]);
  };

  useEffect(() => {
    const fetchInvoices = async () => {
      if (!selectCustomerId?.id) return;

      try {
        const allInvoices = (await getAllInvoices(selectCustomerId?.id)) || [];
        const allExchangeInvoices =
          (await getAllExchangeInvoices(selectCustomerId?.id)) || [];
        //console.log(allInvoices, "lk");
        const getCustomerInvoice = [...allInvoices, ...allExchangeInvoices];

        // let getCustomerInvoice = invoicess.filter((invoice) =>
        //   invoice?.customerDetails?.some(detail => detail.id == selectCustomerId)
        // );

        if (getCustomerInvoice.length > 0) {
          getCustomerInvoice.sort((a, b) => {
            return (
              new Date(b.saleDate).getTime() - new Date(a.saleDate).getTime()
            );
          });
        }
        //console.log(getCustomerInvoice, "k");
        setCustomerInvoices(getCustomerInvoice);
        setSelectedSearch("products");
        dispatch(updateDamageItemCustomer(selectCustomerId));
        setText("");
        setSearchCustomerInvoice("");
        setSearchCustomers([]);
        setSelectedCustomerId({});
      } catch (error) {
        console.error("Error fetching customer invoices:", error);
      }
    };

    fetchInvoices();
  }, [selectCustomerId?.id]);

  const handleSelectCustomer = async (customer) => {
    let allInvoices = (await getAllInvoices(customer.id)) || [];
    let allExchangeInvoices = (await getAllExchangeInvoices(customer.id)) || [];

    let invoicess = await [...allInvoices, ...allExchangeInvoices];
    let getCustomerInvoice =
      invoicess &&
      invoicess.length > 0 &&
      invoicess.filter((e, i) => {
        if (e.customerDetails[0].id == customer.id) {
          return e;
        }
      });

    getCustomerInvoice =
      getCustomerInvoice &&
      getCustomerInvoice.length > 0 &&
      getCustomerInvoice.sort(
        (a, b) =>
          new Date(b.saleDate).getTime() - new Date(a.saleDate).getTime()
      );

    setCustomerInvoices(getCustomerInvoice);
    setSelectedSearch("products");
    dispatch(updateDamageItemCustomer(customer));
    setText("");
    setSearchCustomerInvoice("");
    setSearchCustomers([]);
  };
  //console.log(searchCustomers);
  const handleSearch = (text) => {
    setText(text);

    if (!text) {
      setSearchCustomers([]);
      setSearchInvoices([]);
      setSearchCustomerInvoice("");
      setSearchProducts([]);
      return;
    }

    if (selectedSearch == "customers") {
      setSearchProducts([]);
      setSearchInvoices([]);

      setSearchCustomers(
        customers &&
          customers.length > 0 &&
          customers.filter((e, i) => {
            if (
              e?.customerName?.toLowerCase().includes(text.toLowerCase()) ||
              e?.businessName?.toLowerCase().includes(text.toLowerCase()) ||
              e?.email?.toLowerCase().includes(text.toLowerCase()) ||
              e?.accountNo == text
            ) {
              return e;
            }
          })
      );
    }

    if (selectedSearch == "invoices") {
      setSearchProducts([]);
      setSearchCustomers([]);

      setSearchInvoices(
        invoices &&
          invoices.length > 0 &&
          invoices.filter((e, i) => {
            if (
              e?.invoiceNumber?.toLowerCase().includes(text.toLowerCase()) ||
              e?.businessName?.toLowerCase().includes(text.toLowerCase())
            ) {
              return e;
            }
          })
      );
    }

    if (selectedSearch == "products") {
      setSearchCustomers([]);
      setSearchInvoices([]);

      let allProducts =
        invoices && invoices.length > 0
          ? invoices.flatMap((e) => e.productDetails)
          : [];

      setSearchProducts(
        allProducts &&
          allProducts.length > 0 &&
          allProducts.filter((e) => {
            const searchWords = text.toLowerCase().split(" ").filter(Boolean); // Tokenize search text

            return searchWords.every((word) =>
              [
                e?.productName,
                e?.category,
                e?.sku,
                e?.barcode?.toString(),
                e?.sub_category,
              ].some((field) => field?.toLowerCase().includes(word))
            );
          })
      );
    }

    if (selectedSearch === "imei") {
      //console.log("hello");
      setSearchCustomers([]);
      setSearchInvoices([]);

      // Flatten product details from invoices
      const allProducts =
        invoices?.flatMap((invoice) => invoice.productDetails) || [];

      // Filter products based on IMEI
      const filteredProducts = allProducts.filter((product) => {
        const imei = product?.IMEI;
        //console.log(product?.IMEI, "dl");
        if (imei && (typeof imei === "object" || typeof imei === "string")) {
          // //console.log("hel", imei);

          // Check if any IMEI matches the search text
          return Array.isArray(imei)
            ? imei.some(
                (j) => j?.toString().toLowerCase() === text?.toLowerCase()
              )
            : imei.toString().toLowerCase() === text?.toLowerCase();
        }

        return false; // Return false if IMEI doesn't meet conditions
      });
      //console.log(filteredProducts, "filter");
      setSearchProducts(filteredProducts);
    }
  };

  const handleDiscountPrice = (price, product) => {
    let newInvoice =
      selectedInvoice &&
      selectedInvoice.productDetails.length > 0 &&
      selectedInvoice.productDetails.map((e, i) => {
        if (e._id == product._id) {
          return {
            ...e,
            discountPrice: 0,
            trade_price:
              selectedInvoice?.customerDetails[0].priceLevel[0].id == 1
                ? Number(price)
                : e?.trade_price,
            warehouse_price:
              selectedInvoice?.customerDetails[0].priceLevel[0].id == 2
                ? Number(price)
                : e?.warehouse_price,
            diamond:
              selectedInvoice?.customerDetails[0].priceLevel[0].id == 4
                ? Number(price)
                : e?.diamond,
            retail_price:
              selectedInvoice?.customerDetails[0].priceLevel[0].id == 3
                ? Number(price)
                : e?.retail_price,
          };

          // if (e._id == product._id) {
          //     return {
          //         ...e,
          //         discountPrice: (e?.discountPrice && (Number(price) <= (selectedInvoice?.customerDetails[0].priceLevel[0].id == 1 ? e?.trade_price
          //             : selectedInvoice?.customerDetails[0].priceLevel[0].id == 2 ? e?.warehouse_price : e?.retail_price))) ? Number(price) : 0,
          //         trade_price: (e?.discountPrice &&
          //             (Number(price) <= (selectedInvoice?.customerDetails[0].priceLevel[0].id == 1 ? e?.trade_price
          //                 : selectedInvoice?.customerDetails[0].priceLevel[0].id == 2 ? e?.warehouse_price : e?.retail_price))
          //         ) ? e?.trade_price : selectedInvoice?.customerDetails[0].priceLevel[0].id == 1 ? Number(price) : e?.trade_price,
          //         warehouse_price: (e?.discountPrice && (Number(price) <= (selectedInvoice?.customerDetails[0].priceLevel[0].id == 1 ? e?.trade_price
          //             : selectedInvoice?.customerDetails[0].priceLevel[0].id == 2 ? e?.warehouse_price : e?.retail_price)))
          //             ? e?.warehouse_price : selectedInvoice?.customerDetails[0].priceLevel[0].id == 2 ? Number(price) : e?.warehouse_price,
          //         retail_price: (e?.discountPrice && (Number(price) <= (selectedInvoice?.customerDetails[0].priceLevel[0].id == 1 ? e?.trade_price
          //             : selectedInvoice?.customerDetails[0].priceLevel[0].id == 2 ? e?.warehouse_price : e?.retail_price))) ? e?.retail_price : selectedInvoice?.customerDetails[0].priceLevel[0].id == 3 ? Number(price) : e?.retail_price,

          //     };
        } else {
          return e;
        }
      });

    let invoice = { ...selectedInvoice, productDetails: newInvoice };

    setSelectedInvoice(invoice);
  };

  const handleDiscountPrice2 = (invoices, price, product) => {
    let newInvoice =
      invoices &&
      invoices.productDetails.length > 0 &&
      invoices.productDetails.map((e, i) => {
        if (e._id == product._id) {
          return {
            ...e,
            discountPrice: 0,
            trade_price:
              invoices?.customerDetails[0].priceLevel[0].id == 1
                ? Number(price)
                : e?.trade_price,
            warehouse_price:
              invoices?.customerDetails[0].priceLevel[0].id == 2
                ? Number(price)
                : e?.warehouse_price,
            diamond:
              invoices?.customerDetails[0].priceLevel[0].id == 2
                ? Number(price)
                : e?.diamond,
            retail_price:
              invoices?.customerDetails[0].priceLevel[0].id == 3
                ? Number(price)
                : e?.retail_price,
            diamond:
              invoices?.customerDetails[0].priceLevel[0].id == 4
                ? Number(price)
                : e?.diamond,
          };

          // if (e._id == product._id) {
          //     return {
          //         ...e,
          //         discountPrice: (e?.discountPrice && (Number(price) <= (selectedInvoice?.customerDetails[0].priceLevel[0].id == 1 ? e?.trade_price
          //             : selectedInvoice?.customerDetails[0].priceLevel[0].id == 2 ? e?.warehouse_price : e?.retail_price))) ? Number(price) : 0,
          //         trade_price: (e?.discountPrice &&
          //             (Number(price) <= (selectedInvoice?.customerDetails[0].priceLevel[0].id == 1 ? e?.trade_price
          //                 : selectedInvoice?.customerDetails[0].priceLevel[0].id == 2 ? e?.warehouse_price : e?.retail_price))
          //         ) ? e?.trade_price : selectedInvoice?.customerDetails[0].priceLevel[0].id == 1 ? Number(price) : e?.trade_price,
          //         warehouse_price: (e?.discountPrice && (Number(price) <= (selectedInvoice?.customerDetails[0].priceLevel[0].id == 1 ? e?.trade_price
          //             : selectedInvoice?.customerDetails[0].priceLevel[0].id == 2 ? e?.warehouse_price : e?.retail_price)))
          //             ? e?.warehouse_price : selectedInvoice?.customerDetails[0].priceLevel[0].id == 2 ? Number(price) : e?.warehouse_price,
          //         retail_price: (e?.discountPrice && (Number(price) <= (selectedInvoice?.customerDetails[0].priceLevel[0].id == 1 ? e?.trade_price
          //             : selectedInvoice?.customerDetails[0].priceLevel[0].id == 2 ? e?.warehouse_price : e?.retail_price))) ? e?.retail_price : selectedInvoice?.customerDetails[0].priceLevel[0].id == 3 ? Number(price) : e?.retail_price,

          //     };
        } else {
          return e;
        }
      });
    setSearchCustomerInvoice((prev) =>
      prev.map((inv) =>
        inv.invoiceNumber === invoices.invoiceNumber
          ? { ...inv, productDetails: newInvoice }
          : inv
      )
    );

    // let invoice = { ...selectedInvoice, productDetails: newInvoice };

    // setSelectedInvoice(invoice);
  };

  const handleSelectInvoice = (invoice) => {
    setSelectedInvoice(invoice);
    //console.log(invoice, "invoice1");

    setLessAmount(false);

    let selectCustomer =
      customers &&
      customers.length > 0 &&
      customers.filter((e, i) => {
        return e?.id == invoice?.customerDetails[0]?.id;
      });

    dispatch(
      updateDamageItemCustomer(
        selectCustomer && selectCustomer.length > 0 ? selectCustomer[0] : ""
      )
    );
    setText("");
    setSearchInvoices([]);
  };

  const handleSelectProduct = async (product) => {
    let { productDetails } = selectedInvoice;
//console.log(product,"proudct")
    if (productDetails?.some((e, i) => e._id == product?._id)) {
      let productSelected = productDetails?.find(
        (e, i) => e?._id == product?._id
      );

       let calculateSpDiscountPercent = (selectedInvoice?.SDAmount / ((selectedInvoice?.total)-(selectedInvoice?.discount||0))) * 100;
    // calculateSpDiscountPercent = ((selectedInvoice?.total-(selectedInvoice?.discount||0))*calculateSpDiscountPercent)/100
       //console.log(calculateSpDiscountPercent,"calculateSpDiscuountPercent")
      let qtyReturn = product?.DamageQty
        ? product?.DamageQty
        : product?.saleQty;

      let remainingQtyToReturn =
        productSelected.saleQty -
        (productSelected?.returnQty ? productSelected?.returnQty : 0);

      if (
        Number(qtyReturn) > Number(remainingQtyToReturn) &&
        !productSelected?.selected
      ) {
        message.info(
          `Not enough qty to return the customer has already return ${productSelected?.returnQty} qty`
        );
        return;
      } else {
        productDetails = productDetails.map((e, i) => {
          if (product.id == e.id) {
            return {
              ...e,
              selected: !e.selected,
              discountPrice: 0,
              trade_price:
                selectedInvoice?.customerDetails[0].priceLevel[0].id == 1
                  ? Number(e?.discountPrice)
                    ? e?.discountPrice
                    : e?.trade_price
                  : e?.trade_price,

              warehouse_price:
                selectedInvoice?.customerDetails[0].priceLevel[0].id == 2
                  ? Number(e?.discountPrice)
                    ? e?.discountPrice
                    : e?.warehouse_price
                  : e?.warehouse_price,
              diamond:
                selectedInvoice?.customerDetails[0].priceLevel[0].id == 4
                  ? Number(e?.discountPrice)
                    ? e?.discountPrice
                    : e?.diamond
                  : e?.diamond,
              retail_price:
                selectedInvoice?.customerDetails[0].priceLevel[0].id == 3
                  ? Number(e?.discountPrice)
                    ? e?.discountPrice
                    : e?.retail_price
                  : e?.retail_price,
            };
          } else {
            return e;
          }
        });
        
        let calSd = selectedInvoice?.productDetails?.reduce((t, c) => {
          
          if ((c._id != product._id)&&!c.selected) return t;
//console.log("DO")
          // Pick correct price based on price level
          const priceLevelId = selectedInvoice.customerDetails[0].priceLevel[0].id;
          const price =
            priceLevelId === 1
              ? c.trade_price
              : priceLevelId === 2
              ? c.warehouse_price
              : priceLevelId === 4
              ? c.diamond
              : c.retail_price;

          // Effective qty
          const qty = c.DamageQty || c.saleQty;
          //console.log(price,qty,"price","qty")

          // Discount-adjusted total
          const total = (c.discountPrice
            ? (Number(c.discountPrice)) * qty
            : price * qty);
 //console.log(total,"total")
          // Apply special discount percent
          return t + (total * calculateSpDiscountPercent) / 100;
        }, 0);
        //console.log(calSd,"pdppcalSd")
        await setSelectedInvoice({
          ...selectedInvoice,
          productDetails: productDetails,
          newSDAmount:calSd||0,
        });
        setIsSelectProductUseConfirm(true)
        // await handleOpenConfimModal()
      }
    }
  };
  const handleUpdateProduct = (invoice, productId, updates) => {
    //console.log(invoice.productDetails,"invoice.productDetails")
    const updatedProducts = invoice.productDetails.map((prod) =>
      prod._id === productId ? { ...prod, ...updates } : prod
    );
    // If invoice is in state, update it properly here
    setSearchCustomerInvoice((prev) =>
      prev.map((inv) =>
        inv.invoiceNumber === invoice.invoiceNumber
          ? { ...inv, productDetails: updatedProducts }
          : inv
      )
    );
  };
const handleSelectProduct2 = async (product, invoice) => {
  let { productDetails } = invoice;

  const productSelected = productDetails?.find((e) => e._id === product?._id);
  if (!productSelected) return;

  const totalAfterDiscount = Number(invoice?.total || 0) - Number(invoice?.discount || 0);
  const calculateSpDiscountPercent =
    totalAfterDiscount > 0 ? (Number(invoice?.SDAmount || 0) / totalAfterDiscount) * 100 : 0;

  //console.log(calculateSpDiscountPercent, "calculateSpDiscountPercent");

  const qtyReturn = product?.DamageQty ? Number(product?.DamageQty) : Number(product?.saleQty || 0);
  const remainingQtyToReturn =
    Number(productSelected?.saleQty || 0) -
    Number(productSelected?.returnQty || 0);

  if (qtyReturn > remainingQtyToReturn && !productSelected?.selected) {
    message.info(
      `Not enough qty to return — customer has already returned ${productSelected?.returnQty || 0} qty`
    );
    return;
  }

  productDetails = productDetails.map((e) => {
    if (e._id === product._id) {
      const priceLevelId = invoice?.customerDetails?.[0]?.priceLevel?.[0]?.id;
      const resolvePrice = (basePrice, priceKey) =>
        priceLevelId === priceKey
          ? Number(e?.discountPrice) || e?.[priceKey === 1
              ? "trade_price"
              : priceKey === 2
              ? "warehouse_price"
              : priceKey === 3
              ? "retail_price"
              : "diamond"]
          : e?.[priceKey === 1
              ? "trade_price"
              : priceKey === 2
              ? "warehouse_price"
              : priceKey === 3
              ? "retail_price"
              : "diamond"];

      return {
        ...e,
        selected: !e.selected,
        discountPrice: 0,
        trade_price: resolvePrice(e.trade_price, 1),
        warehouse_price: resolvePrice(e.warehouse_price, 2),
        retail_price: resolvePrice(e.retail_price, 3),
        diamond: resolvePrice(e.diamond, 4),
      };
    } else return e;
  });

  const priceLevelId = invoice?.customerDetails?.[0]?.priceLevel?.[0]?.id || 1;

  const calSd = productDetails.reduce((t, c) => {
    if (!c.selected) return t;

    const price =
      priceLevelId === 1
        ? c.trade_price
        : priceLevelId === 2
        ? c.warehouse_price
        : priceLevelId === 4
        ? c.diamond
        : c.retail_price;

    const qty = Number(c.DamageQty || c.saleQty || 0);
    const total = (Number(c.discountPrice) || price) * qty;
    return t + (total * calculateSpDiscountPercent) / 100;
  }, 0);

   damageItems = productDetails.filter((p) => p.selected).length;
   damageQty = productDetails.reduce(
    (sum, p) =>
      sum +
      (p.selected ? Number(p.DamageQty || p.saleQty || 0) : 0),
    0
  );

   damagetotal = productDetails.reduce((sum, p) => {
    if (!p.selected) return sum;
    const price =
      priceLevelId === 1
        ? p.trade_price
        : priceLevelId === 2
        ? p.warehouse_price
        : priceLevelId === 4
        ? p.diamond
        : p.retail_price;
    const qty = Number(p.DamageQty || p.saleQty || 0);
    return sum + price * qty;
  }, 0);

   damageCost = productDetails.reduce(
    (sum, p) =>
      sum +
      (p.selected
        ? Number(p.cost_price || 0) *
          Number(p.DamageQty || p.saleQty || 0)
        : 0),
    0
  );

   damageDiscount = productDetails.reduce((sum, p) => {
    if (!p.selected || !p.discountPrice) return sum;
    const price =
      priceLevelId === 1
        ? p.trade_price
        : priceLevelId === 2
        ? p.warehouse_price
        : priceLevelId === 4
        ? p.diamond
        : p.retail_price;

    const qty = Number(p.DamageQty || p.saleQty || 0);
    const discountAdjusted =
      (price - Number(p.discountPrice)) * qty;
    return sum + discountAdjusted;
  }, 0);
//console.log(vatRate,"vatRate")
  const vatRates = Number(vatRate || 0);
   damageVat = invoice?.vatAmount
    ? (((damagetotal - damageDiscount)- (((damagetotal - damageDiscount) * calculateSpDiscountPercent) /
                            100) ) * vatRates) / 100
    : 0;
    // console.log( invoice?.vatAmount
    // ? ((damagetotal - damageDiscount) * vatRates) / 100
    // : 0,` invoice?.vatAmount
    // ? ((damagetotal - damageDiscount) * vatRates) / 100
    // : 0`)

   damageSubtotal =
    Number(damagetotal || 0) -
    Number(damageDiscount || 0) +
    Number(damageVat || 0) -
    Number(calSd || 0);

  // //console.log({
  //   damagetotal,
  //   damageDiscount,
  //   damageVat,
  //   calSd,
  //   damageSubtotal,
  // },"dlld");
//console.log(productDetails,"productDetails")
  setIsSelectProductUseConfirm(true);
  handleOpenConfimModal2({
    ...invoice,
    productDetails,
    newSDAmount: calSd || 0,
  });
};

  // const handleSelectProduct2 = async (product, invoice, ctc) => {
  //   // let { productDetails } = selectedInvoice;
  //   //console.log(allReturnProducts, "allReturnProducts");
  //   // let existProduct = allReturnProducts
  //   let productDetails = invoice?.productDetails;
  //   if (invoice?.productDetails?.some((e, i) => e._id == product?._id)) {
  //     let productSelected = product;
  //     let qtyReturn = product?.DamageQty
  //       ? product?.DamageQty
  //       : product?.saleQty;

  //     let remainingQtyToReturn =
  //       productSelected.saleQty -
  //       (productSelected?.returnQty ? productSelected?.returnQty : 0);

  //     if (
  //       Number(qtyReturn) > Number(remainingQtyToReturn) &&
  //       !productSelected?.selected
  //     ) {
  //       message.info(
  //         `Not enough qty to return the customer has already return ${productSelected?.returnQty} qty`
  //       );
  //       return;
  //     } else {
  //       productDetails = productDetails.map((e, i) => {
  //         if (product.id == e.id) {
  //           return {
  //             ...e,
  //             selected: !e.selected,
  //             discountPrice: 0,
  //             trade_price:
  //               invoice?.customerDetails[0].priceLevel[0].id == 1
  //                 ? Number(e?.discountPrice)
  //                   ? e?.discountPrice
  //                   : e?.trade_price
  //                 : e?.trade_price,

  //             warehouse_price:
  //               invoice?.customerDetails[0].priceLevel[0].id == 2
  //                 ? Number(e?.discountPrice)
  //                   ? e?.discountPrice
  //                   : e?.warehouse_price
  //                 : e?.warehouse_price,
  //             diamond:
  //               invoice?.customerDetails[0].priceLevel[0].id == 4
  //                 ? Number(e?.discountPrice)
  //                   ? e?.discountPrice
  //                   : e?.diamond
  //                 : e?.diamond,
  //             retail_price:
  //               invoice?.customerDetails[0].priceLevel[0].id == 3
  //                 ? Number(e?.discountPrice)
  //                   ? e?.discountPrice
  //                   : e?.retail_price
  //                 : e?.retail_price,
  //           };
  //         } else {
  //           return e;
  //         }
  //       });
  //       let newinvoice = { ...invoice, productDetails };
  //       damageQty = !damageQty
  //         ? product?.DamageQty
  //           ? product?.DamageQty
  //           : product.saleQty
  //         : damageQty +
  //           (product?.DamageQty ? product?.DamageQty : product.saleQty);

  //       //console.log(invoice.productDetails, "invoice.productDetails");
  //       damageItems = !damageItems ? 1 : damageItems + 1;
  //       //console.log(damageItems, "dam");

  //       damagetotal = !damagetotal
  //         ? (invoice?.customerDetails[0]?.priceLevel[0].id == 1
  //             ? product.trade_price
  //             : invoice?.customerDetails[0]?.priceLevel[0].id == 2
  //             ? product.warehouse_price
  //             : invoice?.customerDetails[0]?.priceLevel[0].id == 4
  //             ? product.diamond
  //             : product.retail_price) *
  //           (product?.DamageQty
  //             ? Number(product?.DamageQty)
  //             : Number(product.saleQty))
  //         : damagetotal +
  //           (invoice?.customerDetails[0]?.priceLevel[0].id == 1
  //             ? product.trade_price
  //             : invoice?.customerDetails[0]?.priceLevel[0].id == 2
  //             ? product.warehouse_price
  //             : invoice?.customerDetails[0]?.priceLevel[0].id == 4
  //             ? product.diamond
  //             : product.retail_price) *
  //             (product?.DamageQty
  //               ? Number(product?.DamageQty)
  //               : Number(product.saleQty));

  //       damageCost = !damageCost
  //         ? product?.cost_price *
  //           (product?.DamageQty
  //             ? Number(product?.DamageQty)
  //             : Number(product.saleQty))
  //         : damageCost +
  //           product?.cost_price *
  //             (product?.DamageQty
  //               ? Number(product?.DamageQty)
  //               : Number(product.saleQty));

  //       const price =
  //         invoice.customerDetails[0].priceLevel[0].id === 1
  //           ? product.trade_price
  //           : invoice.customerDetails[0].priceLevel[0].id === 2
  //           ? product.warehouse_price
  //           : invoice.customerDetails[0].priceLevel[0].id === 4
  //           ? product.diamond
  //           : product.retail_price;
  //       damageDiscount = !damageDiscount
  //         ? (price - (product.discountPrice ? product.discountPrice : price)) *
  //           (product.DamageQty ? product.DamageQty : product.saleQty)
  //         : damageDiscount +
  //           (price - (product.discountPrice ? product.discountPrice : price)) *
  //             (product.DamageQty ? product.DamageQty : product.saleQty);

  //       if (invoice.vatAmount) {
  //         damageVat = !damageVat
  //           ? ((Number(damagetotal || 0) -
  //               (Number(damageDiscount || 0)
  //                 ? Number(damageDiscount || 0)
  //                 : 0)) *
  //               Number(vatRate || 0)) /
  //             100
  //           : damageVat +
  //             ((Number(damagetotal || 0) -
  //               (Number(damageDiscount || 0)
  //                 ? Number(damageDiscount || 0)
  //                 : 0)) *
  //               Number(vatRate || 0)) /
  //               100;
  //       } else {
  //         damageVat = !damageVat ? 0 : damageVat;
  //       }
  //       let calculateSpDiscountPercent =
  //         (invoice?.SDAmount / ((invoice?.total)-(invoice?.discount||0))) * 100;
  //       //console.log(invoice, "invoice");
  //       // Loop through products
  //       let calSd = invoice?.productDetails?.reduce((t, c) => {
  //         if (c._id != product._id) return t;

  //         // Pick correct price based on price level
  //         const priceLevelId = invoice.customerDetails[0].priceLevel[0].id;
  //         const price =
  //           priceLevelId === 1
  //             ? c.trade_price
  //             : priceLevelId === 2
  //             ? c.warehouse_price
  //             : priceLevelId === 4
  //             ? c.diamond
  //             : c.retail_price;

  //         // Effective qty
  //         const qty = c.DamageQty || c.saleQty;

  //         // Discount-adjusted total
  //         const total =( c.discountPrice
  //           ? (price - c.discountPrice) * qty
  //           : price * qty);
  //         // Apply special discount percent
  //         return t + (total * calculateSpDiscountPercent) / 100;
  //       }, 0);

  //       damageSubtotal =
  //         Number(damagetotal || 0) -
  //         Number(damageDiscount || 0) +
  //         Number(damageVat || 0) -
  //         Number(calSd);

  //       // if (ctc) {
  //       //   await setSelectedInvoice({
  //       //     ...selectedInvoice,
  //       //     productDetails: productDetails,
  //       //   });
  //       // }
  //       await handleOpenConfimModal2(newinvoice);
  //     }
  //   }
  // };
  const [searchIs, setSearchIs] = useState(false);
  const [highlightP, setHighlightP] = useState([]);
  const getLatestProduct = async (productId) => {
  try {
    const token = JSON.parse(sessionStorage.getItem("userData"));

    const { data } = await axios.get(
      `${Base_Uri}getProducts?id=${productId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return data?.data;
  } catch (err) {
    console.error("API error:", err);
    return null;
  }
};
  const handleChooseProducts = async(product, bool) => {
      const latest = await getLatestProduct(product._id);
      console.log(latest,"latest")
    if (selectedSearch == "imei") {
      let searchinvoice =
        invoices &&
        invoices.length > 0 &&
        invoices?.filter((e) =>
          e.productDetails?.some((j) => j.IMEI == product.IMEI)
        );

      searchinvoice = searchinvoice.map((e, i) => {
        let productDetails = e.productDetails.map(async(j, ind) => {
          if (j._id == product._id) {
            let dataToken = JSON.parse(await sessionStorage.getItem("userData"));
      let token = dataToken;
            // setHighlightP((e)=>([...e,product._id]))
            //console.log("plp");
         let dataOfProductCurrent =  await axios.get(`${Base_Uri}getProducts?id=${product._id}`,{headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },})
        console.log(dataOfProductCurrent?.data?.data,"plo")
            return {
              ...j,
              is: true,
              // selected: true,
              discountPrice: 0,
              basecurrentPrice:
                 e?.customerDetails[0].priceLevel[0].id == 1
                    ? (latest?.[0]?.trade_price||j?.trade_price)
                    : e?.customerDetails[0].priceLevel[0].id == 2
                    ? (latest?.[0]?.warehouse_price||j?.warehouse_price)
                    : e?.customerDetails[0].priceLevel[0].id == 3
                    ? (latest?.[0]?.retail_price||j?.retail_price)
                    : e?.customerDetails[0].priceLevel[0].id == 4
                    ? (latest?.[0]?.diamond||j?.diamond)
                    : (latest?.[0]?.retail_price||j?.retail_price),
              trade_price:
                e?.customerDetails[0].priceLevel[0].id == 1
                  ? Number(j?.discountPrice ? j?.discountPrice : j?.trade_price)
                  : j?.trade_price,
              warehouse_price:
                e?.customerDetails[0].priceLevel[0].id == 2
                  ? Number(
                      j?.discountPrice ? j?.discountPrice : j?.warehouse_price
                    )
                  : j?.warehouse_price,
              diamond:
                e?.customerDetails[0].priceLevel[0].id == 4
                  ? Number(j?.discountPrice ? j?.discountPrice : j?.diamond)
                  : j?.diamond,

              retail_price:
                e?.customerDetails[0].priceLevel[0].id == 3
                  ? Number(
                      j?.discountPrice ? j?.discountPrice : j?.retail_price
                    )
                  : j?.retail_price,
            };
          } else {
            return j;
          }
        });

        return {
          ...e,
          productDetails: productDetails,
        };
      });

      searchinvoice =
        searchinvoice &&
        searchinvoice.length > 0 &&
        searchinvoice.sort(
          (a, b) =>
            new Date(b.saleDate).getTime() - new Date(a.saleDate).getTime()
        );

      setSearchCustomerInvoice(searchinvoice.length > 0 ? searchinvoice : []);
      setText("");
      setSearchProducts([]);
      setSearchIs(true);
      return;
    }

    if (customerInvoice) {
      let searchinvoice =
        customerInvoice &&
        customerInvoice.length > 0 &&
        customerInvoice.filter((e, i) => {
          if (e.productDetails.some((j, ind) => j?._id == product?._id)) {
            return e;
          }
        });

      if (searchinvoice && searchinvoice.length > 0) {
        searchinvoice = searchinvoice.map((e, i) => {
          //console.log(searchinvoice, "searchinvoice");
          let productDetails = e.productDetails.map((j, ind) => {
            let foundProduct = allReturnProducts.find((i) =>
              i.productDetails?.some((c) => c._id == j._id)
            );
            let checkInReturn = foundProduct?.selected;

            //console.log(foundProduct, "foundProduct");
            if (j._id == product._id) {
              //  setHighlightP((e)=>([...e,product._id]))
              //console.log("plp");
               
              return {
                ...j,
                selected: checkInReturn,
                is: true,
                discountPrice: 0,
                basecurrentPrice:
                  e?.customerDetails[0].priceLevel[0].id == 1
                    ? (latest?.[0]?.trade_price||j?.trade_price)
                    : e?.customerDetails[0].priceLevel[0].id == 2
                    ? (latest?.[0]?.warehouse_price||j?.warehouse_price)
                    : e?.customerDetails[0].priceLevel[0].id == 3
                    ? (latest?.[0]?.retail_price||j?.retail_price)
                    : e?.customerDetails[0].priceLevel[0].id == 4
                    ? (latest?.[0]?.diamond||j?.diamond)
                    : (latest?.[0]?.retail_price||j?.retail_price),
                trade_price:
                  e?.customerDetails[0].priceLevel[0].id == 1
                    ? Number(
                        j?.discountPrice ? j?.discountPrice : j?.trade_price
                      )
                    : j?.trade_price,
                warehouse_price:
                  e?.customerDetails[0].priceLevel[0].id == 2
                    ? Number(
                        j?.discountPrice ? j?.discountPrice : j?.warehouse_price
                      )
                    : j?.warehouse_price,
                diamond:
                  e?.customerDetails[0].priceLevel[0].id == 4
                    ? Number(j?.discountPrice ? j?.discountPrice : j?.diamond)
                    : j?.diamond,
                retail_price:
                  e?.customerDetails[0].priceLevel[0].id == 3
                    ? Number(
                        j?.discountPrice ? j?.discountPrice : j?.retail_price
                      )
                    : j?.retail_price,
              };
            } else {
              return j;
            }
          });

          return {
            ...e,
            productDetails: productDetails,
          };
        });

        searchinvoice =
          searchinvoice &&
          searchinvoice.length > 0 &&
          searchinvoice.sort(
            (a, b) =>
              new Date(b.saleDate).getTime() - new Date(a.saleDate).getTime()
          );

        setSearchCustomerInvoice(searchinvoice.length > 0 ? searchinvoice : []);
        setText("");
        setSearchProducts([]);
        setSearchIs(true);
        //console.log("lkop", searchIs);
      } else {
        setSearchCustomerInvoice("");
        setSearchProducts([]);
        setText("");
        setSearchIs(false);
      }
    }
  };

  useEffect(() => {
    const func = async ()=>{
      if (
      barcodeData?.length > 0 &&
      selectedSearch?.toLowerCase() == "products"
    ) {
      textInputRef?.current?.blur();
let dataToken = JSON.parse(await sessionStorage.getItem("userData"));
      let token = dataToken;
      let product ={}
        // products &&
        // products?.length > 0 &&
        // products?.find((e) => e?.barcode == barcodeData);
 const response = await fetch(`${Base_Uri}getProducts?rawBarcode=${barcodeData}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      product = await data?.data?.[0];
      if (product) {
        handleChooseProducts(product, false);
        //console.log("product", product);
        setBarcodeRead("");
      } else {
        message.info("Not Found");
        setBarcodeRead("");
      }
    } else if (
      barcodeData?.length > 0 &&
      selectedSearch?.toLowerCase() == "invoices"
    ) {
      textInputRef?.current?.blur();

      let invoice =
        invoices &&
        invoices?.length > 0 &&
        invoices?.find((e) => e?.barcodeNumber == barcodeData);

      if (invoice) {
        handleSelectInvoice(invoice);
        setBarcodeRead("");
      } else {
        message.info("Not Found");
        setBarcodeRead("");
      }
    }
    }
    func()
  }, [barcodeData]);
  const[stateOfCalSd,setStateOfCalSd] = useState("")

  let damagetotal;
  let damageDiscount;
  let damageVat;
  let damageSubtotal;
  let damageQty;
  let damageItems;
  let damageCost;

  if (selectedInvoice && selectedInvoice.productDetails) {
    damageItems = selectedInvoice.productDetails.reduce(
      (previous, current) => previous + (current.selected ? 1 : 0),
      0
    );

    damageQty = selectedInvoice.productDetails.reduce(
      (previous, current) =>
        previous +
        (current.selected
          ? current?.DamageQty
            ? current?.DamageQty
            : current.saleQty
          : 0),
      0
    );

    damagetotal = selectedInvoice.productDetails.reduce(
      (previous, current) =>
        previous +
        (current.selected
          ? (selectedInvoice?.customerDetails[0]?.priceLevel[0].id == 1
              ? current.trade_price
              : selectedInvoice?.customerDetails[0]?.priceLevel[0].id == 2
              ? current.warehouse_price
              : selectedInvoice?.customerDetails[0]?.priceLevel[0].id == 4
              ? current.diamond
              : current.retail_price) *
            (current?.DamageQty
              ? Number(current?.DamageQty)
              : Number(current.saleQty))
          : 0),
      0
    );

    damageCost = selectedInvoice.productDetails.reduce(
      (previous, current) =>
        previous +
        (current.selected
          ? current?.cost_price *
            (current?.DamageQty
              ? Number(current?.DamageQty)
              : Number(current.saleQty))
          : 0),
      0
    );

    damageDiscount = selectedInvoice.productDetails
      ? selectedInvoice.productDetails.reduce((total, current) => {
          if (current.selected && current.discountPrice) {
            const price =
              selectedInvoice.customerDetails[0].priceLevel[0].id === 1
                ? current.trade_price
                : selectedInvoice.customerDetails[0].priceLevel[0].id === 2
                ? current.warehouse_price
                : selectedInvoice.customerDetails[0].priceLevel[0].id === 4
                ? current.diamond
                : current.retail_price;

            const discountAdjustedPrice =
              (price -
                (current.discountPrice ? current.discountPrice : price)) *
              (current.DamageQty ? current.DamageQty : current.saleQty);
            return total + discountAdjustedPrice;
          } else {
            return total;
          }
        }, 0)
      : 0;
    if (selectedInvoice.vatAmount) {
      let calculateSpDiscountPercent =
      (selectedInvoice?.SDAmount / ((selectedInvoice?.total)-(selectedInvoice?.discount||0))) * 100;
      damageVat =
        ((((damagetotal - damageDiscount)- (((damagetotal - damageDiscount) * calculateSpDiscountPercent) /
                            100) )) *
          Number(vatRate || 0)) /
        100;
    } else {
      damageVat = 0;
    }
    let calculateSpDiscountPercent =
      (selectedInvoice?.SDAmount / ((selectedInvoice?.total)-(selectedInvoice?.discount||0))) * 100;
    //console.log(selectedInvoice, "selectedInvoice");
    // Loop through products
    let calSd = selectedInvoice?.productDetails?.reduce((t, c) => {
      if (!c.selected) return t;

      // Pick correct price based on price level
      const priceLevelId = selectedInvoice.customerDetails[0].priceLevel[0].id;
      const price =
        priceLevelId === 1
          ? c.trade_price
          : priceLevelId === 2
          ? c.warehouse_price
          : priceLevelId === 4
          ? c.diamond
          : c.retail_price;

      // Effective qty
      const qty = c.DamageQty || c.saleQty;

      // Discount-adjusted total
      const total = (c.discountPrice
        ? (price - c.discountPrice) * qty
        : price * qty);
        //console.log(total,"totall")
      // Apply special discount percent
      return t + (total * calculateSpDiscountPercent) / 100;
    }, 0);
// calSd&&setStateOfCalSd(calSd||0)
//console.log(damagetotal,"klopd","damagetotal")
//console.log(damageDiscount,"klopd","damageDiscount")
//console.log(damageVat,"klopd","damageVat")
//console.log(calSd,"klopd","calSd")
    damageSubtotal =
      Number(damagetotal || 0) -
      Number(damageDiscount || 0) +
      Number(damageVat || 0) -
      Number(calSd || 0);
    // damageSubtotal = Number(damagetotal||0) - Number(damageDiscount||0) + Number(damageVat||0)-Number(selectedInvoice.SDAmount||0);
  }

  const Header = () => {
    return (
      <View fixed>
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            padding: 10,
            alignItems: "flex-start",
          }}
        >
          <View>
            {returnInvoice?.vatAmount && (
              <View>
                <View>
                  <Image
                    style={{ height: 50, borderRadius: 10 }}
                    source={{
                      uri: `${Image_Uri}companyImage/${vat?.companyLogo}`,
                    }}
                  />

                  <Text
                    style={{
                      color: "black",
                      fontSize: "14px",
                      marginTop: "10px",
                      fontFamily: "MyFont",
                      fontWeight: "bold",
                    }}
                  >
                    {vat?.nickName||vat?.companyName}
                  </Text>
                  <Text
                    style={{
                      color: "black",
                      fontSize: "10px",
                      fontFamily: "MyFont",
                      fontWeight: "normal",
                    }}
                  >
                    {vat?.companyAddress}
                  </Text>

                  <Text
                    style={{
                      color: "black",
                      fontSize: "10px",
                      fontFamily: "MyFont",
                      fontWeight: "normal",
                    }}
                  >
                    {vat?.city}
                  </Text>

                  <Text
                    style={{
                      color: "black",
                      fontSize: "10px",
                      fontFamily: "MyFont",
                      fontWeight: "normal",
                    }}
                  >
                    {vat?.postCode}
                  </Text>
                </View>
                <View>
                  <Text
                    style={{
                      color: "black",
                      fontSize: "10px",
                      marginTop: "3px",
                      fontFamily: "MyFont",
                      fontWeight: "normal",
                    }}
                  >
                    Tel: {vat?.mobileNumber}
                  </Text>
                  <Text
                    style={{
                      color: "black",
                      fontSize: "10px",
                      fontFamily: "MyFont",
                      fontWeight: "normal",
                    }}
                  >
                    Email: {vat?.companyEmail}
                  </Text>
                </View>
                <View>
                  <Text
                    style={{
                      color: "black",
                      fontSize: "10px",
                      fontFamily: "MyFont",
                      fontWeight: "normal",
                    }}
                  >
                    VAT Number: {vat?.vatNumber}
                  </Text>
                  <Text
                    style={{
                      color: "black",
                      fontSize: "10px",
                      fontFamily: "MyFont",
                      fontWeight: "normal",
                    }}
                  >
                    Company No: {vat?.companyNumber}
                  </Text>
                </View>
              </View>
            )}
          </View>

          <View>
            <View style={{ alignItems: "center" }}>
              <Image
                src={`${Image_Uri}products/${returnInvoice?.barcodeImagePath}`}
                style={{
                  height: "35px",
                  width: "150px",
                }}
              />
            </View>

            <View style={{ alignItems: "center", marginTop: "10px" }}>
              <Text
                style={{
                  color: "black",
                  fontSize: "16px",
                  fontFamily: "MyFont",
                  // marginTop:"10px",
                  fontWeight: "bold",
                  textAlign: "center",
                }}
              >
                {returnInvoice?.vatAmount ? "Invoice" : "Quotation"}
              </Text>
            </View>

            <View>
              {returnInvoice?.vatAmount && (
                <Text
                  style={{
                    color: "black",
                    fontSize: "10px",
                    fontFamily: "MyFont",
                    marginTop: "10px",
                    fontWeight: "normal",
                    textAlign: "center",
                  }}
                >
                  Invoice no: {returnInvoice?.invoiceNumber}
                </Text>
              )}

              <Text
                style={{
                  color: "black",
                  fontSize: "10px",
                  fontFamily: "MyFont",
                  // marginTop:"10px",
                  fontWeight: "normal",
                  textAlign: "center",
                }}
              >
                Date:{" "}
                {new Date(returnInvoice?.saleReturnDate).toLocaleDateString(
                  "en-GB",
                  {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                  }
                )}
              </Text>

              <Text
                style={{
                  color: "black",
                  fontSize: "10px",
                  fontFamily: "MyFont",
                  fontWeight: "normal",
                  textAlign: "center",
                }}
              >
                Time:{" "}
                {new Date(returnInvoice?.saleReturnDate).toLocaleTimeString()}
              </Text>

              {(returnInvoice?.saleReturnDate || returnInvoice?.exchangeDate) &&
                returnInvoice?.vatAmount && (
                  <View style={{ marginTop: "10px" }}>
                    {returnInvoice?.vatAmount && (
                      <Text
                        style={{
                          color: "black",
                          fontSize: "10px",
                          fontFamily: "MyFont",
                          // marginTop:"10px",
                          fontWeight: "normal",
                          textAlign: "center",
                        }}
                      >
                        Return Inv Ref.:
                        {returnInvoice?.returnInvoiceRef?.map((e, i) => {
                          return (
                            <Text
                              style={{
                                color: "black",
                                fontSize: "8px",
                                fontFamily: "MyFont",
                                // marginTop:"10px",
                                fontWeight: "normal",
                                textAlign: "center",
                              }}
                            >
                              {e},
                            </Text>
                          );
                        })}
                      </Text>
                    )}
                  </View>
                )}

              <View style={{ marginTop: "10px" }}>
                <Text
                  style={{
                    color: "black",
                    fontSize: "12px",
                    fontFamily: "MyFont",
                    // marginTop:"10px",
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  {returnInvoice?.paymentMethod &&
                    (typeof returnInvoice?.paymentMethod == "object"
                      ? returnInvoice?.paymentMethod
                          .map((e) =>
                            e?.toLowerCase() == "cash"
                              ? "C"
                              : e?.toLowerCase() == "card"
                              ? "CA"
                              : e?.toLowerCase() == "on account"
                              ? "A"
                              : e?.toLowerCase() == "online"
                              ? "B"
                              : e?.toUpperCase()
                          )
                          ?.join(", ")
                      : returnInvoice?.paymentMethod)}
                </Text>

                <Text
                  style={{
                    color: "black",
                    fontSize: "10px",
                    fontFamily: "MyFont",
                    // marginTop:"10px",
                    fontWeight: "normal",
                    textAlign: "center",
                  }}
                >
                  Account No: {selectedCustomer?.accountNo}
                </Text>

                {returnInvoice?.vatAmount && (
                  <Text
                    style={{
                      color: "black",
                      fontSize: "10px",
                      fontFamily: "MyFont",
                      // marginTop:"10px",
                      fontWeight: "normal",
                      textAlign: "center",
                    }}
                  >
                    Business Name: {selectedCustomer?.businessName}
                  </Text>
                )}

                {returnInvoice?.vatAmount && (
                  <Text
                    style={{
                      color: "black",
                      fontSize: "10px",
                      fontFamily: "MyFont",
                      // marginTop:"10px",
                      fontWeight: "normal",
                      textAlign: "center",
                    }}
                  >
                    Email: {selectedCustomer?.email}
                  </Text>
                )}

                {returnInvoice?.vatAmount && (
                  <Text
                    style={{
                      color: "black",
                      fontSize: "10px",
                      fontFamily: "MyFont",
                      marginTop: "10px",
                      fontWeight: "normal",
                      textAlign: "center",
                    }}
                  >
                    Payment Method:{" "}
                    {Array?.isArray(returnInvoice?.paymentMethod)
                      ? returnInvoice?.paymentMethod?.map((e, i) => e).join(",")
                      : returnInvoice?.paymentMethod}
                  </Text>
                )}

                {returnInvoice?.vatAmount && (
                  <Text
                    style={{
                      color: "black",
                      fontSize: "10px",
                      fontFamily: "MyFont",
                      marginTop: "10px",
                      fontWeight: "normal",
                      textAlign: "center",
                    }}
                  >
                    Status: {returnInvoice?.status}
                  </Text>
                )}

                {/* {returnInvoice?.creditDays && (
                                    <Text
                                        style={{
                                            color: "black",
                                            fontSize: "10px",
                                            fontFamily: "MyFont",
                                            marginTop: "10px",
                                            fontWeight: "normal",
                                            textAlign: "center",
                                        }}
                                    >
                                        Credit Days: {returnInvoice?.creditDays}
                                    </Text>
                                )} */}

                {/* {returnInvoice?.referenceId && (
                                    <Text
                                        style={{
                                            color: "black",
                                            fontSize: "10px",
                                            fontFamily: "MyFont",
                                            // marginTop: "10px",
                                            fontWeight: "normal",
                                            textAlign: "center",
                                        }}
                                    >
                                        Reference Id: {returnInvoice?.referenceId}
                                    </Text>
                                )} */}

                {returnInvoice?.vatAmount && returnInvoice?.transactionId && (
                  <Text
                    style={{
                      color: "black",
                      fontSize: "10px",
                      fontFamily: "MyFont",
                      // marginTop: "10px",
                      fontWeight: "normal",
                      textAlign: "center",
                    }}
                  >
                    Transaction Id: {returnInvoice?.transactionId}
                  </Text>
                )}

                {returnInvoice?.vatAmount &&
                  Array?.isArray(returnInvoice?.paymentMethod) &&
                  returnInvoice?.paymentMethod?.some(
                    (e) => typeof e == "string" && e?.toLowerCase() == "cheque"
                  ) && (
                    <View>
                      <Text
                        style={{
                          color: "black",
                          fontSize: "10px",
                          fontFamily: "MyFont",
                          // marginTop:"10px",
                          fontWeight: "normal",
                          textAlign: "center",
                        }}
                      >
                        Cheque No: {returnInvoice?.cheque_no}
                      </Text>

                      <Text
                        style={{
                          color: "black",
                          fontSize: "10px",
                          fontFamily: "MyFont",
                          // marginTop:"10px",
                          fontWeight: "normal",
                          textAlign: "center",
                        }}
                      >
                        Bank Name: {returnInvoice?.bank_name}
                      </Text>

                      <Text
                        style={{
                          color: "black",
                          fontSize: "10px",
                          fontFamily: "MyFont",
                          // marginTop:"10px",
                          fontWeight: "normal",
                          textAlign: "center",
                        }}
                      >
                        Cheque Date:{" "}
                        {new Date(returnInvoice.clear_date).toLocaleDateString(
                          "en-GB",
                          {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                          }
                        )}
                      </Text>
                    </View>
                  )}
              </View>
            </View>
          </View>
        </View>

        <View
          style={{
            flexDirection: "row",
            borderBottomWidth: 1,
            borderColor: "#000",
            paddingBottom: 5,
            paddingTop: 5,
            border: "1px solid black",
            backgroundColor: "gray",
            alignItems: "center",
            padding: 10,
            marginTop: "20px",
          }}
        >
          <View style={{ flex: 0.5 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Item
            </Text>
          </View>

          <View style={{ flex: 1.5 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Barcode
            </Text>
          </View>

          <View style={{ flex: selectedCustomer?.showDiscount ? 4 : 5 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Product Description
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Qty
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Price
            </Text>
          </View>
          {selectedCustomer?.showDiscount && (
            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontFamily: "MyFont",
                  fontSize: 8,
                  fontWeight: "bold",
                }}
              >
                Disc
              </Text>
            </View>
          )}
          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Amount
            </Text>
          </View>
        </View>
      </View>
    );
  };

  const MyDocument = () => (
    <Document size="A4">
      {/* <Header /> */}

      <Page style={{ padding: "0px 10px" }}>
        <Header />
        {/* Data Rows */}
        <View>
          {returnInvoice &&
            returnInvoice?.productDetails &&
            returnInvoice?.productDetails?.length > 0 &&
            returnInvoice?.productDetails?.map((item, index) => (
              <View
                key={index}
                style={{
                  flexDirection: "row",
                  borderBottomWidth: 1,
                  borderColor: "#000",
                  borderLeftWidth: 1,
                  borderRightWidth: 1,
                  padding: "3px 10px",
                }}
              >
                <View style={{ flex: 0.5 }}>
                  <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>-1</Text>
                </View>

                <View style={{ flex: 1.5 }}>
                  <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                    {item.barcode}
                  </Text>
                </View>

                <View style={{ flex: selectedCustomer?.showDiscount ? 4 : 5 }}>
                  <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                    {item.productName}
                  </Text>
                  {item?.productDetails &&
                    item?.productDetails?.length > 0 &&
                    item?.productDetails?.map((e, i) => {
                      return (
                        <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                          {e?.IMEI}
                        </Text>
                      );
                    })}
                </View>

                <View style={{ flex: 1 }}>
                  <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                    -{item?.DamageQty ? item?.DamageQty : item?.saleQty}
                  </Text>
                </View>

                <View style={{ flex: 1 }}>
                  <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                    £ -
                    {returnInvoice?.customerDetails[0]?.priceLevel[0]?.id == 1
                      ? Number(item.trade_price).toFixed(2)
                      : returnInvoice?.customerDetails[0]?.priceLevel[0]?.id ==
                        2
                      ? Number(item.warehouse_price).toFixed(2)
                      : returnInvoice?.customerDetails[0]?.priceLevel[0]?.id ==
                        4
                      ? Number(item.diamond).toFixed(2)
                      : Number(item.retail_price).toFixed(2)}
                  </Text>
                </View>

                {selectedCustomer?.showDiscount && (
                  <View style={{ flex: 1 }}>
                    <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                      £
                      {item.discountPrice
                        ? Number(
                            (returnInvoice?.customerDetails[0]?.priceLevel[0]
                              ?.id == 1
                              ? item.trade_price
                              : returnInvoice?.customerDetails[0]?.priceLevel[0]
                                  ?.id == 2
                              ? item.warehouse_price
                              : returnInvoice?.customerDetails[0]?.priceLevel[0]
                                  ?.id == 4
                              ? item.diamond
                              : item.retail_price) - item.discountPrice
                          ).toFixed(2)
                        : 0}
                    </Text>
                  </View>
                )}

                <View style={{ flex: 1 }}>
                  <Text
                    style={{
                      fontFamily: "MyFont",
                      fontSize: 8,
                      color: "black",
                      fontWeight: "bold",
                    }}
                  >
                    £ -
                    {item.discountPrice
                      ? Number(
                          item.discountPrice *
                            (item?.DamageQty ? item?.DamageQty : item.saleQty)
                        ).toFixed(2)
                      : Number(
                          (returnInvoice?.customerDetails[0]?.priceLevel[0]
                            ?.id == 1
                            ? item.trade_price
                            : returnInvoice?.customerDetails[0]?.priceLevel[0]
                                ?.id == 2
                            ? item.warehouse_price
                            : returnInvoice?.customerDetails[0]?.priceLevel[0]
                                ?.id == 4
                            ? item.diamond
                            : item.retail_price) *
                            (item?.DamageQty ? item?.DamageQty : item.saleQty)
                        ).toFixed(2)}
                  </Text>
                </View>
              </View>
            ))}

          <View
            // key={index}
            style={{
              flexDirection: "row",
              // borderWidth: 1,
              borderColor: "#000",
              padding: "5px 10px",
              borderLeftWidth: 1,
              borderRightWidth: 1,
            }}
          >
            <View style={{ flex: 0.5 }}>
              <Text
                style={{
                  fontFamily: "MyFont",
                  fontSize: 10,
                  fontWeight: "bold",
                }}
              >
                -{returnInvoice?.totalItems}
              </Text>
            </View>

            <View
              style={{
                flex: selectedCustomer?.showDiscount ? 5.5 : 6.5,
                alignItems: "center",
              }}
            >
              <Text
                style={{
                  fontFamily: "MyFont",
                  fontSize: 10,

                  fontWeight: "bold",
                }}
              >
                Subtotal
              </Text>
            </View>

            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontFamily: "MyFont",
                  fontSize: 10,
                  fontWeight: "bold",
                }}
              >
                -{returnInvoice?.totalQty}
              </Text>
            </View>

            <View style={{ flex: 1 }}>price</View>

            {selectedCustomer?.showDiscount && (
              <View style={{ flex: 1 }}>
                <Text
                  style={{
                    fontFamily: "MyFont",
                    fontSize: 10,
                    fontWeight: "bold",
                  }}
                >
                  £{Number(returnInvoice?.discount).toFixed(2)}
                </Text>
              </View>
            )}

            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontFamily: "MyFont",
                  fontSize: 10,
                  fontWeight: "bold",
                }}
              >
                £-
                {Number(returnInvoice?.total - returnInvoice?.discount).toFixed(
                  2
                )}
              </Text>
            </View>
          </View>

          {returnInvoice?.SDAmount && (
                      <View
                        // key={index}
                        style={{
                          flexDirection: "row",
                          // borderWidth: 1,
                          borderLeftWidth: 1,
                          borderRightWidth: 1,
                          borderColor: "#000",
                          borderTopWidth: 1,
                          padding: "5px 10px",
                        }}
                      >
                        <View style={{ flex: 9, alignItems: "center" }}>
                          <Text
                            style={{
                              fontFamily: "MyFont",
                              fontSize: 10,
                              fontWeight: "bold",
                            }}
                          >
                            Special Discount  {(
                              (returnInvoice?.SDAmount /
                                (returnInvoice?.total -
                                  (returnInvoice?.discount || 0))) *
                              100
                            ).toFixed(2)}
                            %
                          </Text>
                        </View>
          
                        <View style={{ flex: 1 }}>
                          <Text
                            style={{
                              fontFamily: "MyFont",
                              fontSize: 10,
                              fontWeight: "bold",
                            }}
                          >
                            - £
                            {Number(returnInvoice?.SDAmount).toFixed(2)}
                            {/* - £{Number(printInvoiceData?.SDAmount).toFixed(2)} */}
                          </Text>
                        </View>
                      </View>
                    )}

                     {returnInvoice?.SDAmount && (
                      <View
                        // key={index}
                        style={{
                          flexDirection: "row",
                          // borderWidth: 1,
                          borderLeftWidth: 1,
                          borderRightWidth: 1,
                          borderColor: "#000",
                          borderTopWidth: 1,
                          padding: "5px 10px",
                        }}
                      >
                        <View style={{ flex: 9, alignItems: "center" }}>
                          <Text
                            style={{
                              fontFamily: "MyFont",
                              fontSize: 10,
                              fontWeight: "bold",
                            }}
                          >
                            Subtotal
                          </Text>
                        </View>
          
                        <View style={{ flex: 1 }}>
                          <Text
                            style={{
                              fontFamily: "MyFont",
                              fontSize: 10,
                              fontWeight: "bold",
                            }}
                          >
                            - £
                            {(Number((returnInvoice?.total||0) - (returnInvoice?.discount||0))-Number(returnInvoice?.SDAmount||0)).toFixed(2)}
                            {/* {Number(returnInvoice?.SDAmount).toFixed(2)} */}
                            {/* - £{Number(printInvoiceData?.SDAmount).toFixed(2)} */}
                          </Text>
                        </View>
                      </View>
                    )}

          {returnInvoice?.vatAmount && (
            <View
              // key={index}
              style={{
                flexDirection: "row",
                // borderWidth: 1,
                borderLeftWidth: 1,
                borderRightWidth: 1,
                borderColor: "#000",
                borderTopWidth: 1,
                padding: "5px 10px",
              }}
            >
              <View style={{ flex: 9, alignItems: "center" }}>
                <Text
                  style={{
                    fontFamily: "MyFont",
                    fontSize: 10,
                    fontWeight: "bold",
                  }}
                >
                  Vat
                </Text>
              </View>

              <View style={{ flex: 1 }}>
                <Text
                  style={{
                    fontFamily: "MyFont",
                    fontSize: 10,

                    fontWeight: "bold",
                  }}
                >
                  £ -{Number(returnInvoice?.vatAmount).toFixed(2)}
                </Text>
              </View>
            </View>
          )}

          

          <View
            // key={index}
            style={{
              flexDirection: "row",
              // borderWidth: 1,
              borderColor: "#000",
              borderWidth: 1,
              padding: "5px 10px",
              // borderBottomWidth:1,
              backgroundColor: "#DDD",
              opacity: 0.7,
            }}
          >
            <View style={{ flex: 9, alignItems: "center" }}>
              <Text
                style={{
                  fontFamily: "MyFont",
                  fontSize: 10,
                  color: "red",
                  fontWeight: "bold",
                }}
              >
                Total
              </Text>
            </View>

            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontFamily: "MyFont",
                  fontSize: 10,
                  color: "red",
                  fontWeight: "bold",
                }}
              >
                £ -{Number(returnInvoice?.subtotal).toFixed(2)}
              </Text>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
  const [customerLedger, setCustomerLedger] = useState([]);

  useEffect(() => {
    if (selectedCustomer) {
      //console.log("hello");
      let ledger = [];
      let previousBalance = 0;
      let id = selectedCustomer.id;
      axios
        .get(`${Base_Uri}getCustomerLedger/${id}`)
        .then((res) => {
          let data = res.data;

          if (!data?.status) {
            message.info(data.message);
            return;
          }

          if (data?.status) {
            let myData = data?.data;
            let customerData = data?.customerData;

            if (!myData || myData?.length == 0) {
              message.info("No Data Found");
              return;
            }

            ledger = myData.map((entry) => {
              let refund =
                entry.refund &&
                entry?.paymentMethod[0]?.toLowerCase() == "onaccount"
                  ? entry.refund
                  : 0;
              let creditNote =
                entry.deductCredit &&
                entry?.paymentMethod[0]?.toLowerCase() == "credit note"
                  ? entry.deductCredit
                  : 0;

              const currentRunningBalance =
                previousBalance +
                Number(entry.transactionType == "Opening Balance"?(entry?.openingquotationBalance+entry?.openinginvoiceBalance)||0:(entry?.paymentMethod?.includes("cheque")||entry?.paymentMethod=="cheque")?entry.toPay:entry.toPay || 0) -
                Number(refund) -
                Number(creditNote) -
                (((entry.transactionType == "Paid on invoice" ||
                  entry.transactionType == "Paid on quotation") &&
                  Number(entry?.deductCredit || 0)) ||
                  0) -(entry.transactionType=="cheque clearing"?Number(entry.deductCredit):0)-
                Number(entry?.additionalDiscount || 0);

              previousBalance = currentRunningBalance;

              return {
                ...entry,
                runningBalance: Number(currentRunningBalance).toFixed(2),
                customerDetails: customerData,
              };
            });

            //console.log(ledger, "l");

            setCustomerLedger(ledger);
          }
        })
        .catch((error) => {
          message.info(error?.message);
        });
    }
  }, [selectedCustomer]);
  //console.log(allReturnProducts,"allReturnProducts")
  const handleGenerateNewInvoice = async () => {
    if (allReturnProducts && allReturnProducts?.length > 0) {
      if (
        !refundCash?.selected &&
        !deductCreditBalance?.selected &&
        !refundCard?.selected
      ) {
        message.info("Kindly Select Payment Option");
        return;
      }


      if (
        deductCreditBalance?.selected &&
        (!selectedDeductBalanceOption ||
          selectedDeductBalanceOption == "select")
      ) {
        message.info("Kindly enter credit deduct option");
        return;
      }

      let allProducts = allReturnProducts?.flatMap((e) => {
        return e?.productDetails || [];
      });

      let customerDetails = allReturnProducts[0]?.customerDetails;

      let returnInvoiceRef = allReturnProducts?.map((e) => {
        return e?.returnInvoiceRef;
      });

      let returnInvoiceDate = allReturnProducts?.map((e) => {
        return e?.invoiceRefDate;
      });

      let total = Number(
        allReturnProducts?.reduce((pre, curr) => {
          return (pre || 0) + (Number(curr?.total) || 0);
        }, 0)
      ).toFixed(2);

      let subtotal = allReturnProducts?.reduce((pre, curr) => {
        return (pre || 0) + (Number(curr?.subtotal) || 0);
      }, 0);

      let discount = allReturnProducts?.reduce((pre, curr) => {
        return (pre || 0) + (Number(curr?.discount) || 0);
      }, 0);

      let totalItems = allReturnProducts?.reduce((pre, curr) => {
        return (pre || 0) + (Number(curr?.totalItems) || 0);
      }, 0);

      let totalQty = allReturnProducts?.reduce((pre, curr) => {
        return (pre || 0) + (Number(curr?.totalQty) || 0);
      }, 0);

      let vatAmount = allReturnProducts?.reduce((pre, curr) => {
        return (pre || 0) + (Number(curr?.vatAmount) || 0);
      }, 0);
      let SDAmount = allReturnProducts?.reduce((pre, curr) => {
        return (pre || 0) + (Number(curr?.SDAmount) || 0);
      }, 0);

      let totalCost = allProducts?.reduce((pre, curr) => {
        return (
          (pre || 0) +
          (Number(curr?.cost_price) *
            (curr?.DamageQty
              ? Number(curr?.DamageQty)
              : Number(curr?.saleQty)) || 0)
        );
      }, 0);

      // ( (((damagetotal+(selectedInvoice?.vatAmount||0))) * ((selectedInvoice?.SDAmount / ((selectedInvoice?.total+(selectedInvoice?.vatAmount||0))-(selectedInvoice?.discount||0))) * 100)) / 100)

      let dataToSend = {
        productDetails: allProducts,
        customerDetails: customerDetails,
        total: total,
        discount: discount,
        subtotal: subtotal,
        totalItems: totalItems,
        totalQty: totalQty,
        vatAmount: vatAmount,
        SDAmount: SDAmount,
        costPrice: totalCost,
        customerName: customerDetails?.customerName,
        saleReturnDate: new Date(),
        status: "Return",
        deductCash: refundCash?.selected,
        deductCreditBalance: deductCreditBalance.selected,
        deductCreditOption: selectedDeductBalanceOption,
        returnInvoiceRef: returnInvoiceRef,
        invoiceRefDate: returnInvoiceDate,
        paymentMethod: deductCreditBalance?.selected
          ? "Credit Note"
          : refundCash?.selected
          ? "refund cash"
          : "refund card",
        vatNumber: vatAmount ? vat?.vatNumber : "",
        companyNumber: vatAmount ? vat?.companyNumber : "",
        employeeDetails: userData,
        employeeId: userData?.id,
      };

      //console.log(dataToSend, "dataToSend");

      setLoading(true);

      let data = await sessionStorage.getItem("userData");
      data = JSON.parse(data);
      let token = data;

      axios
        .post(`${Base_Uri}SaleReturnDamage`, dataToSend, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // Include other headers as needed
          },
        })
        .then((res) => {
          let data = res.data;
          if (data.status) {
            setLoading(false);

            let allData = data?.data;

            setReturnInvoice(allData);
            // getProducts();
            getCustomers();
            getTodayReturnInvoices();
            dispatch(updateAllReturnProducts([]));
            setSuccessfulTransactionModal(true);
          }
        })
        .catch((error) => {
          setLoading(false);
        });
    }
  };

  const handleGoForExchange = async () => {
    if (allReturnProducts && allReturnProducts?.length > 0) {
      let allProducts = allReturnProducts?.flatMap((e) => {
        return e?.productDetails || [];
      });

      let customerDetails = allReturnProducts[0]?.customerDetails;

      let returnInvoiceRef = allReturnProducts?.map((e) => {
        return e?.returnInvoiceRef;
      });

      let returnInvoiceDate = allReturnProducts?.map((e) => {
        return e?.invoiceRefDate;
      });

      let total = Number(
        allReturnProducts?.reduce((pre, curr) => {
          return (pre || 0) + (Number(curr?.total) || 0);
        }, 0)
      ).toFixed(2);

      let subtotal = allReturnProducts?.reduce((pre, curr) => {
        return (pre || 0) + (Number(curr?.subtotal) || 0);
      }, 0);

      let discount = allReturnProducts?.reduce((pre, curr) => {
        return (pre || 0) + (Number(curr?.discount) || 0);
      }, 0);

      let totalItems = allReturnProducts?.reduce((pre, curr) => {
        return (pre || 0) + (Number(curr?.totalItems) || 0);
      }, 0);

      let totalQty = allReturnProducts?.reduce((pre, curr) => {
        return (pre || 0) + (Number(curr?.totalQty) || 0);
      }, 0);

      let vatAmount = allReturnProducts?.reduce((pre, curr) => {
        return (pre || 0) + (Number(curr?.vatAmount) || 0);
      }, 0);
      let SDAmount = allReturnProducts?.reduce((pre, curr) => {
        return (pre || 0) + (Number(curr?.SDAmount) || 0);
      }, 0);
      let SDAmountTotal = allReturnProducts?.reduce((pre, curr) => {
        return (pre || 0) + (Number(curr?.SDAmount)?curr?.total:0 );
      }, 0);

      //console.log(SDAmountTotal,"SDAmountTotal")
      //console.log(allReturnProducts,"allReturnProducts:SDAmountTotal")

      let totalCost = allProducts?.reduce((pre, curr) => {
        return (
          (pre || 0) +
          (Number(curr?.cost_price) *
            (curr?.DamageQty
              ? Number(curr?.DamageQty)
              : Number(curr?.saleQty)) || 0)
        );
      }, 0);

      let dataToSend = {
        productDetails: allProducts,
        customerDetails: customerDetails,
        total: Number(total),
        discount: discount,
        subtotal: subtotal,
        totalItems: totalItems,
        totalQty: totalQty,
        vatAmount: vatAmount,
        SDAmount: SDAmount,
        sdPer:SDAmount?((SDAmount/SDAmountTotal)*100):0,
        costPrice: totalCost,
        customerName: customerDetails?.customerName,
        saleReturnDate: new Date(),
        status: "Return",
        returnInvoiceRef: [
          ...new Set(returnInvoiceRef.flat(Infinity).map(String)),
        ],
        invoiceRefDate: returnInvoiceDate,
        paymentMethod: deductCreditBalance?.selected
          ? "deduct credit"
          : "refund cash",
        vatNumber: vatAmount ? vat?.vatNumber : "",
        companyNumber: vatAmount ? vat?.companyNumber : "",
        employeeDetails: userData,
        employeeId: userData?.id,
      };

      //console.log(dataToSend, "dataToSend");

      dispatch(updateAllReturnProductsDuplicate(allReturnProducts));
      dispatch(updateExhangeProducts(dataToSend));
      cancelModal();
    }
  };

  // function printAndClose() {
  //     // Open a new tab for printing
  //     var printWindow = window.open("Invoice", "_blank");

  //     // Add your content to the new tab (you can replace this with your actual content)
  //     printWindow.document.write(
  //         `<!DOCTYPE html>
  //       <html lang="en">
  //         <head>
  //           <meta charset="UTF-8" />
  //           <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  //           <title>Sale Return Invoice</title>
  //         </head>
  //         <body>
  //         <div
  //         class="container"
  //         style="

  //           display: flex;
  //           justify-content: ${returnInvoice.vatAmount ? `space-between` : `flex-end`
  //         }; /* Changed to space-between */
  //           flex-direction: row; /* Changed to row */
  //           margin-right: 10px;
  //           margin-left:10px;
  //           /* Added margin to the right */
  //         "
  //     >
  //         <!-- Left side details -->

  //         ${returnInvoice?.vatAmount
  //             ? `
  //           <div>
  //             <h1>${vat?.nickName||vat?.companyName}</h1>
  //             <p>${vat?.companyAddress}
  //             </p>

  //             <div>
  //             <p>Tel: ${vat?.mobileNumber} </br>
  //             Email: ${vat?.companyEmail}
  //             </p>

  //           </div>

  //             ${returnInvoice?.vatAmount &&
  //             `<div >
  //                 ${vat?.vatNumber
  //                 ? `<p>Vat Number: ${vat?.vatNumber}
  //                     </br>
  //                     Company Number: ${vat?.companyNumber}
  //                     </p>`
  //                 : ""
  //             }

  //               </div>`
  //             }

  //           </div>

  //           `
  //             : ""
  //         }

  //         <!-- Right side details -->
  //         <div style="text-align: right;">

  //             <div>

  //             <img style="height:35px;" src="${Image_Uri}products/${returnInvoice?.barcodeImagePath
  //         }" />

  //                 <p style="font-size: 32px; font-weight: bold; margin-bottom: 5px;margin-top:0px">
  //                     ${returnInvoice?.vatAmount
  //             ? "Return Invoice"
  //             : "Return Quotation"
  //         }
  //                 </p>
  //                 <div style="margin-bottom: 5px;">
  //                     ${returnInvoice?.vatAmount
  //             ? `<p>Return Invoice #: ${returnInvoice?.invoiceNumber}</br>`
  //             : ""
  //         }
  //                     Return Date: ${new Date(
  //             returnInvoice.saleReturnDate
  //         ).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' })}</br>
  //                     Return Time: ${new Date(
  //             returnInvoice.saleReturnDate
  //         ).toLocaleTimeString()}</p>
  //                 </div>

  //                 ${returnInvoice.saleReturnDate
  //             ? returnInvoice.vatAmount
  //                 ? `<p>Invoice Ref #: ${returnInvoice?.returnInvoiceRef
  //                 }<br>
  //                            Invoice Ref Date: ${new Date(
  //                     returnInvoice.invoiceRefDate
  //                 ).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' })}<br>
  //                            Invoice Ref Time: ${new Date(
  //                     returnInvoice.invoiceRefDate
  //                 ).toLocaleTimeString()}</p>`
  //                 : `Invoice Ref Date: ${new Date(
  //                     returnInvoice.invoiceRefDate
  //                 ).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' })}<br>
  //                         Invoice Ref Time: ${new Date(
  //                     returnInvoice.invoiceRefDate
  //                 ).toLocaleTimeString()}</p>`
  //             : ""
  //         }

  //                 <p style="margin-bottom: 5px; font-weight: bold; font-size: 16px;">
  //                 Bill to:
  //             <br/>
  //             Account Number: ${selectedCustomer?.accountNo}<br/>
  //               ${returnInvoice?.vatAmount
  //             ? `Business Name: ${selectedCustomer?.businessName}<br/>`
  //             : ""
  //         }
  //               ${returnInvoice?.vatAmount
  //             ? `Customer Email: ${selectedCustomer?.email}<br/>`
  //             : ""
  //         }
  //               </p>

  //                   ${returnInvoice?.vatAmount
  //             ? `Payment Method: ${Array.isArray(returnInvoice?.paymentMethod) ? returnInvoice?.paymentMethod?.map((e, i) => e) : returnInvoice?.paymentMethod}`
  //             : ""
  //         }

  //             </div>

  //             ${returnInvoice.status
  //             ? `<p>Status: ${returnInvoice.status}</p>`
  //             : ""
  //         }

  //             ${returnInvoice.referenceId
  //             ? `<p>Reference Id: ${returnInvoice.referenceId}</p>`
  //             : ""
  //         }
  //             ${returnInvoice.transactionId
  //             ? `<p>Transaction Id: ${returnInvoice.transactionId}</p>`
  //             : ""
  //         }
  //             ${Array.isArray(returnInvoice?.paymentMethod) ? returnInvoice?.paymentMethod?.map((e, i) => e?.toLowerCase() == "cheque") : returnInvoice?.paymentMethod.toLowerCase() == "cheque"
  //             ? `<p>Cheque No: ${returnInvoice.cheque_no}</br>
  //                   Bank Name: ${returnInvoice.bank_name}</br>
  //                   Cheque Date: ${new Date(
  //                 returnInvoice.clear_date
  //             ).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' })}</p>
  //                   `
  //             : ""
  //         }
  //         </div>
  //     </div>
  //             </div>
  //             <div style="display:flex;justify-content:center" >
  //             <table style="margin-top:10px;border-collapse: collapse;" >
  //               <thead style="background-color:lightGray;" >
  //                 <tr style="background-color:lightGray;" >

  //                 <th
  //                 style="
  //                   font-size: 16px;
  //                   font-weight: bold;
  //                   margin:0px;
  //                   font-family: Arial, Helvetica, sans-serif;
  //                   border: 1px solid black;
  //                   margin-bottom: 10px;
  //                   "
  //               >
  //                 Item
  //               </th>

  //                 <th
  //                 style="
  //                   font-size: 16px;
  //                   font-weight: bold;
  //                   margin:0px;
  //                   font-family: Arial, Helvetica, sans-serif;
  //                   border: 1px solid black;
  //                   margin-bottom: 10px;
  //                   "
  //               >
  //                 Barcode
  //               </th>

  //                 <th
  //                     colspan="2"
  //                     style="
  //                       font-size: 16px;
  //                       font-weight: bold;
  //                       margin:0px;
  //                       font-family: Arial, Helvetica, sans-serif;
  //                       border: 1px solid black;
  //                       margin-bottom: 10px;
  //                     "
  //                   >
  //                     Description
  //                   </th>

  //                   <th
  //                     style="
  //                       font-size: 16px;
  //                       font-weight: bold;
  //                       margin:0px;
  //                       font-family: Arial, Helvetica, sans-serif;
  //                       border: 1px solid black;
  //                       margin-bottom: 10px;
  //                     "
  //                   >
  //                     Quantity
  //                   </th>

  //                   <th
  //                     style="
  //                       font-size: 16px;
  //                       font-weight: bold;
  //                       margin:0px;
  //                       font-family: Arial, Helvetica, sans-serif;
  //                       border: 1px solid black;
  //                       margin-bottom: 10px;
  //                     "
  //                   >
  //                     Price
  //                   </th>

  //                   <th
  //                     style="
  //                       font-size: 16px;
  //                       font-weight: bold;
  //                       font-family: Arial, Helvetica, sans-serif;
  //                       border: 1px solid black;
  //                       margin-bottom: 10px;
  //                     "
  //                   >
  //                     Discount
  //                   </th>
  //                   <th
  //                     style="
  //                       font-size: 16px;
  //                       font-weight: bold;
  //                       margin:0px;
  //                       font-family: Arial, Helvetica, sans-serif;
  //                       border: 1px solid black;
  //                       margin-bottom: 10px;
  //                     "
  //                   >
  //                     Amount
  //                   </th>
  //                 </tr>
  //               </thead>

  //               ${returnInvoice.productDetails &&
  //         returnInvoice.productDetails.length > 0 &&
  //         returnInvoice.productDetails.map(
  //             (e, i) =>
  //                 `<tbody>
  //                 <tr>

  //                 <td
  //                 style="
  //                   font-size: 16px;
  //                   border-top: 0px solid black;
  //                   border-right: 1px solid black;
  //                   border-left: 1px solid black;
  //                   border-bottom:0px;
  //                   width:100px;
  //                   font-family: Arial, Helvetica, sans-serif;

  //                 "
  //               >
  //                 -1
  //               </td>

  //                 <td
  //                 style="
  //                   font-size: 16px;
  //                   border-top: 0px solid black;
  //                   border-right: 1px solid black;
  //                   border-left: 1px solid black;
  //                   border-bottom:0px;
  //                   width:150px;
  //                   font-family: Arial, Helvetica, sans-serif;
  //                   "
  //               >
  //                 ${e.barcode}
  //               </td>
  //                 <td
  //                     colspan="2"
  //                     style="
  //                       font-size: 16px;
  //                       border-top: 0px solid black;
  //                       border-right: 1px solid black;
  //                       border-left: 1px solid black;
  //                       border-bottom:0px;
  //                       width:250px;
  //                       font-family: Arial, Helvetica, sans-serif;

  //                     "
  //                   >
  //                     ${e.productName}
  //                   </td>

  //                   <td
  //                     style="
  //                       font-size: 16px;
  //                       border-top: 0px solid black;
  //                       border-right: 1px solid black;
  //                       border-left: 1px solid black;
  //                       border-bottom:0px;
  //                       width:100px;
  //                       font-family: Arial, Helvetica, sans-serif;

  //                     "
  //                   >
  //                     -${e.saleQty}
  //                   </td>

  //                   <td
  //                     style="
  //                       font-size: 16px;
  //                       border-top: 0px solid black;
  //                       border-right: 1px solid black;
  //                       border-left: 1px solid black;
  //                       border-bottom:0px;
  //                       width:100px;
  //                       font-family: Arial, Helvetica, sans-serif;

  //                     "
  //                   >
  //                   £-${returnInvoice?.customerDetails[0]?.priceLevel[0]?.id == 1
  //                     ? e.trade_price
  //                     : returnInvoice?.customerDetails[0]?.priceLevel[0]?.id ==
  //                         2
  //                         ? e.warehouse_price
  //                         : e.retail_price
  //                 }
  //                   </td>

  //                   <td
  //                     style="

  //                     border-top: 0px solid black;
  //                     border-right: 1px solid black;
  //                     border-left: 1px solid black;
  //                     border-bottom:0px;
  //                     width:100px;
  //                     font-size: 16px;
  //                     font-family: Arial, Helvetica, sans-serif;

  //                     "
  //                   >
  //                   £${e.discountPrice
  //                     ? (returnInvoice?.customerDetails[0]?.priceLevel[0]?.id ==
  //                         1
  //                         ? e.trade_price
  //                         : returnInvoice?.customerDetails[0]?.priceLevel[0]
  //                             ?.id == 2
  //                             ? e.warehouse_price
  //                             : e.retail_price) - e.discountPrice
  //                     : 0
  //                 }
  //                   </td>

  //                   <td
  //                     style="

  //                     border-top: 0px solid black;
  //                     border-right: 1px solid black;
  //                     border-left: 1px solid black;
  //                     border-bottom:0px;
  //                     width:100px;
  //                       font-size: 16px;
  //                       font-family: Arial, Helvetica, sans-serif;

  //                     "
  //                   >
  //                   £-${e.discountPrice
  //                     ? e.discountPrice * e.saleQty
  //                     : (returnInvoice?.customerDetails[0]?.priceLevel[0]?.id ==
  //                         1
  //                         ? e.trade_price
  //                         : returnInvoice?.customerDetails[0]?.priceLevel[0]
  //                             ?.id == 2
  //                             ? e.warehouse_price
  //                             : e.retail_price) * e.saleQty
  //                 }
  //                   </td>
  //                 </tr>
  //                 </tbody>`
  //         )
  //         }

  //               <tfoot>
  //                 <tr>

  //                 <td
  //                      style="
  //                       font-size: 20px;
  //                       font-weight: bold;
  //                       text-align : center;
  //                       border: 1px solid black;
  //                       font-family: Arial, Helvetica, sans-serif;
  //                     "
  //                   >
  //                     -${returnInvoice?.productDetails?.length}
  //                   </td>

  //                 <td
  //                   colspan="3"
  //                     style="
  //                       font-size: 20px;
  //                       font-weight: bold;
  //                       text-align : center;
  //                       border: 1px solid black;
  //                       font-family: Arial, Helvetica, sans-serif;
  //                     "
  //                   >
  //                     Subtotal
  //                   </td>
  //                   <td
  //                     style="
  //                       font-size: 20px;
  //                       font-weight: bold;
  //                       text-align : center;
  //                       border: 1px solid black;
  //                       font-family: Arial, Helvetica, sans-serif;

  //                     "
  //                   >
  //                     (${returnInvoice.productDetails.reduce(
  //             (previous, current) => {
  //                 return previous + current.saleQty;
  //             },
  //             0
  //         )})
  //                   </td>
  //                   <td
  //                     style="
  //                       font-size: 20px;
  //                       font-weight: bold;
  //                       font-family: Arial, Helvetica, sans-serif;
  //                       border: 1px solid black;
  //                     "
  //                   ></td>
  //                   <td
  //                     style="
  //                       font-size: 20px;
  //                       font-weight: bold;
  //                       text-align : center;
  //                       font-family: Arial, Helvetica, sans-serif;
  //                       border-top: 1px solid black;
  //                     "
  //                   >
  //                   £${returnInvoice.discount ?? 0}

  //                   </td>
  //                   <td
  //                     style="
  //                       font-size: 20px;
  //                       font-weight: bold;
  //                       text-align : center;
  //                       font-family: Arial, Helvetica, sans-serif;
  //                       border: 1px solid black;
  //                     "
  //                   >
  //                   £-${returnInvoice.vatAmount
  //             ? returnInvoice.total - returnInvoice.discount
  //             : returnInvoice.subtotal
  //         }
  //                   </td>
  //                 </tr>

  //                 ${returnInvoice.vatAmount
  //             ? `
  //                 <tr>
  //                   <td
  //                     colspan="7"
  //                     style="
  //                       font-size: 20px;
  //                       font-weight: bold;
  //                       text-align : center;
  //                       border: 1px solid black;
  //                       font-family: Arial, Helvetica, sans-serif;
  //                     "
  //                   >
  //                     Vat
  //                   </td>
  //                   <td
  //                     style="
  //                       font-size: 20px;
  //                       font-weight: bold;
  //                       text-align : center;
  //                       border: 1px solid black;
  //                       font-family: Arial, Helvetica, sans-serif;
  //                     "
  //                   >
  //                   £ -${returnInvoice.vatAmount}
  //                   </td>
  //                 </tr>`
  //             : ""
  //         }

  //                 <tr>
  //                   <td
  //                     colspan="7"
  //                     style="
  //                       font-size: 20px;
  //                       font-weight: bold;
  //                       color: red;
  //                       text-align : center;
  //                       font-family: Arial, Helvetica, sans-serif;
  //                       border: 1px solid black; "
  //                   >
  //                     Total
  //                   </td>
  //                   <td
  //                     style="
  //                       font-size: 20px;
  //                       font-weight: bold;
  //                       text-align : center;
  //                       border: 1px solid black;
  //                       font-family: Arial, Helvetica, sans-serif;
  //                       color: red;
  //                     "
  //                   >
  //                   £ -${returnInvoice.subtotal}
  //                   </td>
  //                 </tr>
  //               </tfoot>
  //             </table>

  //           </div>
  //         </body>
  //       </html>
  //       `
  //     );
  //     // printWindow.document.close();
  //     setTimeout(() => {
  //         printWindow.print();
  //     }, 100);

  //     printWindow.onafterprint = function () {
  //         try {
  //             dispatch(updateDamageItemCustomer(""));
  //             dispatch(updateSaleReturnCart([]));
  //             setSelectedInvoice("");
  //             setSearchCustomers([]);
  //             setSearchInvoices([]);
  //             setSearchProducts([]);
  //             setDeductCreditBalance({
  //                 ...deductCreditBalance,
  //                 selected: false,
  //             });
  //             setCustomerInvoices("");
  //             setSearchCustomerInvoice("");
  //             setConfirmModalVisible(false);
  //             setSelectedSearch("customers");
  //             setSuccessfulTransactionModal(false);
  //             setReturnInvoice("");
  //             setReturnModal(false);
  //         } catch (error) {
  //             console.error("Error in clearing data:", error);
  //         } finally {
  //             // Close the print window
  //             printWindow.close();
  //         }
  //     };
  // }
  const emailInvoice = async () => {
    let { customerDetails } = returnInvoice;

    let dataToSend = {
      printInvoiceData: returnInvoice,
    };

    setEmailLoading(true);

    let data = await sessionStorage.getItem("userData");
    data = JSON.parse(data);
    let token = data;

    axios
      .post(`${Base_Uri}pdfSendToCustomer`, dataToSend, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // Include other headers as needed
        },
      })
      .then((res) => {
        let data = res.data;

        setEmailLoading(false);

        if (data && data.status) {
          message.info("Invoice Send Succesfully");
        }
        cancelModal();
      })
      .catch((error) => {
        //console.log(error, "errorrrr");
        setEmailLoading(false);
        message.info("There is a server error in email sending");
      });
  };
  const cancelModal = () => {
    dispatch(updateDamageItemCustomer(""));
    dispatch(updateSaleReturnCart([]));
    setSelectedInvoice("");
    setLessAmount(false);
    setPdfDownloadView(false);
    setSearchCustomers([]);
    setDeductCreditBalance({
      ...deductCreditBalance,
      selected: false,
    });
    setSearchInvoices([]);
    setSearchProducts([]);
    setConfirmModalVisible(false);
    setCustomerInvoices("");
    setSearchCustomerInvoice("");
    dispatch(updateAllReturnProducts([]));
    setSelectedSearch("customers");
    setSuccessfulTransactionModal(false);
    setReturnModal(false);
  };
  const handleGoBack = () => {
    if (selectedSearch == "customers" || selectedSearch == "products") {
      setSelectedInvoice("");
    } else {
      setSelectedInvoice("");
      setCustomerInvoices("");
      setSearchCustomerInvoice("");
      dispatch(updateDamageItemCustomer(""));
    }
  };
  const changeDamageQty = (qty, ind, type) => {
    let { productDetails } = selectedInvoice;

    let productSelected = productDetails?.filter((e, i) => i == ind);

    productSelected = productSelected?.[0];

    let remainingQtyToReturn =
      productSelected.saleQty -
      (productSelected?.returnQty ? productSelected?.returnQty : 0);

    if (Number(qty) > Number(remainingQtyToReturn)) {
      message.info(
        `Not enough qty to return the customer has already return ${productSelected?.returnQty} qty`
      );
      return;
    }

    let { returnProductDetails } = selectedInvoice;

    if (type == "exchange") {
      returnProductDetails = returnProductDetails.map((e, i) => {
        if (ind == i) {
          return {
            ...e,
            DamageQty: Number(qty),
          };
        } else {
          return e;
        }
      });

      setSelectedInvoice({
        ...selectedInvoice,
        returnProductDetails: productDetails,
      });

      return;
    }

    productDetails = productDetails.map((e, i) => {
      if (ind == i) {
        return {
          ...e,
          DamageQty: Number(qty),
        };
      } else {
        return e;
      }
    });

    setSelectedInvoice({
      ...selectedInvoice,
      productDetails: productDetails,
    });
  };

  const handleSelectReturnOption = (option) => {
    if (option == "credit") {
      setDeductCreditBalance({
        ...deductCreditBalance,
        selected: !deductCreditBalance.selected,
      });
      setRefundCash({ ...refundCash, selected: false });
      setExchangeProduct({ ...exchangeProduct, selected: false });
    } else if (option == "cash") {
      setDeductCreditBalance({ ...deductCreditBalance, selected: false });
      setRefundCash({ ...refundCash, selected: !refundCash?.selected });
      setExchangeProduct({ ...exchangeProduct, selected: false });
    } else if (option == "card") {
      setDeductCreditBalance({ ...deductCreditBalance, selected: false });
      setRefundCash({ ...refundCash, selected: false });
      setRefundCard({ ...refundCard, selected: !refundCard?.selected });
      setExchangeProduct({ ...exchangeProduct, selected: false });
    } else {
      setDeductCreditBalance({ ...deductCreditBalance, selected: false });
      setRefundCash({ ...refundCash, selected: false });
      setExchangeProduct({
        ...exchangeProduct,
        selected: !exchangeProduct?.selected,
      });
    }
  };

  const handleShowDescription = (ind) => {
    setSearchProducts(
      searchProducts &&
        searchProducts?.length > 0 &&
        searchProducts?.map((e, i) => {
          if (ind == i) {
            return {
              ...e,
              showDescription: !e?.showDescription,
            };
          } else {
            return e;
          }
        })
    );
  };
  // const handleOpenConfimModal2 = (invoice) => {
  //   if (!damageQty) {
  //     message.info("Kindly select Damage Products");
  //     return;
  //   }

  //   let selectedProducts = invoice?.productDetails?.filter((e) => e?.selected);

  //   if (
  //     selectedProducts &&
  //     selectedProducts?.length > 0 &&
  //     selectedProducts?.some((e) => e?.selected && !e?.returnStatus)
  //   ) {
  //     message.info("Kindly Enter Status");
  //     return;
  //   }

  //   let allReturns =
  //     allReturnProducts && allReturnProducts.length > 0
  //       ? [...allReturnProducts]
  //       : [];

  //   let existingIndex = allReturns.findIndex((e) =>
  //     e?.returnInvoiceRef.includes(invoice?.invoiceNumber)
  //   );
  //   //console.log(invoice, "invoice?.customerDetails[0]");
  //   //console.log(damagetotal, "damagetotal");
  //   let returnData = {
  //     productDetails: selectedProducts,
  //     returnInvoiceRef: invoice?.invoiceNumber,
  //     total: Number(damagetotal),
  //     customerDetails: invoice?.customerDetails[0],
  //     discount: damageDiscount,
  //     subtotal: Number(damageSubtotal),
  //     costPrice: damageCost,
  //     totalItems: damageItems,
  //     totalQty: damageQty,
  //     invoiceRefDate: invoice?.saleDate,
  //     vatAmount: damageVat,
  //     employeeDetails: userData,
  //     employeeId: userData?.id,
  //   };
  //   //console.log(returnData, "returnData");
  //   //console.log(allReturns, "allReturns");

  //   if (existingIndex !== -1) {
  //     // Invoice exists, update it
  //     allReturns[existingIndex] = returnData;
  //   } else {
  //     // Invoice does not exist, add new
  //     allReturns.push(returnData);
  //   }

  //   dispatch(updateAllReturnProducts(allReturns));
  //   notify("Successfully added in return");
  // };

  const handleOpenConfimModal = () => {
    if (!damageQty) {
      message.info("Kindly select Damage Products");
      return;
    }
//console.log(selectedInvoice?.newSDAmount,"sd")
    let selectedProducts = selectedInvoice?.productDetails?.filter(
      (e) => e?.selected
    );

    if (
      selectedProducts &&
      selectedProducts?.length > 0 &&
      selectedProducts?.some((e) => e?.selected && !e?.returnStatus)
    ) {
      message.info("Kindly Enter Status");
      return;
    }

    let allReturns =
      allReturnProducts && allReturnProducts.length > 0
        ? [...allReturnProducts]
        : [];

    let existingIndex = allReturns.findIndex((e) =>
      e?.returnInvoiceRef.includes(selectedInvoice?.invoiceNumber)
    );

    let returnData = {
      productDetails: selectedProducts,
      returnInvoiceRef: selectedInvoice?.invoiceNumber,
      total: Number(damagetotal),
      customerDetails: selectedInvoice?.customerDetails[0],
      discount: damageDiscount,
      subtotal: Number(damageSubtotal),
      costPrice: damageCost,
      totalItems: damageItems,
      totalQty: damageQty,
      invoiceRefDate: selectedInvoice?.saleDate,
      vatAmount: damageVat,
      employeeDetails: userData,
      employeeId: userData?.id,
      SDAmount:selectedInvoice?.newSDAmount||0
    };
    ////console.log(returnData);
    //console.log(allReturns);

    if (existingIndex !== -1) {
      // Invoice exists, update it
      allReturns[existingIndex] = returnData;
    } else {
      // Invoice does not exist, add new
      allReturns.push(returnData);
    }

    dispatch(updateAllReturnProducts(allReturns));
    notify("Successfully added in return");
  };
  const handleOpenConfimModal2 = (invoice) => {
    // if (!damageQty) {
    //   message.info("Kindly select Damage Products");
    //   return;
    // }

    let selectedProducts = invoice?.productDetails?.filter(
      (e) => e?.selected
    );

    if (
      selectedProducts &&
      selectedProducts?.length > 0 &&
      selectedProducts?.some((e) => e?.selected && !e?.returnStatus)
    ) {
      message.info("Kindly Enter Status");
      return;
    }

    let allReturns =
      allReturnProducts && allReturnProducts.length > 0
        ? [...allReturnProducts]
        : [];

    let existingIndex = allReturns.findIndex((e) =>
      e?.returnInvoiceRef.includes(invoice?.invoiceNumber)
    );

    let returnData = {
      productDetails: selectedProducts,
      returnInvoiceRef: invoice?.invoiceNumber,
      total: Number(damagetotal),
      customerDetails: invoice?.customerDetails[0],
      discount: damageDiscount,
      subtotal: Number(damageSubtotal),
      costPrice: damageCost,
      totalItems: damageItems,
      totalQty: damageQty,
      invoiceRefDate: invoice?.saleDate,
      vatAmount: damageVat,
      employeeDetails: userData,
      employeeId: userData?.id,
      SDAmount:invoice?.newSDAmount||0
    };
    //console.log(returnData);
    //console.log(allReturns);

    if (existingIndex !== -1) {
      // Invoice exists, update it
      allReturns[existingIndex] = returnData;
    } else {
      // Invoice does not exist, add new
      allReturns.push(returnData);
    }

    dispatch(updateAllReturnProducts(allReturns));
    notify("Successfully added in return");
  };

  const [isSelectProductUseConfirm,setIsSelectProductUseConfirm] = useState(false)

  useEffect(() => {
      if (!isSelectProductUseConfirm) return;
    let selectedProducts = selectedInvoice?.productDetails?.filter(
      (e) => e?.selected
    );
    if (isSelectProductUseConfirm&&selectedProducts && Object.keys(selectedProducts)?.length != 0) {
      handleOpenConfimModal();
    }
    setIsSelectProductUseConfirm(false)
  }, [selectedInvoice?.productDetails,isSelectProductUseConfirm]);
  const changeProductStatus = (status, product) => {
    let { productDetails } = selectedInvoice;

    productDetails =
      productDetails &&
      productDetails?.length > 0 &&
      productDetails?.map((e, i) => {
        if (product?._id == e?._id) {
          return {
            ...e,
            returnStatus: status,
          };
        } else {
          return e;
        }
      });

    setSelectedInvoice({ ...selectedInvoice, productDetails: productDetails });

    // dispatch(updateCart(cartData))
  };

  const changeProductReason = (reason, product) => {
    let { productDetails } = selectedInvoice;

    productDetails =
      productDetails &&
      productDetails?.length > 0 &&
      productDetails?.map((e, i) => {
        if (product?._id == e?._id) {
          return {
            ...e,
            reason: reason,
          };
        } else {
          return e;
        }
      });
    //console.log(productDetails, "productDetails");
    setSelectedInvoice({ ...selectedInvoice, productDetails: productDetails });

    // dispatch(updateCart(cartData))
  };

  const handleShowIMEI = (data) => {
    //console.log(data, "dataaaa");
  };

  const PrintReturnLabel = (product) => {
    //console.log(product, "product");
    // console.log(
    //   new Date().toLocaleDateString("en-GB", {
    //     day: "2-digit",
    //     month: "2-digit",
    //     year: "numeric",
    //   })
    // );
    //console.log(new Date().toLocaleTimeString());
    //console.log(selectedCustomer,"selectedCustomer");
     const printWindow = window.open('', '', 'height=400,width=600');
  printWindow.document.write(`
    <html>
      <head>
        <title>Print Label</title>
        <style>
          body { font-family: Arial, sans-serif; padding: 20px; }
          .label {
            border: 2px solid #000;
            width: 300px;
            font-size: 14px;
            padding:15px;
          }
            @page {
    size: 85mm 60mm;  /* width x height */
  }
          .label h2 {
            margin: 0 0 10px 0;
            text-align: center;
          }
          .label p { margin: 5px 0; }
        </style>
      </head>
      <body>
        <div class="label">
          <h2>Product Label</h2>
          <p><b>Date/Time:</b> ${ new Date().toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })} / ${new Date().toLocaleTimeString()}</p>
          <p><b>Customer:</b> ${selectedCustomer?.businessName}</p>
          <p><b>Product:</b> ${product?.product_name}</p>
          <p><b>Reason:</b> ${product?.returnStatus}: ${product?.reason||""}</p>
        </div>
        <script>
          window.print();
          window.onafterprint = window.close;
        </script>
      </body>
    </html>
  `);
  };

  const handleOpenConfimModal3 = (invoice) => {
  if (!damageQty) {
    message.info("Kindly select Damage Products");
    return;
  }

  //console.log(invoice?.newSDAmount, "sd");

  const selectedProducts = invoice?.productDetails?.filter((e) => e?.selected) || [];

  if (
    selectedProducts.length > 0 &&
    selectedProducts.some((e) => e?.selected && !e?.returnStatus)
  ) {
    message.info("Kindly Enter Status");
    return;
  }

  const allReturns = Array.isArray(allReturnProducts) ? [...allReturnProducts] : [];

  const existingIndex = allReturns.findIndex(
    (e) => e?.returnInvoiceRef === invoice?.returnInvoiceRef
  );

  const returnData = {
    productDetails: selectedProducts,
    returnInvoiceRef: invoice?.returnInvoiceRef,
    total: Number(damagetotal || 0),
    customerDetails: invoice?.customerDetails || {},
    discount: Number(damageDiscount || 0),
    subtotal: Number(damageSubtotal || 0),
    costPrice: Number(damageCost || 0),
    totalItems: Number(damageItems || 0),
    totalQty: Number(damageQty || 0),
    invoiceRefDate: invoice?.invoiceRefDate,
    vatAmount: Number(damageVat || 0),
    employeeDetails: userData || {},
    employeeId: userData?.id || "",
    SDAmount: Number(invoice?.SDAmount || 0),
  };

  if (existingIndex !== -1) {
    allReturns[existingIndex] = returnData;
  } else {
    allReturns.push(returnData);
  }

  dispatch(updateAllReturnProducts(allReturns));
  // notify("Successfully added in return");
};


const RemoveProduct = (invoiceRef, productId,pr=true) => {
  const updatedInvoices = (Array.isArray(allReturnProducts) ? allReturnProducts : [])
    .map((invoice) => {
      if (invoice.returnInvoiceRef !== invoiceRef) return invoice;

      const remainingProducts = (invoice.productDetails || []).filter(
        (p) => p._id !== productId
      );

      if (remainingProducts.length === 0) return null;

      return { ...invoice, productDetails: remainingProducts };
    })
    .filter(Boolean);

  //console.log(updatedInvoices, "updatedInvoices");

  const updateInvoiceArray = updatedInvoices
   ;

    //console.log(updateInvoiceArray,"updateInvoiceArray")
//console.log(invoiceRef,"invoiceRef")
  const makeInvoice = updateInvoiceArray.find(
    (e) => e?.returnInvoiceRef === invoiceRef
  );

  //console.log(makeInvoice,"makeInvoice")

  if (!makeInvoice) {
  console.warn("No invoice found for:", invoiceRef);

  if (Array.isArray(updatedInvoices)) {
    dispatch(updateAllReturnProducts(updatedInvoices));
  }

  //console.log(selectedInvoice, "selectedInvoice2", "ddppd");
    
  //console.log(updatedInvoices, "updatedInvoices", "ddppd");

  if ( updatedInvoices.length == 0&&pr) {
    //console.log("ddppd",updatedInvoices.length)
      setSelectedSearch("products");
      setSelectedInvoice("");
      notify("Product Successfully remove ")
  }
  if (updatedInvoices.length == 0&&!pr) {
    
    if (selectedInvoice&&selectedInvoice?.productDetails) {
      let selectedInvoiceDup = selectedInvoice
    selectedInvoiceDup.productDetails = selectedInvoiceDup&&selectedInvoiceDup?.productDetails?.map((e)=>{
      //console.log(e._id!=productId,"e._id!=productId")
      if(e._id!=productId) return e
      // console.log({
      //   ...e,
      //   selected:false
      // },"dpldldl")
      return({
        ...e,
        selected:false
      }) 
    })
    //console.log(selectedInvoiceDup,"selectedInvoiceDup")
    setSelectedInvoice(selectedInvoiceDup)
    }
   if (searchCustomerInvoice?.length) {
  const selectedInvoiceDup = searchCustomerInvoice.find(
    (e) => e.invoiceNumber === invoiceRef
  );

  if (selectedInvoiceDup) {
    const updatedProductDetails = selectedInvoiceDup.productDetails?.map((p) =>
      p._id !== productId
        ? p
        : { ...p, selected: false }
    );

    const updatedInvoice = {
      ...selectedInvoiceDup,
      productDetails: updatedProductDetails,
    };

    const updatedInvoices = searchCustomerInvoice.map((inv) =>
      inv.invoiceNumber === invoiceRef ? updatedInvoice : inv
    );

    //console.log(updatedInvoice, "updatedInvoice");
    setSearchCustomerInvoice(updatedInvoices);
  }
}

  }

  // if (typeof handleGoBack === "function") {
  //   handleGoBack();
  // }

  return;
}


  const totalAfterDiscount =
    Number(makeInvoice?.total || 0) - Number(makeInvoice?.discount || 0);

  const calculateSpDiscountPercent =
    totalAfterDiscount > 0
      ? (Number(makeInvoice?.SDAmount || 0) / totalAfterDiscount) * 100
      : 0;

  const priceLevelId =
    makeInvoice?.customerDetails?.priceLevel?.[0]?.id || 1;

  const calSd = (makeInvoice?.productDetails || []).reduce((t, c) => {
    if (!c.selected) return t;
    const price =
      priceLevelId === 1
        ? c.trade_price
        : priceLevelId === 2
        ? c.warehouse_price
        : priceLevelId === 4
        ? c.diamond
        : c.retail_price;

    const qty = Number(c.DamageQty || c.saleQty || 0);
    const total = (Number(c.discountPrice) || price) * qty;
    return t + (total * calculateSpDiscountPercent) / 100;
  }, 0);

  damageItems = (makeInvoice?.productDetails || []).filter((p) => p.selected)
    .length;

  damageQty = (makeInvoice?.productDetails || []).reduce(
    (sum, p) => sum + (p.selected ? Number(p.DamageQty || p.saleQty || 0) : 0),
    0
  );

  damagetotal = (makeInvoice?.productDetails || []).reduce((sum, p) => {
    if (!p.selected) return sum;
    const price =
      priceLevelId === 1
        ? p.trade_price
        : priceLevelId === 2
        ? p.warehouse_price
        : priceLevelId === 4
        ? p.diamond
        : p.retail_price;
    const qty = Number(p.DamageQty || p.saleQty || 0);
    return sum + price * qty;
  }, 0);

  damageCost = (makeInvoice?.productDetails || []).reduce(
    (sum, p) =>
      sum +
      (p.selected
        ? Number(p.cost_price || 0) * Number(p.DamageQty || p.saleQty || 0)
        : 0),
    0
  );

  damageDiscount = (makeInvoice?.productDetails || []).reduce((sum, p) => {
    if (!p.selected || !p.discountPrice) return sum;
    const price =
      priceLevelId === 1
        ? p.trade_price
        : priceLevelId === 2
        ? p.warehouse_price
        : priceLevelId === 4
        ? p.diamond
        : p.retail_price;

    const qty = Number(p.DamageQty || p.saleQty || 0);
    const discountAdjusted = (price - Number(p.discountPrice)) * qty;
    return sum + discountAdjusted;
  }, 0);


  const vatRates = Number(vatRate || 0);
  damageVat = makeInvoice?.vatAmount
    ? (((damagetotal - damageDiscount)- (((damagetotal - damageDiscount) * calculateSpDiscountPercent) /
                            100) ) * vatRates) / 100
    : 0;

  damageSubtotal =
    Number(damagetotal || 0) -
    Number(damageDiscount || 0) +
    Number(damageVat || 0) -
    Number(calSd || 0);

    if (selectedInvoice&&selectedInvoice?.productDetails) {
      let selectedInvoiceDup = selectedInvoice
    selectedInvoiceDup.productDetails = selectedInvoiceDup&&selectedInvoiceDup?.productDetails?.map((e)=>{
      //console.log(e._id!=productId,"e._id!=productId")
      if(e._id!=productId) return e
      // console.log({
      //   ...e,
      //   selected:false
      // },"dpldldl")
      return({
        ...e,
        selected:false
      }) 
    })
    //console.log(selectedInvoiceDup,"selectedInvoiceDup")
    setSelectedInvoice(selectedInvoiceDup)
    }

    if (searchCustomerInvoice?.length) {
  const selectedInvoiceDup = searchCustomerInvoice.find(
    (e) => e.invoiceNumber === invoiceRef
  );

  if (selectedInvoiceDup) {
    const updatedProductDetails = selectedInvoiceDup.productDetails?.map((p) =>
      p._id !== productId
        ? p
        : { ...p, selected: false }
    );

    const updatedInvoice = {
      ...selectedInvoiceDup,
      productDetails: updatedProductDetails,
    };

    const updatedInvoices = searchCustomerInvoice.map((inv) =>
      inv.invoiceNumber === invoiceRef ? updatedInvoice : inv
    );

    //console.log(updatedInvoice, "updatedInvoice");
    setSearchCustomerInvoice(updatedInvoices);
  }
}

notify("Product Successfully remove ")
  // ✅ Pass single invoice object, not array
  handleOpenConfimModal3({...makeInvoice,SDAmount:calSd});
};



  return (
    <div>
      <Modal
        open={open}
        // onClose={cancelModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        {invoiceLoading || exchangeLoading ? (
          <Box
            sx={[
              style,
              {
                containerStyle,
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
              },
            ]}
          >
            <RingLoader
              loading={invoiceLoading}
              size={50}
              color={Colors.black}
            />
          </Box>
        ) : pdfDownloadView ? (
          <Box
            style={{
              wodth: "100%",
              height: "100%",
              // border: "1px solid red",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <PDFViewer width={850} height={700} style={{ marginTop: 100 }}>
              <MyDocument />
            </PDFViewer>
            <CloseOutlinedIcon
              fontSize="large"
              style={{
                color: Colors.black,
                marginTop: "100px",
                cursor: "pointer",
              }}
              onClick={() => cancelModal()}
            />
          </Box>
        ) : (
          <Box sx={[style, { containerStyle }]}>
            <ToastContainer />

            <Box
              onClick={() => cancelModal()}
              style={{ position: "absolute", top: 10, right: 10 }}
            >
              <CloseIcon fontSize="large" />
            </Box>

            {((selectedInvoice && customerInvoice) || searchIs) &&
              selectedSearch !== "checkout" && (
                <ArrowBackIosNewOutlined
                  style={{ position: "absolute", top: 20 }}
                  onClick={() => {
                    if (searchIs) {
                      setSearchIs(false);
                      setSearchCustomerInvoice("");
                    } else {
                      handleGoBack();
                    }
                  }}
                />
              )}

            <Typography
              sx={{
                fontSize: "20px",
                color: Colors.button,
                fontWeight: "bold",
                fontFamily: "Poppins",
                textAlign: "center",
                ...headingTextStyle,
              }}
              id="modal-modal-title"
              variant="h6"
              component="h2"
            >
              {heading}
            </Typography>

            <Grid md={12} xs={12} sm={12}>
              <Box
                sx={{
                  width: "100%",
                  marginTop: { xs: "10px", sm: "10px", md: "10px" },
                  border: `1px solid ${Colors.button}`,
                  borderRadius: "5px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "5px 10px 5px 10px",
                  margin: 0,
                }}
              >
                <TextField
                  variant="standard" // <== changed this
                  margin="normal"
                  required
                  value={text}
                  fullWidth
                  autoFocus
                  inputRef={textInputRef}
                  onChange={(e) => handleSearch(e.target.value)}
                  InputProps={{
                    // startAdornment: <AccountCircle />, // <== adjusted this
                    disableUnderline: true,
                    fontSize: "12px",

                    // <== added this
                    // fontSize: "2px"
                  }}
                  // onChange={handleSearchProducts}
                  placeholder={
                    selectedSearch == "products"
                      ? "Search Products Name & Barcode"
                      : selectedSearch == "invoices"
                      ? "Search Invoice"
                      : "Search Customer"
                  }
                  sx={{
                    width: "90%",
                    fontSize: "12px",
                    padding: 0,
                    fontFamily: "Poppins",
                    fontWeight: "bold",
                    margin: 0,
                  }}
                />

                <img
                  src={require("../Images/search.png")}
                  style={{ height: "20px" }}
                />
              </Box>

              <Box>
                {searchInvoices && searchInvoices.length > 0
                  ? searchInvoices.map((e, i) => {
                      return (
                        <Button
                          onClick={() => handleSelectInvoice(e)}
                          sx={{
                            width: "100%",
                            mt: 1,
                            backgroundColor: Colors.white,
                            p: "0px 10px",
                            fontFamily: "Poppins",
                            fontWeight: "bold",
                            borderRadius: 1,
                            textAlign: "left",
                            display: "flex",
                            justifyContent: "flex-start",
                            border: `1px solid ${Colors.border}`,
                            "&:hover": {
                              color: "#5DC002", // Set your desired hover color
                            },
                          }}
                        >
                          <p
                            style={{ fontFamily: "Poppins", textAlign: "left" }}
                          >
                            {e.invoiceNumber}
                          </p>
                        </Button>
                      );
                    })
                  : searchCustomers && searchCustomers.length > 0
                  ? searchCustomers.map((e, i) => {
                      return (
                        <Button
                          onClick={() => {
                            // handleSelectCustomer(e)
                            //console.log(e, "dkdkdk");
                            setSelectedCustomerId(e);
                            // setTimeout(()=>{
                            //   textInputRef?.current?.blur()
                            // },[400])
                          }}
                          sx={{
                            width: "100%",
                            mt: 1,
                            backgroundColor: Colors.white,
                            p: "0px 10px",
                            fontFamily: "Poppins",
                            fontWeight: "bold",
                            borderRadius: 1,
                            textAlign: "left",
                            display: "flex",
                            justifyContent: "flex-start",
                            border: `1px solid ${Colors.border}`,
                          }}
                        >
                          <p
                            style={{ fontFamily: "Poppins", textAlign: "left" }}
                          >
                            {e.businessName}
                          </p>
                        </Button>
                      );
                    })
                  : searchProducts &&
                    searchProducts.length > 0 &&
                    searchProducts
                      .filter(
                        (value, index, self) =>
                          index === self.findIndex((t) => t._id === value._id)
                      )
                      .map((e, i) => {
                        return (
                          <Button
                            onClick={() => handleChooseProducts(e, true)}
                            sx={{
                              width: "100%",
                              // mt: 1,
                              backgroundColor: Colors.white,
                              p: "10px 10px",
                              fontFamily: "Poppins",
                              fontWeight: "bold",
                              cursor: "pointer",
                              borderRadius: 1,
                              textAlign: "left",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "flex-start",
                              border: `1px solid ${Colors.border}`,
                            }}
                          >
                            <p
                              style={{
                                fontFamily: "Poppins",
                                textAlign: "left",
                                marginBottom: 0,
                                color: Colors.button,
                              }}
                            >
                              {e.product_name}
                              <br />
                              {/* Available qty: {e.qty} */}
                            </p>
                          </Button>
                        );
                      })}
              </Box>

              <Box sx={{ display: "flex", flexDirection: "row", mt: 1 }}>
                <CustomButton
                  text="Customers"
                  onClick={() => setSelectedSearch("customers")}
                  style={{
                    width: "120px",
                    borderRadius: "5px",

                    backgroundColor:
                      selectedSearch == "customers"
                        ? Colors.button
                        : Colors.white,
                    color:
                      selectedSearch == "customers"
                        ? Colors.white
                        : Colors.button,
                  }}
                />

                <CustomButton
                  text="Products"
                  onClick={() => setSelectedSearch("products")}
                  style={{
                    width: "120px",
                    ml: 1,
                    borderRadius: "5px",
                    backgroundColor:
                      selectedSearch == "products"
                        ? Colors.button
                        : Colors.white,
                    color:
                      selectedSearch == "products"
                        ? Colors.white
                        : Colors.button,
                  }}
                />

                <CustomButton
                  text="IMEI"
                  onClick={() => setSelectedSearch("imei")}
                  style={{
                    width: "120px",
                    ml: 1,
                    borderRadius: "5px",
                    backgroundColor:
                      selectedSearch == "imei" ? Colors.button : Colors.white,
                    color:
                      selectedSearch == "imei" ? Colors.white : Colors.button,
                  }}
                />

                <CustomButton
                  text="Invoices"
                  onClick={() => setSelectedSearch("invoices")}
                  style={{
                    width: "120px",
                    borderRadius: "5px",
                    ml: 1,
                    backgroundColor:
                      selectedSearch == "invoices"
                        ? Colors.button
                        : Colors.white,
                    color:
                      selectedSearch == "invoices"
                        ? Colors.white
                        : Colors.button,
                  }}
                />

                {allReturnProducts &&
                  allReturnProducts?.length > 0 &&
                  selectedCustomer && (
                    <CustomButton
                      text="Checkout"
                      onClick={() => setSelectedSearch("checkout")}
                      style={{
                        width: "120px",
                        borderRadius: "5px",
                        ml: 1,
                        backgroundColor:
                          selectedSearch == "checkout"
                            ? Colors.button
                            : Colors.white,
                        color:
                          selectedSearch == "checkout"
                            ? Colors.white
                            : Colors.button,
                      }}
                    />
                  )}
              </Box>

              {selectedInvoice ? (
                <Box
                  sx={{
                    width: "100%",
                    backgroundColor: Colors.white,
                    marginTop: "10px",

                    borderRadius: "5px",
                  }}
                >
                  <Grid xs={12}>
                    <Box
                      sx={{
                        display: "flex",
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        fontFamily: "Poppins",
                        fontSize: "14px",
                        fontWeight: "bold",
                      }}
                    >
                      <Box style={{ display: "flex", flexDirection: "row" }}>
                        {" "}
                        Account No :{" "}
                        <span style={{ marginLeft: 5 }}>
                          {" "}
                          {selectedInvoice?.customerDetails?.[0]?.accountNo}
                        </span>
                      </Box>

                      <Box style={{ display: "flex", flexDirection: "row" }}>
                        {" "}
                        Business Name :{" "}
                        <span style={{ marginLeft: 5 }}>
                          {" "}
                          {selectedInvoice?.customerDetails?.[0]?.businessName}
                        </span>
                      </Box>

                      <Box
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          width: "100%",
                        }}
                      >
                        <Box>
                          {" "}
                          Customer Name :{" "}
                          <span style={{ marginLeft: 5 }}>
                            {" "}
                            {selectedInvoice?.customerDetails[0]?.customerName}
                          </span>
                        </Box>

                        <Box>
                          Payment Method :{" "}
                          <span
                            style={{
                              marginLeft: 5,
                              color: Array.isArray(
                                selectedInvoice?.paymentMethod
                              )
                                ? selectedInvoice?.paymentMethod?.some(
                                    (e, i) =>
                                      typeof e == "string" &&
                                      e.toLowerCase() == "credit"
                                  )
                                  ? Colors.red
                                  : Colors.green
                                : selectedInvoice?.paymentMethod?.toLowerCase() ==
                                  "credit"
                                ? Colors.red
                                : Colors.green,
                            }}
                          >
                            {" "}
                            {Array.isArray(selectedInvoice?.paymentMethod)
                              ? selectedInvoice?.paymentMethod
                                  ?.map((e, i) => e)
                                  .join(",")
                              : selectedInvoice?.paymentMethod}
                          </span>
                        </Box>
                      </Box>

                      <Box
                        style={{ display: "flex", flexDirection: "row", m: 0 }}
                      >
                        {" "}
                        Customer Email :{" "}
                        <span style={{ marginLeft: 5 }}>
                          {" "}
                          {selectedInvoice?.customerDetails[0]?.email}
                        </span>
                      </Box>

                      <Box
                        style={{ display: "flex", flexDirection: "row", m: 0 }}
                      >
                        {" "}
                        Invoice Balance :{" "}
                        <span style={{ marginLeft: 5 }}>
                          {" "}
                          £
                          {selectedCustomer?.creditBalance
                            ? Number(selectedCustomer?.creditBalance).toFixed(2)
                            : 0}
                        </span>
                      </Box>

                      <Box
                        style={{ display: "flex", flexDirection: "row", m: 0 }}
                      >
                        {" "}
                        Quotation Balance :{" "}
                        <span style={{ marginLeft: 5 }}>
                          {" "}
                          £
                          {(customerLedger[customerLedger.length - 1]
                            ?.runningBalance - selectedCustomer?.creditBalance).toFixed(2)}
                        </span>
                      </Box>

                      {selectedCustomer?.comment && (
                        <Box
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            m: 0,
                            textAlign: "left",
                          }}
                        >
                          {" "}
                          Comment:{" "}
                          <span
                            style={{
                              marginLeft: 5,
                              fontSize: "12px",
                              fontWeight: "800",
                              fontFamily: "Poppins",
                              textAlign: "left",
                              color: "red",
                            }}
                          >
                            {" "}
                            {selectedCustomer?.comment}
                          </span>
                        </Box>
                      )}

                      <Box
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          m: 0,
                          alignItems: "center",
                          textAlign: "left",
                        }}
                      >
                        {" "}
                        Delivery Address:{" "}
                        <span
                          style={{
                            marginLeft: 5,
                            fontSize: "12px",
                            fontWeight: "800",
                            fontFamily: "Poppins",
                            textAlign: "left",
                            color: "purple",
                          }}
                        >
                          {" "}
                          {selectedCustomer?.deliveryAddress
                            ? selectedCustomer?.deliveryAddress
                            : selectedCustomer?.address}
                        </span>
                      </Box>

                      {selectedInvoice?.exchangeDate ? (
                        <Box
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            m: 0,
                            alignItems: "center",
                            textAlign: "left",
                          }}
                        >
                          {" "}
                          Date:
                          <span
                            style={{
                              marginLeft: 5,
                              fontSize: "14px",
                              fontWeight: "400",
                              fontFamily: "Poppins",
                              textAlign: "left",
                            }}
                          >
                            {" "}
                            {new Date(
                              selectedInvoice.exchangeDate
                            ).toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                            })}
                          </span>
                        </Box>
                      ) : (
                        selectedInvoice?.saleDate && (
                          <Box
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              m: 0,
                              alignItems: "center",
                              textAlign: "left",
                            }}
                          >
                            {" "}
                            Date:
                            <span
                              style={{
                                marginLeft: 5,
                                fontSize: "14px",
                                fontWeight: "400",
                                fontFamily: "Poppins",
                                textAlign: "left",
                              }}
                            >
                              {" "}
                              {new Date(
                                selectedInvoice.saleDate
                              ).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                              })}
                            </span>
                          </Box>
                        )
                      )}

                      {selectedInvoice?.exchangeDate ? (
                        <Box
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            m: 0,
                            alignItems: "center",
                            textAlign: "left",
                          }}
                        >
                          {" "}
                          Time:
                          <span
                            style={{
                              marginLeft: 5,
                              fontSize: "14px",
                              fontWeight: "400",
                              fontFamily: "Poppins",
                              textAlign: "left",
                            }}
                          >
                            {" "}
                            {new Date(
                              selectedInvoice.exchangeDate
                            ).toLocaleTimeString()}
                          </span>
                        </Box>
                      ) : (
                        selectedInvoice?.saleDate && (
                          <Box
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              m: 0,
                              alignItems: "center",
                              textAlign: "left",
                            }}
                          >
                            {" "}
                            Time:
                            <span
                              style={{
                                marginLeft: 5,
                                fontSize: "14px",
                                fontWeight: "400",
                                fontFamily: "Poppins",
                                textAlign: "left",
                              }}
                            >
                              {" "}
                              {new Date(
                                selectedInvoice.saleDate
                              ).toLocaleTimeString()}
                            </span>
                          </Box>
                        )
                      )}
                    </Box>
                  </Grid>
                </Box>
              ) : searchCustomerInvoice && searchCustomerInvoice.length > 0 ? (
                <Box
                  sx={{
                    width: "100%",
                    backgroundColor: Colors.white,
                    marginTop: "10px",
                    borderRadius: "5px",
                  }}
                >
                  <Grid xs={12}>
                    <Box
                      sx={{
                        display: "flex",
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        fontFamily: "Poppins",
                        fontSize: "14px",
                        fontWeight: "bold",
                      }}
                    >
                      <Box style={{ display: "flex", flexDirection: "row" }}>
                        {" "}
                        Account No:{" "}
                        <span style={{ marginLeft: 5 }}>
                          {" "}
                          {selectedCustomer?.accountNo}
                        </span>
                      </Box>
                      <Box style={{ display: "flex", flexDirection: "row" }}>
                        {" "}
                        Business Name :{" "}
                        <span style={{ marginLeft: 5 }}>
                          {" "}
                          {selectedCustomer?.businessName}
                        </span>
                      </Box>
                      <Box style={{ display: "flex", flexDirection: "row" }}>
                        {" "}
                        Customer Name :{" "}
                        <span style={{ marginLeft: 5 }}>
                          {" "}
                          {selectedCustomer?.customerName}
                        </span>
                      </Box>

                      <Box
                        style={{ display: "flex", flexDirection: "row", m: 0 }}
                      >
                        {" "}
                        Customer Email :{" "}
                        <span style={{ marginLeft: 5 }}>
                          {" "}
                          {selectedCustomer?.email}
                        </span>
                      </Box>

                      <Box
                        style={{ display: "flex", flexDirection: "row", m: 0 }}
                      >
                        {" "}
                        Invoice Balance :{" "}
                        <span style={{ marginLeft: 5 }}>
                          {" "}
                          £
                          {selectedCustomer?.creditBalance
                            ? Number(selectedCustomer?.creditBalance).toFixed(2)
                            : 0}
                        </span>
                      </Box>

                      <Box
                        style={{ display: "flex", flexDirection: "row", m: 0 }}
                      >
                        {" "}
                        Quotation Balance :{" "}
                        <span style={{ marginLeft: 5 }}>
                          {" "}
                          £
                          {/* {selectedCustomer?.quotationBalance
                            ? Number(
                                selectedCustomer?.quotationBalance
                              ).toFixed(2)
                            : 0} */}
                          {(customerLedger[customerLedger.length - 1]
                            ?.runningBalance - selectedCustomer?.creditBalance)?.toFixed(2)}
                        </span>
                      </Box>

                      {selectedCustomer?.comment && (
                        <Box
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            m: 0,
                            textAlign: "left",
                          }}
                        >
                          {" "}
                          Comment:{" "}
                          <span
                            style={{
                              marginLeft: 5,
                              fontSize: "12px",
                              fontWeight: "800",
                              fontFamily: "Poppins",
                              textAlign: "left",
                              color: "red",
                            }}
                          >
                            {" "}
                            {selectedCustomer?.comment}
                          </span>
                        </Box>
                      )}

                      <Box
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          m: 0,
                          alignItems: "center",
                          textAlign: "left",
                        }}
                      >
                        {" "}
                        Delivery Address:{" "}
                        <span
                          style={{
                            marginLeft: 5,
                            fontSize: "12px",
                            fontWeight: "800",
                            fontFamily: "Poppins",
                            textAlign: "left",
                            color: "purple",
                          }}
                        >
                          {" "}
                          {selectedCustomer?.deliveryAddress
                            ? selectedCustomer?.deliveryAddress
                            : selectedCustomer?.address}
                        </span>
                      </Box>

                      {!searchIs &&
                        searchCustomerInvoice &&
                        selectedSearch?.toLowerCase() !== "checkout" &&
                        searchCustomerInvoice.length > 0 &&
                        searchCustomerInvoice?.map((invoice, ind) => {
                          //console.log(invoice, "allReturnProducts");
                          //console.log(selectedInvoice, "allReturnProducts2");
                          let fjc = allReturnProducts.find(
                            (e) =>
                              e.returnInvoiceRef &&
                              e.returnInvoiceRef.includes(invoice.invoiceNumber)
                          );
                          let pfjc = fjc?.productDetails;
                          let pIvoice = invoice?.productDetails;
                          pIvoice.map((e) => {
                            if (
                              pfjc?.length != 0 &&
                              pfjc?.find((j) => j?._id == e?._id)
                            ) {
                              e.selected = true;
                              e.returnStatus = pfjc?.filter(
                                (j) => j?._id == e?._id
                              )?.[0]?.returnStatus;
                              e.reason = pfjc?.filter(
                                (j) => j?._id == e?._id
                              )?.[0]?.reason||"";
                               e.DamageQty = pfjc?.filter(
                                  (j) => j?._id == e?._id
                                )?.[0]?.DamageQty;
                              return e;
                            } else {
                              return e;
                            }
                          });
                          invoice.productDetails = pIvoice;
                          return (
                            <Button
                              onClick={() => setSelectedInvoice(invoice)}
                              sx={{
                                borderBottom: `1px solid ${Colors.border}`,
                                width: "100%",
                                alignItems: "center",
                                p: 0,
                                m: 0,
                              }}
                            >
                              <Grid
                                md={12}
                                xs={12}
                                sm={12}
                                container
                                sx={{ mt: 1 }}
                              >
                                <Grid item xs={6} sx={{ p: 1 }}>
                                  <Box sx={{ width: "100%" }}>
                                    <Typography
                                      sx={{
                                        fontSize: "14px",
                                        fontFamily: "Poppins",
                                        color: Colors.black,
                                        fontWeight: "bold",
                                        textAlign: "left",
                                      }}
                                    >
                                      Invoice No:{" "}
                                      <span>{invoice?.invoiceNumber} </span>
                                    </Typography>

                                    <Typography
                                      sx={{
                                        fontSize: "12px",
                                        fontFamily: "Poppins",
                                        color: Colors.text,
                                        fontWeight: "500",
                                        textAlign: "left",
                                      }}
                                    >
                                      Date/Time:{" "}
                                      <span>
                                        {" "}
                                        {invoice?.exchangeDate
                                          ? new Date(
                                              invoice?.exchangeDate
                                            ).toLocaleDateString("en-GB", {
                                              day: "2-digit",
                                              month: "2-digit",
                                              year: "numeric",
                                            })
                                          : new Date(
                                              invoice?.saleDate
                                            ).toLocaleDateString("en-GB", {
                                              day: "2-digit",
                                              month: "2-digit",
                                              year: "numeric",
                                            })}{" "}
                                        {invoice?.exchangeDate
                                          ? new Date(
                                              invoice?.exchangeDate
                                            ).toLocaleTimeString()
                                          : new Date(
                                              invoice?.saleDate
                                            ).toLocaleTimeString()}{" "}
                                      </span>
                                    </Typography>

                                    <Typography
                                      sx={{
                                        fontSize: "12px",
                                        fontFamily: "Poppins",
                                        color: Colors.text,
                                        fontWeight: "500",
                                        textAlign: "left",
                                      }}
                                    >
                                      product Name:{" "}
                                      <span>
                                        {invoice.productDetails
                                          .filter((e) => e.selected)
                                          .map((selectedProduct, index) => (
                                            <span key={index}>
                                              {selectedProduct.productName}
                                            </span>
                                          ))}
                                      </span>
                                    </Typography>

                                    <Typography
                                      sx={{
                                        fontSize: "12px",
                                        fontFamily: "Poppins",
                                        color: Colors.text,
                                        fontWeight: "500",
                                        textAlign: "left",
                                      }}
                                    >
                                      Quantity:{" "}
                                      <span>
                                        {invoice.productDetails
                                          .filter((e) => e.selected)
                                          .map((selectedProduct, index) => (
                                            <span key={index}>
                                              {selectedProduct.saleQty}
                                            </span>
                                          ))}
                                      </span>
                                    </Typography>
                                  </Box>
                                </Grid>
                                <Grid
                                  item
                                  xs={3}
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: "14px",
                                      fontFamily: "Poppins",
                                      fontWeight: "bold",

                                      color: Array.isArray(
                                        invoice?.paymentMethod
                                      )
                                        ? invoice?.paymentMethod?.some(
                                            (e, i) =>
                                              typeof e == "string" &&
                                              e.toLowerCase() == "credit"
                                          )
                                          ? Colors.red
                                          : Colors.green
                                        : invoice?.paymentMethod?.toLowerCase() ==
                                          "credit"
                                        ? Colors.red
                                        : Colors.green,
                                    }}
                                  >
                                    {" "}
                                    {Array.isArray(invoice?.paymentMethod)
                                      ? invoice?.paymentMethod
                                          ?.map((e, i) => e)
                                          .join(",")
                                      : invoice?.paymentMethod}
                                  </Typography>
                                </Grid>

                                <Grid
                                  item
                                  xs={3}
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: "14px",
                                      fontFamily: "Poppins",
                                      color: Colors.black,
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {Number(invoice.subtotal).toFixed(2)}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Button>
                          );
                        })}
                      {searchIs &&
                        selectedSearch?.toLowerCase() !== "checkout" && (
                          <Box sx={{ marginTop: "0px", width: "100%" }}>
                            <Grid
                              container
                              xs={12}
                              sx={{
                                backgroundColor: Colors.black,
                                alignItems: "center",
                              }}
                            >
                              <Grid item xl={4.5} lg={4} md={4} sm={4.5} xs={4}>
                                <Typography
                                  sx={{
                                    color: Colors.white,
                                    fontFamily: "Poppins",
                                    fontWeight: "500",
                                    fontSize: {
                                      lg: "16px",
                                      md: "12px",
                                      sm: "10px",
                                      xs: "8px",
                                    },
                                    textAlign: "center",
                                  }}
                                >
                                  Product Description
                                </Typography>
                              </Grid>

                              <Grid item xl={1} lg={2} md={2} sm={1.5} xs={1.5}>
                                <Typography
                                  sx={{
                                    color: Colors.white,
                                    fontFamily: "Poppins",
                                    fontWeight: "500",
                                    fontSize: {
                                      lg: "16px",
                                      md: "12px",
                                      sm: "10px",
                                      xs: "8px",
                                    },
                                    textAlign: "left",
                                  }}
                                >
                                  Quantity
                                </Typography>
                              </Grid>

                              <Grid item xl={1} lg={1} md={0.5} sm={0.5} xs={1}>
                                <Typography
                                  sx={{
                                    color: Colors.white,
                                    fontFamily: "Poppins",
                                    fontWeight: "500",
                                    width: "100%",
                                    fontSize: {
                                      lg: "16px",
                                      md: "12px",
                                      sm: "10px",
                                      xs: "8px",
                                    },
                                    textAlign: { md: "center", lg: "left" },
                                  }}
                                >
                                  Return Qty
                                </Typography>
                              </Grid>

                              <Grid
                                item
                                xl={1}
                                lg={1.5}
                                md={1}
                                sm={1.5}
                                xs={1.5}
                              >
                                <Typography
                                  sx={{
                                    color: Colors.white,
                                    fontFamily: "Poppins",
                                    fontWeight: "500",
                                    fontSize: {
                                      lg: "16px",
                                      md: "12px",
                                      sm: "10px",
                                      xs: "8px",
                                    },
                                    textAlign: { md: "center", lg: "left" },
                                  }}
                                >
                                  Current Price(£)
                                </Typography>
                              </Grid>

                              <Grid item xl={1} lg={1} md={1} sm={1.5} xs={2}>
                                <Typography
                                  sx={{
                                    color: Colors.white,
                                    fontFamily: "Poppins",
                                    fontWeight: "500",
                                    fontSize: {
                                      lg: "16px",
                                      md: "12px",
                                      sm: "10px",
                                      xs: "8px",
                                    },
                                    textAlign: { md: "center", lg: "left" },
                                  }}
                                >
                                  Sold Price(£)
                                </Typography>
                              </Grid>

                              <Grid item xl={3} lg={2} md={2} sm={3} xs={2.5}>
                                <Typography
                                  sx={{
                                    color: Colors.white,

                                    fontFamily: "Poppins",
                                    fontWeight: "500",
                                    fontSize: {
                                      lg: "16px",
                                      md: "12px",
                                      sm: "10px",
                                      xs: "8px",
                                    },
                                    textAlign: "center",
                                    width: "100%",
                                  }}
                                >
                                  Action
                                </Typography>
                              </Grid>
                            </Grid>
                          </Box>
                        )}
                      {searchIs &&
                        searchCustomerInvoice &&
                        selectedSearch?.toLowerCase() !== "checkout" &&
                        searchCustomerInvoice.length > 0 &&
                        searchCustomerInvoice?.map((invoice, ind) => {
                          //console.log(invoice, "invoice");
                          //console.log(allReturnProducts);
                          let fjc = allReturnProducts.find(
                            (e) =>
                              e.returnInvoiceRef &&
                              e.returnInvoiceRef.includes(invoice.invoiceNumber)
                          );
                          let pfjc = fjc?.productDetails;
                          let pIvoice = invoice?.productDetails;
                          //console.log(pIvoice, "pIvoice");
                          let item = invoice;
                          pIvoice?.map((e) => {
                            if (
                              pfjc?.length != 0 &&
                              pfjc?.find((j) => j?._id == e?._id)
                            ) {
                              //console.log(e, "plko[");
                              if (!e?.selected) {
                                e.selected = true;
                              }
                              if (!e?.returnStatus) {
                                e.returnStatus = pfjc?.filter(
                                  (j) => j?._id == e?._id
                                )?.[0]?.returnStatus;
                              }
                              if (!e?.reason) {
                                if (pfjc?.filter(
                                (j) => j?._id == e?._id
                              )?.[0]?.reason) {
                                  
                                e.reason = pfjc?.filter(
                                (j) => j?._id == e?._id
                              )?.[0]?.reason||"";
                                }
                              }
                              if (!e?.DamageQty) {
                                if (pfjc?.filter(
                                  (j) => j?._id == e?._id
                                )?.[0]?.DamageQty) {
                                  e.DamageQty = pfjc?.filter(
                                  (j) => j?._id == e?._id
                                )?.[0]?.DamageQty;
                                }
                              }
                              return e;
                            } else {
                              return e;
                            }
                          });
                          invoice.productDetails = pIvoice;
                          // fjc.productDetails = invoice?.productDetails
                          //console.log(fjc, "fjc");
                          return pIvoice
                            ?.filter((e) => e?.is == true)
                            ?.map((e, i) => {
                              return (
                                <Grid
                                  container
                                  xs={12}
                                  sm={12}
                                  md={12}
                                  sx={{
                                    backgroundColor: highlightP?.includes(
                                      e?._id
                                    )
                                      ? "rgba(0,0,0,0.2)"
                                      : Colors.white,
                                    padding: "10px 0px 10px 0px",
                                  }}
                                >
                                  <Grid
                                    item
                                    xl={4.5}
                                    lg={4}
                                    md={4}
                                    sm={4.5}
                                    xs={4}
                                  >
                                    <Box
                                      sx={{
                                        display: "flex",
                                        justifyContent: "row",
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          display: "flex",
                                          flexDirection: "column",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <div>
                                          <Typography
                                            sx={{
                                              fontSize: "12px",
                                              fontFamily: "Poppins",
                                              color: Colors.black,
                                              fontWeight: "bold",
                                              textAlign: "left",
                                            }}
                                          >
                                            Invoice No:{" "}
                                            <span>
                                              {invoice?.invoiceNumber}
                                            </span>
                                            <span style={{color:Colors.button}}>
                                              {invoice?.vatAmount?" (VAT)":""}{" "}
                                            </span>
                                            <span style={{color:Colors.button}}>
                                              {invoice?.SDAmount?" (SD)":""}{" "}
                                            </span>
                                          </Typography>

                                          <Typography
                                            sx={{
                                              fontSize: "12px",
                                              fontFamily: "Poppins",
                                              color: Colors.text,
                                              fontWeight: "500",
                                              textAlign: "left",
                                            }}
                                          >
                                            Date/Time:{" "}
                                            <span>
                                              {" "}
                                              {invoice?.exchangeDate
                                                ? new Date(
                                                    invoice?.exchangeDate
                                                  ).toLocaleDateString(
                                                    "en-GB",
                                                    {
                                                      day: "2-digit",
                                                      month: "2-digit",
                                                      year: "numeric",
                                                    }
                                                  )
                                                : new Date(
                                                    invoice?.saleDate
                                                  ).toLocaleDateString(
                                                    "en-GB",
                                                    {
                                                      day: "2-digit",
                                                      month: "2-digit",
                                                      year: "numeric",
                                                    }
                                                  )}{" "}
                                              {invoice?.exchangeDate
                                                ? new Date(
                                                    invoice?.exchangeDate
                                                  ).toLocaleTimeString()
                                                : new Date(
                                                    invoice?.saleDate
                                                  ).toLocaleTimeString()}{" "}
                                            </span>
                                          </Typography>
                                        </div>
                                        <Typography
                                          sx={{
                                            color: "background: #000",
                                            fontFamily: "Poppins",
                                            fontWeight: "600",
                                            fontSize: {
                                              lg: "14px",
                                              md: "10px",
                                              sm: "8px",
                                              xs: "6px",
                                            },
                                            textAlign: "left",
                                          }}
                                        >
                                          {e?.productName}
                                        </Typography>

                                        {typeof e?.IMEI == "object" ? (
                                          <View>
                                            {e?.IMEI?.map((it, ind) => {
                                              return (
                                                <View>
                                                  <Text
                                                    style={{
                                                      fontFamily: "Poppins",
                                                      fontSize: 12,
                                                    }}
                                                  >
                                                    {it},{" "}
                                                  </Text>
                                                </View>
                                              );
                                            })}
                                          </View>
                                        ) : (
                                          <Text
                                            style={{
                                              fontFamily: "Poppins",
                                              fontSize: 12,
                                            }}
                                          >
                                            {e?.IMEI}
                                          </Text>
                                        )}
                                        {/* <Typography
                                        sx={{
                                          color: "background: #939598",
                                          fontFamily: "Poppins",
                                          fontWeight: "500",
                                          fontSize: {
                                            lg: "12px",
                                            md: "10px",
                                            sm: "8px",
                                            xs: "6px",
                                          },
                                          textAlign: "left",
                                        }}
                                      >
                                        Category: {e?.category}
                                      </Typography> */}
                                      </Box>
                                    </Box>
                                  </Grid>

                                  <Grid
                                    item
                                    xl={1}
                                    lg={2}
                                    md={2}
                                    sm={1.5}
                                    xs={1.5}
                                    sx={{
                                      display: "flex",
                                      //   border:"1px solid red",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        display: "flex",
                                        marginRight: "10px",
                                        // border:"1px solid red",
                                        //   justifyContent: "space-between",
                                        width: "100%",
                                        //   border: "1px solid red",
                                      }}
                                    >
                                      <button
                                        onClick={() =>
                                          handleDecreaseProduct2(item, e)
                                        }
                                        style={{
                                          width: width < 600 ? "25px" : "35px",
                                          padding: "0px 0px 0px 0px",
                                          height: width < 600 ? "25px" : "35px",
                                          borderRadius: "5px",
                                          marginRight: "10px",
                                          backgroundColor: Colors.white,
                                          fontFamily: "Poppins",
                                          fontWeight: "bold",
                                          border: `1px solid ${Colors?.border}`,
                                        }}
                                      >
                                        -
                                      </button>
                                      <TextField
                                        variant="standard"
                                        margin="normal"
                                        required
                                        value={
                                          e?.DamageQty
                                            ? e?.DamageQty
                                            : e?.saleQty
                                        }
                                        onChange={(newValue) =>
                                          handleUpdateProduct(item, e._id, {
                                            DamageQty: newValue.target.value,
                                          })
                                        }
                                        fullWidth
                                        InputProps={{
                                          disableUnderline: true,
                                          fontSize: "12px",
                                          style: {
                                            textAlign: "center",
                                            fontSize: "16px",
                                            alignSelf: "center",
                                          },
                                        }}
                                        inputProps={{
                                          disableUnderline: true,
                                          fontSize: "12px",
                                          style: {
                                            textAlign: "center",
                                            fontSize: "16px",
                                            alignSelf: "center",
                                          },
                                        }}
                                        placeholder="Price"
                                        sx={{
                                          width: width < 600 ? "25px" : "35px",
                                          height: width < 600 ? "25px" : "35px",
                                          fontSize: "12px",
                                          padding: 0,
                                          border: `1px solid ${Colors.border}`,
                                          borderRadius: "5px",
                                          textAlign: "center", // Move textAlign to sx

                                          fontFamily: "Poppins",
                                          fontWeight: "bold",
                                          margin: 0,
                                        }}
                                      />
                                    </Box>
                                  </Grid>

                                  <Grid
                                    item
                                    xl={1}
                                    lg={1}
                                    md={0.5}
                                    sm={0.5}
                                    xs={1}
                                    sx={{
                                      display: "flex",
                                      // border:"1px solid red",
                                      // justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        color: Colors.text,
                                        fontFamily: "Poppins",
                                        fontWeight: "600",
                                        fontSize: width < 600 ? "10px" : "12px",
                                        // border: `1px solid ${Colors.border}`,
                                        padding: "4px",
                                        // width: width < 600 ? "25px" : "35px",
                                        padding: "0px 0px 0px 0px",
                                        // height: width < 600 ? "25px" : "35px",
                                        display: "flex",
                                      }}
                                    >
                                      <TextField
                                        variant="standard" // <== changed this
                                        margin="normal"
                                        value={e?.returnQty ? e?.returnQty : 0}
                                        required
                                        fullWidth
                                        InputProps={{
                                          disableUnderline: true,
                                          fontSize: "12px",
                                          style: {
                                            textAlign: "center",
                                            fontSize: "16px",
                                            alignSelf: "center",
                                          },
                                        }}
                                        inputProps={{
                                          disableUnderline: true,
                                          fontSize: "12px",
                                          style: {
                                            textAlign: "center",
                                            fontSize: "16px",
                                            alignSelf: "center",
                                          },
                                        }}
                                        placeholder="Price"
                                        sx={{
                                          width: width < 600 ? "25px" : "35px",
                                          height: width < 600 ? "25px" : "35px",
                                          fontSize: "12px",
                                          padding: 0,
                                          border: `1px solid ${Colors.border}`,
                                          borderRadius: "5px",
                                          textAlign: "center", // Move textAlign to sx

                                          fontFamily: "Poppins",
                                          fontWeight: "bold",
                                          margin: 0,
                                        }}
                                      />
                                    </Box>
                                  </Grid>
                                  <Grid
                                    item
                                    xl={1}
                                    lg={1.5}
                                    md={1}
                                    sm={1.5}
                                    xs={2}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      // border:"1px solid red"
                                    }}
                                  >
                                    <div style={{ fontWeight: "400" }}>£ </div>{" "}
                                    <TextField
                                      variant="standard" // <== changed this
                                      margin="normal"
                                      value={e?.basecurrentPrice}
                                      required
                                      fullWidth
                                      InputProps={{
                                        // startAdornment: <AccountCircle />, // <== adjusted this
                                        disableUnderline: true,
                                        fontSize: "12px",

                                        // <== added this
                                        // fontSize: "2px"
                                      }}
                                      placeholder="Search Current Price..."
                                      sx={{
                                        width: "90%",
                                        fontSize: "12px",
                                        padding: 0,
                                        fontFamily: "Poppins",
                                        fontWeight: "bold",
                                        margin: 0,
                                      }}
                                    />
                                  </Grid>

                                  <Grid
                                    item
                                    xl={1}
                                    lg={1}
                                    md={1}
                                    sm={1.5}
                                    xs={2}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      // border:"1px solid red"
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        color: Colors.text,
                                        fontFamily: "Poppins",
                                        fontWeight: "600",
                                        fontSize: width < 600 ? "10px" : "12px",
                                        border: `1px solid ${Colors.border}`,
                                        padding: "4px",
                                        width: width < 600 ? "70px" : "100px",
                                        display: "flex",
                                      }}
                                    >
                                      <TextField
                                        variant="standard" // <== changed this
                                        margin="normal"
                                        value={
                                          e?.discountPrice
                                            ? Number(e?.discountPrice)
                                            : invoice.customerDetails[0]
                                                ?.priceLevel[0]?.id == 1
                                            ? Number(e?.trade_price)
                                            : invoice.customerDetails[0]
                                                ?.priceLevel[0]?.id == 2
                                            ? Number(e?.warehouse_price)
                                            : invoice.customerDetails[0]
                                                ?.priceLevel[0]?.id == 4
                                            ? Number(e?.diamond)
                                            : Number(e?.retail_price)
                                        }
                                        onChange={(text) =>
                                          handleDiscountPrice2(
                                            invoice,
                                            text.target.value,
                                            e
                                          )
                                        }
                                        required
                                        fullWidth
                                        InputProps={{
                                          // startAdornment: <AccountCircle />, // <== adjusted this
                                          disableUnderline: true,
                                          fontSize: "12px",

                                          // <== added this
                                          // fontSize: "2px"
                                        }}
                                        placeholder="Search Product/Customer/Invoice"
                                        sx={{
                                          width: "90%",
                                          fontSize: "12px",
                                          padding: 0,
                                          fontFamily: "Poppins",
                                          fontWeight: "bold",
                                          margin: 0,
                                        }}
                                      />
                                    </Box>
                                  </Grid>
                                  <Grid
                                    item
                                    xl={3}
                                    lg={2}
                                    md={2}
                                    sm={3}
                                    xs={2.5}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "space-around",
                                      alignItems: "center",
                                      width: "100%",
                                      // border:"1px solid red"
                                    }}
                                  >
                                    {/* {(userData?.role?.toLowerCase() == "admin" ||
                                    userData?.role_access?.some(
                                      (e, i) =>
                                        e.name.toLowerCase() ==
                                          "showcostprice" && e?.selected
                                    )) && (
                                    <Box>
                                      {refHover?.hover && refHover.ind == i && (
                                        <Typography
                                          sx={{ textAlign: "center" }}
                                        >
                                          {e?.cost_price}.000
                                        </Typography>
                                      )}

                                      <Button
                                        onClick={() => {
                                          setRefHover({
                                            hover: !refHover?.hover,
                                            ind: i,
                                          });
                                        }}
                                        sx={{
                                          fontFamily: "Poppins",
                                          fontSize: "12px",
                                          marginLeft: 1,
                                          display: { xs: "none", sm: "block" },
                                          border: `1px solid ${Colors.border}`,
                                          borderRadius: 1,
                                        }}
                                      >
                                        Ref
                                      </Button>
                                    </Box>
                                  )} */}

                                    <BasicSelect
                                      value={
                                        e?.returnStatus
                                          ? e?.returnStatus
                                          : "select"
                                      }
                                      status="Select"
                                      id={productStatus}
                                      width={"120px"}
                                      onChange={(newValue) =>
                                        handleUpdateProduct(item, e._id, {
                                          returnStatus: newValue,
                                        })
                                      }
                                    />
                                    {/* <Input
                                  value={e.reason}
                                  // style={{width:100}}
                                  onChange={(l) =>
                                  handleUpdateProduct(item, e._id, { reason: l.target.value })
                                  }
                                  placeholder="Reason"
                                /> */}
                                    <Autocomplete
                                      freeSolo
                                      options={
                                        e?.returnStatus ==
                                        "Unused/Change of mind"
                                          ? [
                                              "No Longer Needed",
                                              "Expensive Price",
                                              "Wrong Product Inside",
                                              "Other",
                                            ]
                                          : e?.returnStatus == "Faulty"
                                          ? [
                                              "Touch Not Wokring",
                                              "LCD Blank",
                                              "Lines on LCD",
                                              "Signal issue",
                                              "Slow charging",
                                              "Other",
                                            ]
                                          : e?.returnStatus == "Damaged"
                                          ? [
                                              "Physical damage",
                                              "LCD flex damage",
                                              "Other",
                                            ]
                                          : []
                                      }
                                      value={e?.reason || ""}
                                      onChange={(event, newValue) =>
                                        handleUpdateProduct(item, e._id, {
                                          reason: newValue,
                                        })
                                      }
                                      onInputChange={(event, newInputValue) =>
                                        handleUpdateProduct(item, e._id, {
                                          reason: newInputValue,
                                        })
                                      }
                                      renderInput={(params) => (
                                        <TextField {...params} label="Reason" />
                                      )}
                                    />
                                    {/* 
                                                                {e?.IMEI && Array?.isArray(e?.IMEI) && e?.IMEI?.length > 0 && <Button
                                                                    sx={{
                                                                        fontFamily: "Poppins",
                                                                        fontSize: "12px",
                                                                        marginLeft: 1,
                                                                        display: { xs: "none", sm: "block" },
                                                                        border: `1px solid ${Colors.border}`,
                                                                        borderRadius: 1,
                                                                    }}
                                                                >
                                                                    Show Imei
                                                                </Button>} */}

                                    <Checkbox
                                      onClick={() => {
                                        //console.log(item, "item", e);
                                       !e.selected&& handleSelectProduct2(e, item);
                                      }}
                                      color={
                                        e.selected ? Colors.white : Colors.black
                                      }
                                      style={{
                                        backgroundColor: e.selected
                                          ? Colors.button
                                          : Colors.white,
                                        // marginLeft: 10,
                                      }}
                                      data={e}
                                    />
                                  </Grid>
                                </Grid>
                              );
                            });
                        })}
                    </Box>
                  </Grid>
                </Box>
              ) : customerInvoice ? (
                <Box
                  sx={{
                    width: "100%",
                    backgroundColor: Colors.white,
                    marginTop: "10px",
                    borderRadius: "5px",
                  }}
                >
                  <Grid xs={12}>
                    <Box
                      sx={{
                        display: "flex",
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        fontFamily: "Poppins",
                        fontSize: "14px",
                        fontWeight: "bold",
                      }}
                    >
                      <Box style={{ display: "flex", flexDirection: "row" }}>
                        {" "}
                        Account No :{" "}
                        <span style={{ marginLeft: 5 }}>
                          {" "}
                          {selectedCustomer?.accountNo}
                        </span>
                      </Box>
                      <Box style={{ display: "flex", flexDirection: "row" }}>
                        {" "}
                        Business Name :{" "}
                        <span style={{ marginLeft: 5 }}>
                          {" "}
                          {selectedCustomer?.businessName}
                        </span>
                      </Box>

                      <Box style={{ display: "flex", flexDirection: "row" }}>
                        {" "}
                        Customer Name :{" "}
                        <span style={{ marginLeft: 5 }}>
                          {" "}
                          {selectedCustomer?.customerName}
                        </span>
                      </Box>

                      <Box
                        style={{ display: "flex", flexDirection: "row", m: 0 }}
                      >
                        {" "}
                        Customer Email :{" "}
                        <span style={{ marginLeft: 5 }}>
                          {" "}
                          {selectedCustomer?.email}
                        </span>
                      </Box>

                      <Box
                        style={{ display: "flex", flexDirection: "row", m: 0 }}
                      >
                        {" "}
                        Invoice Balance :{" "}
                        <span style={{ marginLeft: 5 }}>
                          {" "}
                          £
                          {selectedCustomer?.creditBalance
                            ? Number(selectedCustomer?.creditBalance).toFixed(2)
                            : 0}
                        </span>
                      </Box>

                      <Box
                        style={{ display: "flex", flexDirection: "row", m: 0 }}
                      >
                        {" "}
                        Quotation Balance :{" "}
                        <span style={{ marginLeft: 5 }}>
                          {" "}
                          £
                          {/* {selectedCustomer?.quotationBalance
                            ? Number(
                                selectedCustomer?.quotationBalance
                              ).toFixed(2)
                            : 0} */}
                          {(customerLedger[customerLedger.length - 1]
                            ?.runningBalance - selectedCustomer?.creditBalance)?.toFixed(2)}
                        </span>
                      </Box>

                      {selectedCustomer?.comment && (
                        <Box
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            m: 0,
                            textAlign: "left",
                          }}
                        >
                          {" "}
                          Comment:{" "}
                          <span
                            style={{
                              marginLeft: 5,
                              fontSize: "12px",
                              fontWeight: "800",
                              fontFamily: "Poppins",
                              textAlign: "left",
                              color: "red",
                            }}
                          >
                            {" "}
                            {selectedCustomer?.comment}
                          </span>
                        </Box>
                      )}

                      <Box
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          m: 0,
                          alignItems: "center",
                          textAlign: "left",
                        }}
                      >
                        {" "}
                        Delivery Address:{" "}
                        <span
                          style={{
                            marginLeft: 5,
                            fontSize: "12px",
                            fontWeight: "800",
                            fontFamily: "Poppins",
                            textAlign: "left",
                            color: "purple",
                          }}
                        >
                          {" "}
                          {selectedCustomer?.deliveryAddress
                            ? selectedCustomer?.deliveryAddress
                            : selectedCustomer?.address}
                        </span>
                      </Box>

                      {!searchIs &&
                        customerInvoice &&
                        selectedSearch?.toLowerCase() !== "checkout" &&
                        customerInvoice.length > 0 &&
                        customerInvoice?.map((invoice, ind) => {
                          //console.log(invoice, "invoice");
                          //console.log(allReturnProducts);
                          // let fjc = allReturnProducts.find(
                          //   (e) =>
                          //     e.returnInvoiceRef &&
                          //     e.returnInvoiceRef.includes(invoice.invoiceNumber)
                          // );
                          // let pfjc = fjc?.productDetails;
                          // let pIvoice = invoice?.productDetails;
                          // pIvoice.map((e) => {
                          //   if (
                          //     pfjc?.length != 0 &&
                          //     pfjc?.find((j) => j?._id == e?._id)
                          //   ) {
                          //     if (!e?.selected) {
                          //       e.selected = true;
                          //     }
                          //     if (!e?.returnStatus) {
                          //       e.returnStatus = pfjc?.filter(
                          //         (j) => j?._id == e?._id
                          //       )?.[0]?.returnStatus;
                          //     }
                          //     if (!e?.reason) {
                          //       e.reason = pfjc?.filter(
                          //       (j) => j?._id == e?._id
                          //     )?.[0]?.reason||"";
                          //     }
                          //     if (!e?.DamageQty) {
                          //       e.DamageQty = pfjc?.filter(
                          //         (j) => j?._id == e?._id
                          //       )?.[0]?.DamageQty;
                          //     }
                          //     return e;
                          //   } else {
                          //     return e;
                          //   }
                          // });
                          // invoice.productDetails = pIvoice;

                          let fjc = allReturnProducts.find(
  (e) =>
    e.returnInvoiceRef &&
    e.returnInvoiceRef.includes(invoice.invoiceNumber)
);

let pfjc = fjc?.productDetails;
let pIvoice = invoice?.productDetails;

const updatedProducts = pIvoice.map((e) => {
  const matched = pfjc?.find((j) => j?._id == e?._id);

  if (pfjc?.length && matched) {
    return {
      ...e,
      selected: true,
      returnStatus: matched?.returnStatus,
      reason: matched?.reason || "",
      DamageQty: matched?.DamageQty,
    };
  }

  return e; // keep original if no match
});

invoice.productDetails = updatedProducts;
                          // fjc.productDetails = invoice?.productDetails
                          //console.log(fjc, "fjc");
                          return (
                            <Button
                              onClick={() => {
                                setSelectedInvoice(invoice);
                                //console.log(fjc, "insetSelectedInvoice(fjc)");
                              }}
                              sx={{
                                borderBottom: `1px solid ${Colors.border}`,
                                width: "100%",
                                alignItems: "center",
                                p: 0,
                                m: 0,
                              }}
                            >
                              <Grid
                                md={12}
                                xs={12}
                                sm={12}
                                container
                                sx={{ mt: 1 }}
                              >
                                <Grid item xs={6} sx={{ p: 1 }}>
                                  <Box sx={{ width: "100%" }}>
                                    <Typography
                                      sx={{
                                        fontSize: "14px",
                                        fontFamily: "Poppins",
                                        color: Colors.black,
                                        fontWeight: "bold",
                                        textAlign: "left",
                                      }}
                                    >
                                      {invoice?.saleDate && invoice?.vatAmount
                                        ? "Invoice No"
                                        : invoice?.saleDate &&
                                          !invoice?.vatAmount
                                        ? "Quotation No"
                                        : invoice?.exchangeDate &&
                                          Number(Math.abs(invoice?.vatAmount))
                                        ? "Exchange Invoice No"
                                        : "Exchange Quotation No"}
                                      : <span>{invoice?.invoiceNumber} </span>
                                       <span style={{color:Colors.button}}>
                                              {invoice?.vatAmount?" (VAT)":""}{" "}
                                            </span>
                                            <span style={{color:Colors.button}}>
                                              {invoice?.SDAmount?" (SD)":""}{" "}
                                            </span>
                                    </Typography>

                                    <Typography
                                      sx={{
                                        fontSize: "12px",
                                        fontFamily: "Poppins",
                                        color: Colors.text,
                                        fontWeight: "500",
                                        textAlign: "left",
                                      }}
                                    >
                                      Date/Time:{" "}
                                      <span>
                                        {invoice?.exchangeDate
                                          ? new Date(
                                              invoice?.exchangeDate
                                            ).toLocaleDateString("en-GB", {
                                              day: "2-digit",
                                              month: "2-digit",
                                              year: "numeric",
                                            })
                                          : new Date(
                                              invoice?.saleDate
                                            ).toLocaleDateString("en-GB", {
                                              day: "2-digit",
                                              month: "2-digit",
                                              year: "numeric",
                                            })}{" "}
                                        {invoice?.exchangeDate
                                          ? new Date(
                                              invoice?.exchangeDate
                                            ).toLocaleTimeString()
                                          : new Date(
                                              invoice?.saleDate
                                            ).toLocaleTimeString()}{" "}
                                      </span>
                                    </Typography>
                                  </Box>
                                </Grid>
                                <Grid
                                  item
                                  xs={3}
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: "14px",
                                      fontFamily: "Poppins",
                                      fontWeight: "bold",

                                      color: Array.isArray(
                                        invoice?.paymentMethod
                                      )
                                        ? invoice?.paymentMethod?.some(
                                            (e, i) =>
                                              typeof e == "string" &&
                                              e.toLowerCase() == "credit"
                                          )
                                          ? Colors.red
                                          : Colors.green
                                        : invoice?.paymentMethod?.toLowerCase() ==
                                          "credit"
                                        ? Colors.red
                                        : Colors.green,
                                    }}
                                  >
                                    {" "}
                                    {Array.isArray(invoice?.paymentMethod)
                                      ? invoice?.paymentMethod
                                          ?.map((e, i) => e)
                                          .join(",")
                                      : invoice?.paymentMethod}
                                  </Typography>
                                </Grid>

                                <Grid
                                  item
                                  xs={3}
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: "14px",
                                      fontFamily: "Poppins",
                                      color: Colors.black,
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {Number(invoice.subtotal).toFixed(2)}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Button>
                          );
                        })}
                      {searchIs && (
                        <Box sx={{ marginTop: "0px", width: "100%" }}>
                          <Grid
                            container
                            xs={12}
                            sx={{
                              backgroundColor: Colors.black,
                            }}
                          >
                            <Grid
                              item
                              xl={0.5}
                              lg={0.5}
                              md={1}
                              sm={0.8}
                              xs={0.5}
                            >
                              <Typography
                                sx={{
                                  color: Colors.white,
                                  fontFamily: "Poppins",
                                  fontWeight: "500",
                                  textAlign: "center",
                                  fontSize: { xs: "10px", sm: "16px" },
                                }}
                              >
                                item
                              </Typography>
                            </Grid>

                            <Grid item xl={3} lg={2.5} md={2.5} sm={3} xs={2.5}>
                              <Typography
                                sx={{
                                  color: Colors.white,
                                  fontFamily: "Poppins",
                                  fontWeight: "500",
                                  fontSize: {
                                    lg: "16px",
                                    md: "12px",
                                    sm: "10px",
                                    xs: "8px",
                                  },
                                  textAlign: "left",
                                }}
                              >
                                Product Description
                              </Typography>
                            </Grid>

                            <Grid item xl={1} lg={2} md={2} sm={1.5} xs={1.5}>
                              <Typography
                                sx={{
                                  color: Colors.white,
                                  fontFamily: "Poppins",
                                  fontWeight: "500",
                                  fontSize: {
                                    lg: "16px",
                                    md: "12px",
                                    sm: "10px",
                                    xs: "8px",
                                  },
                                  textAlign: "left",
                                }}
                              >
                                Quantity
                              </Typography>
                            </Grid>

                            <Grid item xl={1.5} lg={1.5} md={1} sm={1} xs={1.5}>
                              <Typography
                                sx={{
                                  color: Colors.white,
                                  fontFamily: "Poppins",
                                  fontWeight: "500",
                                  width: "100%",
                                  fontSize: {
                                    lg: "16px",
                                    md: "12px",
                                    sm: "10px",
                                    xs: "8px",
                                  },
                                  textAlign: { md: "center", lg: "left" },
                                }}
                              >
                                Return Qty
                              </Typography>
                            </Grid>

                            <Grid item xl={1} lg={1} md={1} sm={1.5} xs={2}>
                              <Typography
                                sx={{
                                  color: Colors.white,
                                  fontFamily: "Poppins",
                                  fontWeight: "500",
                                  fontSize: {
                                    lg: "16px",
                                    md: "12px",
                                    sm: "10px",
                                    xs: "8px",
                                  },
                                  textAlign: { md: "center", lg: "left" },
                                }}
                              >
                                Price(£)
                              </Typography>
                            </Grid>

                            <Grid item xl={4} lg={3} md={3} sm={4} xs={4}>
                              <Typography
                                sx={{
                                  color: Colors.white,

                                  fontFamily: "Poppins",
                                  fontWeight: "500",
                                  fontSize: {
                                    lg: "16px",
                                    md: "12px",
                                    sm: "10px",
                                    xs: "8px",
                                  },
                                  textAlign: "center",
                                  width: "100%",
                                }}
                              >
                                Action
                              </Typography>
                            </Grid>
                          </Grid>
                        </Box>
                      )}
                      {searchIs &&
                        customerInvoice &&
                        selectedSearch?.toLowerCase() !== "checkout" &&
                        customerInvoice.length > 0 &&
                        customerInvoice?.map((invoice, ind) => {
                          //console.log(invoice, "invoice");
                          //console.log(allReturnProducts);
                          let fjc = allReturnProducts.find(
                            (e) =>
                              e.returnInvoiceRef &&
                              e.returnInvoiceRef.includes(invoice.invoiceNumber)
                          );
                          let pfjc = fjc?.productDetails;
                          let pIvoice = invoice?.productDetails;
                         pIvoice.map((e) => {
                            if (
                              pfjc?.length != 0 &&
                              pfjc?.find((j) => j?._id == e?._id)
                            ) {
                              e.selected = true;
                              e.returnStatus = pfjc?.filter(
                                (j) => j?._id == e?._id
                              )?.[0]?.returnStatus;
                              e.reason = pfjc?.filter(
                                (j) => j?._id == e?._id
                              )?.[0]?.reason||"";
                               e.DamageQty = pfjc?.filter(
                                  (j) => j?._id == e?._id
                                )?.[0]?.DamageQty;
                              return e;
                            } else {
                              return e;
                            }
                          });
                          invoice.productDetails = pIvoice;
                          // fjc.productDetails = invoice?.productDetails
                          //console.log(fjc, "fjc");
                          return (
                            <Button
                              onClick={() => {
                                setSelectedInvoice(invoice);
                                //console.log(fjc, "insetSelectedInvoice(fjc)");
                              }}
                              sx={{
                                borderBottom: `1px solid ${Colors.border}`,
                                width: "100%",
                                alignItems: "center",
                                p: 0,
                                m: 0,
                              }}
                            >
                              <Grid
                                md={12}
                                xs={12}
                                sm={12}
                                container
                                sx={{ mt: 1 }}
                              >
                                <Grid item xs={6} sx={{ p: 1 }}>
                                  <Box sx={{ width: "100%" }}>
                                    <Typography
                                      sx={{
                                        fontSize: "14px",
                                        fontFamily: "Poppins",
                                        color: Colors.black,
                                        fontWeight: "bold",
                                        textAlign: "left",
                                      }}
                                    >
                                      {invoice?.saleDate && invoice?.vatAmount
                                        ? "Invoice No"
                                        : invoice?.saleDate &&
                                          !invoice?.vatAmount
                                        ? "Quotation No"
                                        : invoice?.exchangeDate &&
                                          Number(Math.abs(invoice?.vatAmount))
                                        ? "Exchange Invoice No"
                                        : "Exchange Quotation No"}
                                      : <span>{invoice?.invoiceNumber} </span>
                                       <span style={{color:Colors.button}}>
                                              {invoice?.vatAmount?" (VAT)":""}{" "}
                                            </span>
                                            <span style={{color:Colors.button}}>
                                              {invoice?.SDAmount?" (SD)":""}{" "}
                                            </span>
                                    </Typography>

                                    <Typography
                                      sx={{
                                        fontSize: "12px",
                                        fontFamily: "Poppins",
                                        color: Colors.text,
                                        fontWeight: "500",
                                        textAlign: "left",
                                      }}
                                    >
                                      Date/Time:{" "}
                                      <span>
                                        {invoice?.exchangeDate
                                          ? new Date(
                                              invoice?.exchangeDate
                                            ).toLocaleDateString("en-GB", {
                                              day: "2-digit",
                                              month: "2-digit",
                                              year: "numeric",
                                            })
                                          : new Date(
                                              invoice?.saleDate
                                            ).toLocaleDateString("en-GB", {
                                              day: "2-digit",
                                              month: "2-digit",
                                              year: "numeric",
                                            })}{" "}
                                        {invoice?.exchangeDate
                                          ? new Date(
                                              invoice?.exchangeDate
                                            ).toLocaleTimeString()
                                          : new Date(
                                              invoice?.saleDate
                                            ).toLocaleTimeString()}{" "}
                                      </span>
                                    </Typography>
                                  </Box>
                                </Grid>
                                <Grid
                                  item
                                  xs={3}
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: "14px",
                                      fontFamily: "Poppins",
                                      fontWeight: "bold",

                                      color: Array.isArray(
                                        invoice?.paymentMethod
                                      )
                                        ? invoice?.paymentMethod?.some(
                                            (e, i) =>
                                              typeof e == "string" &&
                                              e.toLowerCase() == "credit"
                                          )
                                          ? Colors.red
                                          : Colors.green
                                        : invoice?.paymentMethod?.toLowerCase() ==
                                          "credit"
                                        ? Colors.red
                                        : Colors.green,
                                    }}
                                  >
                                    {" "}
                                    {Array.isArray(invoice?.paymentMethod)
                                      ? invoice?.paymentMethod
                                          ?.map((e, i) => e)
                                          .join(",")
                                      : invoice?.paymentMethod}
                                  </Typography>
                                </Grid>

                                <Grid
                                  item
                                  xs={3}
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: "14px",
                                      fontFamily: "Poppins",
                                      color: Colors.black,
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {Number(invoice.subtotal).toFixed(2)}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Button>
                          );
                        })}
                    </Box>
                  </Grid>
                </Box>
              ) : (
                ""
              )}
            </Grid>

            {selectedSearch?.toLowerCase() == "checkout" &&
            allReturnProducts?.length > 0
              ? allReturnProducts?.map((item, index) => {
                  //console.log(item, "lop");
                  //console.log(allReturnProducts, "lop2");
                  return (
                    <Box
                      sx={{
                        backgroundColor: Colors.white,
                        border: `1px solid ${Colors.border}`,
                        width: "100%",
                        borderRadius: "5px",
                        boxSizing: "border-box",
                        padding: "0px 0px 0px 0px",
                      }}
                    >
                      <Box style={{ margin: "5px" }}>
                        <Typography
                          sx={{
                            fontFamily: "Poppins",
                            fontWeight: "bold",
                            color: Colors.red,
                            fontSize: "14px",
                          }}
                        >
                          Invoice Number : {item?.returnInvoiceRef}
                        </Typography>
                      </Box>

                      <Box sx={{ marginTop: "0px", width: "100%" }}>
                        <Grid
                          container
                          xs={12}
                          sx={{
                            backgroundColor: Colors.black,
                          }}
                        >
                          {/* <Grid item xl={0.5} lg={0.5} md={1} sm={0.8} xs={0.5}>
                            <Typography
                              sx={{
                                color: Colors.white,
                                fontFamily: "Poppins",
                                fontWeight: "500",
                                textAlign: "center",
                                fontSize: { xs: "10px", sm: "16px" },
                              }}
                            >
                              item
                            </Typography>
                          </Grid> */}

                          <Grid item xl={5} lg={4.5} md={4.5} sm={5} xs={4.5}>
                            <Typography
                              sx={{
                                color: Colors.white,
                                fontFamily: "Poppins",
                                fontWeight: "500",
                                fontSize: {
                                  lg: "16px",
                                  md: "12px",
                                  sm: "10px",
                                  xs: "8px",
                                },
                                textAlign: "center",
                              }}
                            >
                              Product Description
                            </Typography>
                          </Grid>

                          <Grid item xl={1} lg={2} md={2} sm={1.5} xs={1.5}>
                            <Typography
                              sx={{
                                color: Colors.white,
                                fontFamily: "Poppins",
                                fontWeight: "500",
                                fontSize: {
                                  lg: "16px",
                                  md: "12px",
                                  sm: "10px",
                                  xs: "8px",
                                },
                                textAlign: "left",
                              }}
                            >
                              Quantity
                            </Typography>
                          </Grid>

                          <Grid item xl={1.5} lg={1.5} md={1} sm={1} xs={1.5}>
                            <Typography
                              sx={{
                                color: Colors.white,
                                fontFamily: "Poppins",
                                fontWeight: "500",
                                width: "100%",
                                fontSize: {
                                  lg: "16px",
                                  md: "12px",
                                  sm: "10px",
                                  xs: "8px",
                                },
                                textAlign: { md: "center", lg: "left" },
                              }}
                            >
                              Return Qty
                            </Typography>
                          </Grid>

                          <Grid item xl={1} lg={1} md={1} sm={1.5} xs={2}>
                            <Typography
                              sx={{
                                color: Colors.white,
                                fontFamily: "Poppins",
                                fontWeight: "500",
                                fontSize: {
                                  lg: "16px",
                                  md: "12px",
                                  sm: "10px",
                                  xs: "8px",
                                },
                                textAlign: { md: "center", lg: "left" },
                              }}
                            >
                              Price(£)
                            </Typography>
                          </Grid>

                          <Grid item xl={3} lg={2} md={2} sm={3} xs={2.5}>
                            <Typography
                              sx={{
                                color: Colors.white,

                                fontFamily: "Poppins",
                                fontWeight: "500",
                                fontSize: {
                                  lg: "16px",
                                  md: "12px",
                                  sm: "10px",
                                  xs: "8px",
                                },
                                textAlign: "center",
                                width: "100%",
                              }}
                            >
                              Action
                            </Typography>
                          </Grid>
                        </Grid>
                      </Box>

                      <Box
                        sx={{ marginTop: "0px", backgroundColor: Colors.white }}
                      >
                        {item?.productDetails &&
                        item?.productDetails?.length > 0 ? (
                          item?.productDetails?.map((e, i) => {
                            //console.log(highlightP?.includes(e?._id));
                            //console.log(highlightP);
                            //console.log(e?._id);
                            return (
                              <Grid
                                container
                                xs={12}
                                sm={12}
                                md={12}
                                sx={{
                                  backgroundColor: highlightP?.includes(e?._id)
                                    ? "rgba(0,0,0,0.2)"
                                    : Colors.white,
                                  padding: "10px 0px 10px 0px",
                                }}
                              >
                                {/* <Grid
                                  item
                                  xl={0.5}
                                  lg={0.5}
                                  md={1}
                                  sm={0.8}
                                  xs={0.5}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    // border:"1px solid red"
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      color: Colors.text,
                                      fontFamily: "Poppins",
                                      fontWeight: "600",
                                      fontSize: { xs: "10px", sm: "16px" },
                                    }}
                                  >
                                    {i + 1}
                                  </Typography>
                                </Grid> */}

                                <Grid
                                  item
                                  xl={5}
                                  lg={4.5}
                                  md={4.5}
                                  sm={5}
                                  xs={4.5}
                                >
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "row",
                                      marginLeft: 2,
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <Typography
                                        sx={{
                                          color: "background: #000",
                                          fontFamily: "Poppins",
                                          fontWeight: "600",
                                          fontSize: {
                                            lg: "16px",
                                            md: "12px",
                                            sm: "10px",
                                            xs: "8px",
                                          },
                                          textAlign: "left",
                                        }}
                                      >
                                        {e?.productName}
                                      </Typography>
                                      {typeof e?.IMEI == "object" ? (
                                        <View>
                                          {e?.IMEI?.map((it, ind) => {
                                            return (
                                              <View>
                                                <Text
                                                  style={{
                                                    fontFamily: "Poppins",
                                                    fontSize: 12,
                                                  }}
                                                >
                                                  {it},{" "}
                                                </Text>
                                              </View>
                                            );
                                          })}
                                        </View>
                                      ) : (
                                        <Text
                                          style={{
                                            fontFamily: "Poppins",
                                            fontSize: 12,
                                          }}
                                        >
                                          {e?.IMEI}
                                        </Text>
                                      )}
                                      {/* <Typography
                                        sx={{
                                          color: "background: #939598",
                                          fontFamily: "Poppins",
                                          fontWeight: "500",
                                          fontSize: {
                                            lg: "12px",
                                            md: "10px",
                                            sm: "8px",
                                            xs: "6px",
                                          },
                                          textAlign: "left",
                                        }}
                                      >
                                        Category: {e?.category}
                                      </Typography> */}
                                    </Box>
                                  </Box>
                                </Grid>

                                <Grid
                                  item
                                  xl={1}
                                  lg={2}
                                  md={2}
                                  sm={1.5}
                                  xs={1.5}
                                  sx={{
                                    display: "flex",
                                    //   border:"1px solid red",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <Box
                                    sx={{
                                      display: "flex",
                                      marginRight: "10px",
                                      // border:"1px solid red",
                                      //   justifyContent: "space-between",
                                      width: "100%",
                                      //   border: "1px solid red",
                                    }}
                                  >
                                    <TextField
                                      variant="standard"
                                      margin="normal"
                                      required
                                      value={
                                        e?.DamageQty ? e?.DamageQty : e?.saleQty
                                      }
                                      fullWidth
                                      InputProps={{
                                        disableUnderline: true,
                                        fontSize: "12px",
                                        style: {
                                          textAlign: "center",
                                          fontSize: "16px",
                                          alignSelf: "center",
                                        },
                                      }}
                                      inputProps={{
                                        disableUnderline: true,
                                        fontSize: "12px",
                                        style: {
                                          textAlign: "center",
                                          fontSize: "16px",
                                          alignSelf: "center",
                                        },
                                      }}
                                      placeholder="Price"
                                      sx={{
                                        width: width < 600 ? "25px" : "35px",
                                        height: width < 600 ? "25px" : "35px",
                                        fontSize: "12px",
                                        padding: 0,
                                        border: `1px solid ${Colors.border}`,
                                        borderRadius: "5px",
                                        textAlign: "center", // Move textAlign to sx

                                        fontFamily: "Poppins",
                                        fontWeight: "bold",
                                        margin: 0,
                                      }}
                                    />
                                  </Box>
                                </Grid>

                                <Grid
                                  item
                                  xl={1.5}
                                  lg={1.5}
                                  md={1}
                                  sm={1.5}
                                  xs={2}
                                  sx={{
                                    display: "flex",
                                    // border:"1px solid red",
                                    // justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <Box
                                    sx={{
                                      color: Colors.text,
                                      fontFamily: "Poppins",
                                      fontWeight: "600",
                                      fontSize: width < 600 ? "10px" : "12px",
                                      // border: `1px solid ${Colors.border}`,
                                      padding: "4px",
                                      // width: width < 600 ? "25px" : "35px",
                                      padding: "0px 0px 0px 0px",
                                      // height: width < 600 ? "25px" : "35px",
                                      display: "flex",
                                    }}
                                  >
                                    <TextField
                                      variant="standard" // <== changed this
                                      margin="normal"
                                      value={e?.returnQty ? e?.returnQty : 0}
                                      required
                                      fullWidth
                                      InputProps={{
                                        disableUnderline: true,
                                        fontSize: "12px",
                                        style: {
                                          textAlign: "center",
                                          fontSize: "16px",
                                          alignSelf: "center",
                                        },
                                      }}
                                      inputProps={{
                                        disableUnderline: true,
                                        fontSize: "12px",
                                        style: {
                                          textAlign: "center",
                                          fontSize: "16px",
                                          alignSelf: "center",
                                        },
                                      }}
                                      placeholder="Price"
                                      sx={{
                                        width: width < 600 ? "25px" : "35px",
                                        height: width < 600 ? "25px" : "35px",
                                        fontSize: "12px",
                                        padding: 0,
                                        border: `1px solid ${Colors.border}`,
                                        borderRadius: "5px",
                                        textAlign: "center", // Move textAlign to sx

                                        fontFamily: "Poppins",
                                        fontWeight: "bold",
                                        margin: 0,
                                      }}
                                    />
                                  </Box>
                                </Grid>
                                <Grid
                                  item
                                  xl={1}
                                  lg={1}
                                  md={1}
                                  sm={1.5}
                                  xs={2}
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    // border:"1px solid red"
                                  }}
                                >
                                  <Box
                                    sx={{
                                      color: Colors.text,
                                      fontFamily: "Poppins",
                                      fontWeight: "600",
                                      fontSize: width < 600 ? "10px" : "12px",
                                      border: `1px solid ${Colors.border}`,
                                      padding: "4px",
                                      width: width < 600 ? "70px" : "100px",
                                      display: "flex",
                                    }}
                                  >
                                    <TextField
                                      variant="standard" // <== changed this
                                      margin="normal"
                                      value={
                                        e?.discountPrice
                                          ? Number(e?.discountPrice).toFixed(2)
                                          : item.customerDetails?.priceLevel[0]
                                              ?.id == 1
                                          ? Number(e?.trade_price).toFixed(2)
                                          : item.customerDetails?.priceLevel[0]
                                              ?.id == 2
                                          ? Number(e?.warehouse_price).toFixed(
                                              2
                                            )
                                          : item.customerDetails?.priceLevel[0]
                                              ?.id == 4
                                          ? Number(e?.diamond).toFixed(2)
                                          : Number(e?.retail_price).toFixed(2)
                                      }
                                      required
                                      fullWidth
                                      InputProps={{
                                        // startAdornment: <AccountCircle />, // <== adjusted this
                                        disableUnderline: true,
                                        fontSize: "12px",

                                        // <== added this
                                        // fontSize: "2px"
                                      }}
                                      placeholder="Search Product/Customer/Invoice"
                                      sx={{
                                        width: "90%",
                                        fontSize: "12px",
                                        padding: 0,
                                        fontFamily: "Poppins",
                                        fontWeight: "bold",
                                        margin: 0,
                                      }}
                                    />
                                  </Box>
                                </Grid>
                                <Grid
                                  item
                                  xl={3.5}
                                  lg={2.5}
                                  md={2.5}
                                  sm={3.5}
                                  xs={3}
                                  sx={{
                                    display: "flex",
                                    justifyContent: "space-around",
                                    alignItems: "center",
                                    width: "100%",
                                    // border:"1px solid red"
                                  }}
                                >
                                  {(userData?.role?.toLowerCase() == "admin" ||
                                    userData?.role_access?.some(
                                      (e, i) =>
                                        e.name.toLowerCase() ==
                                          "showcostprice" && e?.selected
                                    )) && (
                                    <Box>
                                      {refHover?.hover && refHover.ind == i && (
                                        <Typography
                                          sx={{ textAlign: "center" }}
                                        >
                                          {e?.cost_price}.000
                                        </Typography>
                                      )}

                                      <Button
                                        onClick={() => {
                                          setRefHover({
                                            hover: !refHover?.hover,
                                            ind: i,
                                          });
                                        }}
                                        sx={{
                                          fontFamily: "Poppins",
                                          fontSize: "12px",
                                          marginLeft: 1,
                                          display: { xs: "none", sm: "block" },
                                          border: `1px solid ${Colors.border}`,
                                          borderRadius: 1,
                                        }}
                                      >
                                        Ref
                                      </Button>
                                    </Box>
                                  )}

                                  <BasicSelect
                                    value={
                                      e?.returnStatus
                                        ? e?.returnStatus
                                        : "select"
                                    }
                                    status="Select"
                                    id={productStatus}
                                    width={"100px"}
                                    // onChange={(j) => console.log(j)}
                                  />
                                  { (
                                    <Input
                                      value={e?.reason}
                                       style={{width:100}}
                                      // onChange={(i) =>
                                      //   changeProductReason(i.target.value, e)
                                      // }
                                      placeholder="Reason"
                                    />
                                  )}

                                  {/* 
                                                                {e?.IMEI && Array?.isArray(e?.IMEI) && e?.IMEI?.length > 0 && <Button
                                                                    sx={{
                                                                        fontFamily: "Poppins",
                                                                        fontSize: "12px",
                                                                        marginLeft: 1,
                                                                        display: { xs: "none", sm: "block" },
                                                                        border: `1px solid ${Colors.border}`,
                                                                        borderRadius: 1,
                                                                    }}
                                                                >
                                                                    Show Imei
                                                                </Button>} */}

                                  {/* <Checkbox
                                    onClick={() => handleSelectProduct(e)}
                                    color={
                                      e.selected ? Colors.white : Colors.black
                                    }
                                    style={{
                                      backgroundColor: e.selected
                                        ? Colors.button
                                        : Colors.white,
                                      // marginLeft: 10,
                                    }}
                                    data={e}
                                  /> */}
                                  <div
                                    style={{ cursor: "pointer",color:"blue" }}
                                    onClick={() => PrintReturnLabel(e)}
                                  >
                                    Print
                                  </div>
                                    <Box
                                        sx={{
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                        }}
                                        onClick={() => RemoveProduct(item?.returnInvoiceRef,e._id)}
                                      >
                                        <img
                                          src={require("../Images/delete.png")}
                                          style={{ height: "25px" }}
                                        />
                                      </Box>
                                </Grid>
                              </Grid>
                            );
                          })
                        ) : (
                          <Box
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "center",
                              alignItems: "center",
                              padding: 10,
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: "24px",
                                fontFamily: "Poppins",
                                fontWeight: "bold",
                              }}
                            >
                              No Product Added
                            </Typography>
                          </Box>
                        )}

                        {selectedInvoice?.returnProductDetails &&
                        selectedInvoice?.returnProductDetails?.length > 0
                          ? selectedInvoice?.returnProductDetails?.map(
                              (e, i) => {
                                return (
                                  <Grid
                                    container
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    sx={{
                                      backgroundColor: Colors.white,
                                      padding: "10px 0px 10px 0px",
                                    }}
                                  >
                                    <Grid
                                      item
                                      xl={0.8}
                                      lg={0.8}
                                      md={1}
                                      sm={0.8}
                                      xs={0.5}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <Typography
                                        sx={{
                                          color: Colors.text,
                                          fontFamily: "Poppins",
                                          fontWeight: "600",
                                          fontSize: { xs: "10px", sm: "16px" },
                                        }}
                                      >
                                        {i +
                                          1 +
                                          selectedInvoice?.productDetails
                                            ?.length}
                                      </Typography>
                                    </Grid>

                                    <Grid
                                      item
                                      xl={3}
                                      lg={2.5}
                                      md={2.5}
                                      sm={3}
                                      xs={2.5}
                                    >
                                      <Box
                                        sx={{
                                          display: "flex",
                                          justifyContent: "row",
                                        }}
                                      >
                                        <Box
                                          sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                          }}
                                        >
                                          <Typography
                                            sx={{
                                              color: "background: #000",
                                              fontFamily: "Poppins",
                                              fontWeight: "600",
                                              fontSize: {
                                                lg: "16px",
                                                md: "12px",
                                                sm: "10px",
                                                xs: "8px",
                                              },
                                              textAlign: "left",
                                            }}
                                          >
                                            {e?.productName}
                                          </Typography>
                                          {typeof e?.IMEI == "object" ? (
                                            <View>
                                              {e?.IMEI?.map((it, ind) => {
                                                return (
                                                  <View>
                                                    <Text
                                                      style={{
                                                        fontFamily: "Poppins",
                                                        fontSize: 12,
                                                      }}
                                                    >
                                                      {it},{" "}
                                                    </Text>
                                                  </View>
                                                );
                                              })}
                                            </View>
                                          ) : (
                                            <Text
                                              style={{
                                                fontFamily: "Poppins",
                                                fontSize: 12,
                                              }}
                                            >
                                              {e?.IMEI}
                                            </Text>
                                          )}
                                          <Typography
                                            sx={{
                                              color: "background: #939598",
                                              fontFamily: "Poppins",
                                              fontWeight: "500",
                                              fontSize: {
                                                lg: "12px",
                                                md: "10px",
                                                sm: "8px",
                                                xs: "6px",
                                              },
                                              textAlign: "left",
                                            }}
                                          >
                                            Category: {e?.category}
                                          </Typography>
                                        </Box>
                                      </Box>
                                    </Grid>

                                    <Grid
                                      item
                                      xl={1.5}
                                      lg={2}
                                      md={2}
                                      sm={1.5}
                                      xs={1.5}
                                      sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          display: "flex",
                                          //   justifyContent: "space-between",
                                          width: "100%",
                                          //   border: "1px solid red",
                                        }}
                                      >
                                        <TextField
                                          variant="standard"
                                          margin="normal"
                                          required
                                          // onChange={(e) =>
                                          //     changeDamageQty(e.target.value, i, "exchange")
                                          // }
                                          value={
                                            e?.DamageQty
                                              ? `-${e?.DamageQty}`
                                              : `-${e?.saleQty}`
                                          }
                                          fullWidth
                                          InputProps={{
                                            disableUnderline: true,
                                            fontSize: "12px",
                                            style: {
                                              textAlign: "center",
                                              fontSize: "16px",
                                              alignSelf: "center",
                                            },
                                          }}
                                          inputProps={{
                                            disableUnderline: true,
                                            fontSize: "12px",
                                            style: {
                                              textAlign: "center",
                                              fontSize: "16px",
                                              alignSelf: "center",
                                            },
                                          }}
                                          placeholder="Quantity"
                                          sx={{
                                            width:
                                              width < 600 ? "25px" : "35px",
                                            height:
                                              width < 600 ? "25px" : "35px",
                                            fontSize: "12px",
                                            padding: 0,
                                            border: `1px solid ${Colors.border}`,
                                            borderRadius: "5px",
                                            textAlign: "center", // Move textAlign to sx

                                            fontFamily: "Poppins",
                                            fontWeight: "bold",
                                            margin: 0,
                                          }}
                                        />
                                      </Box>
                                    </Grid>
                                    <Grid
                                      item
                                      xl={1.5}
                                      lg={1.5}
                                      md={1}
                                      sm={1.5}
                                      xs={2}
                                      sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                      }}
                                    >
                                      <TextField
                                        variant="standard" // <== changed this
                                        margin="normal"
                                        value={
                                          item.customerDetails[0]?.priceLevel[0]
                                            ?.id == 1
                                            ? e?.current_tradeprice
                                            : item.customerDetails[0]
                                                ?.priceLevel[0]?.id == 2
                                            ? e?.current_warehouseprice
                                            : item.customerDetails[0]
                                                ?.priceLevel[0]?.id == 4
                                            ? e?.current_diamond
                                            : e?.current_retailprice
                                        }
                                        required
                                        fullWidth
                                        InputProps={{
                                          // startAdornment: <AccountCircle />, // <== adjusted this
                                          disableUnderline: true,
                                          fontSize: "12px",

                                          // <== added this
                                          // fontSize: "2px"
                                        }}
                                        placeholder="Search Current Price..."
                                        sx={{
                                          width: "90%",
                                          fontSize: "12px",
                                          padding: 0,
                                          fontFamily: "Poppins",
                                          fontWeight: "bold",
                                          margin: 0,
                                        }}
                                      />
                                    </Grid>

                                    <Grid
                                      item
                                      xl={1.5}
                                      lg={1.5}
                                      md={1}
                                      sm={1.5}
                                      xs={2}
                                      sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          color: Colors.text,
                                          fontFamily: "Poppins",
                                          fontWeight: "600",
                                          fontSize:
                                            width < 600 ? "10px" : "12px",
                                          border: `1px solid ${Colors.border}`,
                                          padding: "4px",
                                          width: width < 600 ? "70px" : "100px",
                                          display: "flex",
                                        }}
                                      >
                                        <TextField
                                          variant="standard" // <== changed this
                                          margin="normal"
                                          value={`-${
                                            Number(e?.discountPrice)
                                              ? e?.discountPrice
                                              : item.customerDetails[0]
                                                  ?.priceLevel[0]?.id == 1
                                              ? e?.trade_price
                                              : item.customerDetails[0]
                                                  ?.priceLevel[0]?.id == 2
                                              ? e?.warehouse_price
                                              : item.customerDetails[0]
                                                  ?.priceLevel[0]?.id == 4
                                              ? e?.diamond
                                              : e?.retail_price
                                          }`}
                                          onChange={(text) =>
                                            handleDiscountPrice(
                                              text.target.value,
                                              e
                                            )
                                          }
                                          required
                                          fullWidth
                                          InputProps={{
                                            // startAdornment: <AccountCircle />, // <== adjusted this
                                            disableUnderline: true,
                                            fontSize: "12px",

                                            // <== added this
                                            // fontSize: "2px"
                                          }}
                                          placeholder="Search Product/Customer/Invoice"
                                          sx={{
                                            width: "90%",
                                            fontSize: "12px",
                                            padding: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: "bold",
                                            margin: 0,
                                          }}
                                        />
                                      </Box>
                                    </Grid>
                                    <Grid
                                      item
                                      xl={3}
                                      lg={3}
                                      md={3}
                                      sm={4}
                                      xs={3.5}
                                      sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                        }}
                                        onClick={() => handleDeleteProduct(e)}
                                      >
                                        <img
                                          src={require("../Images/delete.png")}
                                          style={{ height: "25px" }}
                                        />
                                      </Box>
                                      {userData?.show_price && (
                                        <Box>
                                          {refHover?.hover &&
                                            refHover.ind ==
                                              i +
                                                item?.productDetails
                                                  ?.length && (
                                              <Typography
                                                sx={{ textAlign: "center" }}
                                              >
                                                {e?.current_costprice}.00
                                              </Typography>
                                            )}

                                          <Button
                                            onMouseEnter={() =>
                                              setRefHover({
                                                hover: true,
                                                ind:
                                                  i +
                                                  item?.productDetails?.length,
                                              })
                                            }
                                            onMouseLeave={() =>
                                              setRefHover({
                                                hover: false,
                                              })
                                            }
                                            sx={{
                                              fontFamily: "Poppins",
                                              fontSize: "12px",
                                              marginLeft: 1,
                                              display: {
                                                xs: "none",
                                                sm: "block",
                                              },
                                              border: `1px solid ${Colors.border}`,
                                              borderRadius: 1,
                                            }}
                                          >
                                            Ref
                                          </Button>
                                        </Box>
                                      )}

                                      {/* <Checkbox onClick={() => handleSelectProduct(e)} color={e.selected ? Colors.white : Colors.black} style={{ backgroundColor: e.selected ? Colors.button : Colors.white, marginLeft: 10 }} data={e} /> */}
                                    </Grid>
                                  </Grid>
                                );
                              }
                            )
                          : ""}
                      </Box>
                    </Box>
                  );
                })
              : selectedInvoice && (
                  <Box
                    sx={{
                      backgroundColor: Colors.white,
                      border: `1px solid ${Colors.border}`,
                      width: "100%",
                      borderRadius: "5px",
                      boxSizing: "border-box",
                      padding: "0px 0px 0px 0px",
                    }}
                  >
                    <Box sx={{ marginTop: "0px", width: "100%" }}>
                      <Grid
                        container
                        xs={12}
                        sx={{
                          backgroundColor: Colors.black,
                          display: "flex",
                          alignItems: "center",
                          //   padding: "10px 0px 10px 0px",
                          // border:"2px solid purple"
                        }}
                      >
                        {/* <Grid item xl={0.5} lg={0.5} md={1} sm={0.8} xs={0.5}>
                          <Typography
                            sx={{
                              color: Colors.white,
                              fontFamily: "Poppins",
                              fontWeight: "500",
                              textAlign: "center",
                              fontSize: { xs: "10px", sm: "16px" },
                            }}
                          >
                            item
                          </Typography>
                        </Grid> */}

                        <Grid item xl={4} lg={3.5} md={3.5} sm={4} xs={3.5}>
                          <Typography
                            sx={{
                              color: Colors.white,
                              fontFamily: "Poppins",
                              fontWeight: "500",
                              fontSize: {
                                lg: "16px",
                                md: "12px",
                                sm: "10px",
                                xs: "8px",
                              },
                              textAlign: "center",
                            }}
                          >
                            Product Description
                          </Typography>
                        </Grid>

                        <Grid item xl={1} lg={2} md={2} sm={1.5} xs={1.5}>
                          <Typography
                            sx={{
                              color: Colors.white,
                              fontFamily: "Poppins",
                              fontWeight: "500",
                              fontSize: {
                                lg: "16px",
                                md: "12px",
                                sm: "10px",
                                xs: "8px",
                              },
                              textAlign: "left",
                            }}
                          >
                            Quantity
                          </Typography>
                        </Grid>

                        <Grid item xl={1} lg={1} md={0.5} sm={0.5} xs={1}>
                          <Typography
                            sx={{
                              color: Colors.white,
                              fontFamily: "Poppins",
                              fontWeight: "500",
                              width: "100%",
                              fontSize: {
                                lg: "16px",
                                md: "12px",
                                sm: "10px",
                                xs: "8px",
                              },
                              textAlign: { md: "center", lg: "left" },
                            }}
                          >
                            Return Qty
                          </Typography>
                        </Grid>

                        <Grid item xl={1} lg={1.5} md={1} sm={1.5} xs={1.5}>
                          <Typography
                            sx={{
                              color: Colors.white,
                              fontFamily: "Poppins",
                              fontWeight: "500",
                              fontSize: {
                                lg: "16px",
                                md: "12px",
                                sm: "10px",
                                xs: "8px",
                              },
                              textAlign: { md: "center", lg: "left" },
                            }}
                          >
                            Current Price(£)
                          </Typography>
                        </Grid>

                        <Grid item xl={1} lg={1} md={1} sm={1.5} xs={2}>
                          <Typography
                            sx={{
                              color: Colors.white,
                              fontFamily: "Poppins",
                              fontWeight: "500",
                              fontSize: {
                                lg: "16px",
                                md: "12px",
                                sm: "10px",
                                xs: "8px",
                              },
                              textAlign: { md: "center", lg: "left" },
                            }}
                          >
                            Sold Price(£)
                          </Typography>
                        </Grid>

                        <Grid item xl={3.5} lg={2.5} md={2.5} sm={3.5} xs={3}>
                          <Typography
                            sx={{
                              color: Colors.white,

                              fontFamily: "Poppins",
                              fontWeight: "500",
                              fontSize: {
                                lg: "16px",
                                md: "12px",
                                sm: "10px",
                                xs: "8px",
                              },
                              textAlign: "center",
                              width: "100%",
                            }}
                          >
                            Action
                          </Typography>
                        </Grid>
                      </Grid>
                    </Box>

                    <Box
                      sx={{ marginTop: "0px", backgroundColor: Colors.white }}
                    >
                      {selectedInvoice?.productDetails &&
                      selectedInvoice?.productDetails?.length > 0 ? (
                        selectedInvoice?.productDetails?.map((e, i) => {
                          //console.log(highlightP?.includes(e?._id));
                          //console.log(highlightP);
                          //console.log(e?._id);
                         
                          return (
                            <Grid
                              container
                              xs={12}
                              sm={12}
                              md={12}
                              sx={{
                                backgroundColor: highlightP?.includes(e?._id)
                                  ? "rgba(0,0,0,0.2)"
                                  : Colors.white,

                                padding: "10px 0px 10px 0px",
                              }}
                            >
                              {/* <Grid
                                item
                                xl={0.5}
                                lg={0.5}
                                md={1}
                                sm={0.8}
                                xs={0.5}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  // border:"1px solid red"
                                }}
                              >
                                <Typography
                                  sx={{
                                    color: Colors.text,
                                    fontFamily: "Poppins",
                                    fontWeight: "600",
                                    fontSize: { xs: "10px", sm: "16px" },
                                  }}
                                >
                                  {i + 1}
                                </Typography>
                              </Grid> */}

                              <Grid
                                item
                                xl={4}
                                lg={3.5}
                                md={3.5}
                                sm={4}
                                xs={3.5}
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "row",
                                    marginLeft: 2,
                                  }}
                                >
                                  {e?.image1_url && (
                                    <img
                                      src={`${Image_Uri}products/${e?.image1_url}`}
                                      style={{
                                        height:
                                          width < 600
                                            ? "30px"
                                            : width < 800
                                            ? "50px"
                                            : width < 1300
                                            ? "60px"
                                            : "80px",
                                        marginRight: "10px",
                                      }}
                                    />
                                  )}

                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "column",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <Typography
                                      sx={{
                                        color: "background: #000",
                                        fontFamily: "Poppins",
                                        fontWeight: "600",
                                        fontSize: {
                                          lg: "16px",
                                          md: "12px",
                                          sm: "10px",
                                          xs: "8px",
                                        },
                                        textAlign: "left",
                                      }}
                                    >
                                      {e?.productName}
                                    </Typography>
                                    {typeof e?.IMEI == "object" ? (
                                      <View>
                                        {e?.IMEI?.map((it, ind) => {
                                          return (
                                            <View>
                                              <Text
                                                style={{
                                                  fontFamily: "Poppins",
                                                  fontSize: 12,
                                                }}
                                              >
                                                {it},{" "}
                                              </Text>
                                            </View>
                                          );
                                        })}
                                      </View>
                                    ) : (
                                      <Text
                                        style={{
                                          fontFamily: "Poppins",
                                          fontSize: 12,
                                        }}
                                      >
                                        {e?.IMEI}
                                      </Text>
                                    )}
                                    {/* <Typography
                                      sx={{
                                        color: "background: #939598",
                                        fontFamily: "Poppins",
                                        fontWeight: "500",
                                        fontSize: {
                                          lg: "12px",
                                          md: "10px",
                                          sm: "8px",
                                          xs: "6px",
                                        },
                                        textAlign: "left",
                                      }}
                                    >
                                      Category: {e?.category}
                                    </Typography> */}
                                  </Box>
                                </Box>
                              </Grid>

                              <Grid
                                item
                                xl={1}
                                lg={2}
                                md={2}
                                sm={1.5}
                                xs={1.5}
                                sx={{
                                  display: "flex",
                                  //   border:"1px solid red",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    marginRight: "10px",
                                    // border:"1px solid red",
                                    //   justifyContent: "space-between",
                                    width: "100%",
                                    //   border: "1px solid red",
                                  }}
                                >
                                  <button
                                    onClick={() => handleDecreaseProduct(e)}
                                    style={{
                                      width: width < 600 ? "25px" : "35px",
                                      padding: "0px 0px 0px 0px",
                                      height: width < 600 ? "25px" : "35px",
                                      borderRadius: "5px",
                                      marginRight: "10px",
                                      backgroundColor: Colors.white,
                                      fontFamily: "Poppins",
                                      fontWeight: "bold",
                                      border: `1px solid ${Colors?.border}`,
                                    }}
                                  >
                                    -
                                  </button>
                                  <TextField
                                    variant="standard"
                                    margin="normal"
                                    required
                                    onChange={(e) =>
                                      changeDamageQty(e.target.value, i)
                                    }
                                    value={
                                      e?.DamageQty ? e?.DamageQty : e?.saleQty
                                    }
                                    fullWidth
                                    InputProps={{
                                      disableUnderline: true,
                                      fontSize: "12px",
                                      style: {
                                        textAlign: "center",
                                        fontSize: "16px",
                                        alignSelf: "center",
                                      },
                                    }}
                                    inputProps={{
                                      disableUnderline: true,
                                      fontSize: "12px",
                                      style: {
                                        textAlign: "center",
                                        fontSize: "16px",
                                        alignSelf: "center",
                                      },
                                    }}
                                    placeholder="Price"
                                    sx={{
                                      width: width < 600 ? "25px" : "35px",
                                      height: width < 600 ? "25px" : "35px",
                                      fontSize: "12px",
                                      padding: 0,
                                      border: `1px solid ${Colors.border}`,
                                      borderRadius: "5px",
                                      textAlign: "center", // Move textAlign to sx

                                      fontFamily: "Poppins",
                                      fontWeight: "bold",
                                      margin: 0,
                                    }}
                                  />
                                </Box>
                              </Grid>

                              <Grid
                                item
                                xl={1}
                                lg={1}
                                md={0.5}
                                sm={0.5}
                                xs={1}
                                sx={{
                                  display: "flex",
                                  // border:"1px solid red",
                                  // justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <Box
                                  sx={{
                                    color: Colors.text,
                                    fontFamily: "Poppins",
                                    fontWeight: "600",
                                    fontSize: width < 600 ? "10px" : "12px",
                                    // border: `1px solid ${Colors.border}`,
                                    padding: "4px",
                                    // width: width < 600 ? "25px" : "35px",
                                    padding: "0px 0px 0px 0px",
                                    // height: width < 600 ? "25px" : "35px",
                                    display: "flex",
                                  }}
                                >
                                  <TextField
                                    variant="standard" // <== changed this
                                    margin="normal"
                                    value={e?.returnQty ? e?.returnQty : 0}
                                    required
                                    fullWidth
                                    InputProps={{
                                      disableUnderline: true,
                                      fontSize: "12px",
                                      style: {
                                        textAlign: "center",
                                        fontSize: "16px",
                                        alignSelf: "center",
                                      },
                                    }}
                                    inputProps={{
                                      disableUnderline: true,
                                      fontSize: "12px",
                                      style: {
                                        textAlign: "center",
                                        fontSize: "16px",
                                        alignSelf: "center",
                                      },
                                    }}
                                    placeholder="Price"
                                    sx={{
                                      width: width < 600 ? "25px" : "35px",
                                      height: width < 600 ? "25px" : "35px",
                                      fontSize: "12px",
                                      padding: 0,
                                      border: `1px solid ${Colors.border}`,
                                      borderRadius: "5px",
                                      textAlign: "center", // Move textAlign to sx

                                      fontFamily: "Poppins",
                                      fontWeight: "bold",
                                      margin: 0,
                                    }}
                                  />
                                </Box>
                              </Grid>

                              <Grid
                                item
                                xl={1}
                                lg={1.5}
                                md={1}
                                sm={1.5}
                                xs={1.5}
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  // border:"1px solid red"
                                }}
                              >
                                <div style={{ fontWeight: "400" }}>£ </div>{" "}
                                <TextField
                                  variant="standard" // <== changed this
                                  margin="normal"
                                  value={
                                    selectedInvoice.customerDetails[0]
                                      ?.priceLevel[0]?.id == 1
                                      ? e?.trade_price
                                      : selectedInvoice.customerDetails[0]
                                          ?.priceLevel[0]?.id == 2
                                      ? e?.warehouse_price
                                      : selectedInvoice.customerDetails[0]
                                          ?.priceLevel[0]?.id == 4
                                      ? e?.diamond
                                      : e?.retail_price
                                  }
                                  required
                                  fullWidth
                                  InputProps={{
                                    // startAdornment: <AccountCircle />, // <== adjusted this
                                    disableUnderline: true,
                                    fontSize: "12px",

                                    // <== added this
                                    // fontSize: "2px"
                                  }}
                                  placeholder="Search Current Price..."
                                  sx={{
                                    width: "90%",
                                    fontSize: "12px",
                                    padding: 0,
                                    fontFamily: "Poppins",
                                    fontWeight: "bold",
                                    margin: 0,
                                  }}
                                />
                              </Grid>

                              <Grid
                                item
                                xl={1}
                                lg={1}
                                md={1}
                                sm={1.5}
                                xs={2}
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  // border:"1px solid red"
                                }}
                              >
                                <Box
                                  sx={{
                                    color: Colors.text,
                                    fontFamily: "Poppins",
                                    fontWeight: "600",
                                    fontSize: width < 600 ? "10px" : "12px",
                                    border: `1px solid ${Colors.border}`,
                                    padding: "4px",
                                    width: width < 600 ? "70px" : "100px",
                                    display: "flex",
                                  }}
                                >
                                  <TextField
                                    variant="standard" // <== changed this
                                    margin="normal"
                                    value={
                                      e?.discountPrice
                                        ? Number(e?.discountPrice)
                                        : selectedInvoice.customerDetails[0]
                                            ?.priceLevel[0]?.id == 1
                                        ? Number(e?.trade_price)
                                        : selectedInvoice.customerDetails[0]
                                            ?.priceLevel[0]?.id == 2
                                        ? Number(e?.warehouse_price)
                                        : selectedInvoice.customerDetails[0]
                                            ?.priceLevel[0]?.id == 4
                                        ? Number(e?.diamond)
                                        : Number(e?.retail_price)
                                    }
                                    onChange={(text) =>
                                      handleDiscountPrice(text.target.value, e)
                                    }
                                    required
                                    fullWidth
                                    InputProps={{
                                      // startAdornment: <AccountCircle />, // <== adjusted this
                                      disableUnderline: true,
                                      fontSize: "12px",

                                      // <== added this
                                      // fontSize: "2px"
                                    }}
                                    placeholder="Search Product/Customer/Invoice"
                                    sx={{
                                      width: "90%",
                                      fontSize: "12px",
                                      padding: 0,
                                      fontFamily: "Poppins",
                                      fontWeight: "bold",
                                      margin: 0,
                                    }}
                                  />
                                </Box>
                              </Grid>
                              <Grid
                                item
                                xl={3.5}
                                lg={2.5}
                                md={2.5}
                                sm={3.5}
                                xs={3}
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-around",
                                  alignItems: "center",
                                  width: "100%",
                                  // border:"1px solid red"
                                }}
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                  onClick={() => RemoveProduct(selectedInvoice?.invoiceNumber,e._id,false)}
                                >
                                  <img
                                    src={require("../Images/delete.png")}
                                    style={{ height: "25px" }}
                                  />
                                </Box>
                                {(userData?.role?.toLowerCase() == "admin" ||
                                  userData?.role_access?.some(
                                    (e, i) =>
                                      e.name.toLowerCase() == "showcostprice" &&
                                      e?.selected
                                  )) && (
                                  <Box>
                                    {refHover?.hover && refHover.ind == i && (
                                      <Typography sx={{ textAlign: "center" }}>
                                        {e?.cost_price}.000
                                      </Typography>
                                    )}

                                    <Button
                                      onClick={() => {
                                        setRefHover({
                                          hover: !refHover?.hover,
                                          ind: i,
                                        });
                                      }}
                                      sx={{
                                        fontFamily: "Poppins",
                                        fontSize: "12px",
                                        marginLeft: 1,
                                        display: { xs: "none", sm: "block" },
                                        border: `1px solid ${Colors.border}`,
                                        borderRadius: 1,
                                      }}
                                    >
                                      Ref
                                    </Button>
                                  </Box>
                                )}

                                <BasicSelect
                                  value={
                                    e?.returnStatus ? e?.returnStatus : "select"
                                  }
                                  status="Select"
                                  id={productStatus}
                                  width={"120px"}
                                  onChange={(j) => changeProductStatus(j, e)}
                                />
                                {/* <Input
                                  value={e.reason}
                                  onChange={(i) =>
                                    changeProductReason(i.target.value, e)
                                  }
                                  placeholder="Reason"
                                /> */}
                                <Autocomplete
                                  freeSolo
                                  options={
                                    e?.returnStatus == "Unused/Change of mind"
                                      ? [
                                          "No Longer Needed",
                                          "Expensive Price",
                                          "Wrong Product Inside",
                                          "Other",
                                        ]
                                      : e?.returnStatus == "Faulty"
                                      ? [
                                          "Touch Not Wokring",
                                          "LCD Blank",
                                          "Lines on LCD",
                                          "Signal issue",
                                          "Slow charging",
                                          "Other",
                                        ]
                                      : e?.returnStatus == "Damaged"
                                      ? [
                                          "Physical damage",
                                          "LCD flex damage",
                                          "Other",
                                        ]
                                      : []
                                  }
                                  value={e?.reason || ""}
                                  onChange={(event, newValue) =>
                                    changeProductReason(newValue, e)
                                  }
                                  onInputChange={(event, newInputValue) =>
                                    changeProductReason(newInputValue, e)
                                  }
                                  renderInput={(params) => (
                                    <TextField {...params} label="Reason" />
                                  )}
                                />
                                {/* {e?.IMEI && Array?.isArray(e?.IMEI) && e?.IMEI?.length > 0 && <Button
                                                            onClick={()=>handleShowIMEI(e)}
                                                                sx={{
                                                                    fontFamily: "Poppins",
                                                                    fontSize: "12px",
                                                                    marginLeft: 1,
                                                                    display: { xs: "none", sm: "block" },
                                                                    border: `1px solid ${Colors.border}`,
                                                                    borderRadius: 1,
                                                                }}
                                                            >
                                                                Show Imei
                                                            </Button>} */}

                                <Checkbox
                                
                                  // onClick={() => handleSelectProduct2(e,selectedInvoice,true)}
                                  onClick={() =>!e.selected&&  handleSelectProduct(e)}
                                  color={
                                    e.selected ? Colors.white : Colors.black
                                  }
                                  style={{
                                    backgroundColor: e.selected
                                      ? Colors.button
                                      : Colors.white,
                                    // marginLeft: 10,
                                  }}
                                  data={e}
                                />
                              </Grid>
                            </Grid>
                          );
                        })
                      ) : (
                        <Box
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: 10,
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "24px",
                              fontFamily: "Poppins",
                              fontWeight: "bold",
                            }}
                          >
                            No Product Added
                          </Typography>
                        </Box>
                      )}

                      {selectedInvoice?.returnProductDetails &&
                      selectedInvoice?.returnProductDetails?.length > 0
                        ? selectedInvoice?.returnProductDetails?.map((e, i) => {
                            return (
                              <Grid
                                container
                                xs={12}
                                sm={12}
                                md={12}
                                sx={{
                                  backgroundColor: Colors.white,
                                  padding: "10px 0px 10px 0px",
                                }}
                              >
                                <Grid
                                  item
                                  xl={0.8}
                                  lg={0.8}
                                  md={1}
                                  sm={0.8}
                                  xs={0.5}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      color: Colors.text,
                                      fontFamily: "Poppins",
                                      fontWeight: "600",
                                      fontSize: { xs: "10px", sm: "16px" },
                                    }}
                                  >
                                    {i +
                                      1 +
                                      selectedInvoice?.productDetails?.length}
                                  </Typography>
                                </Grid>

                                <Grid
                                  item
                                  xl={3}
                                  lg={2.5}
                                  md={2.5}
                                  sm={3}
                                  xs={2.5}
                                >
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "row",
                                    }}
                                  >
                                    {/* {e?.image1_url && (
                                                        <img
                                                            src={`${Image_Uri}products/${e?.image1_url}`}
                                                            style={{
                                                                height:
                                                                    width < 600
                                                                        ? "30px"
                                                                        : width < 800
                                                                            ? "50px"
                                                                            : width < 1300
                                                                                ? "60px"
                                                                                : "80px",
                                                                marginRight: "10px",
                                                            }}
                                                        />
                                                    )} */}

                                    <Box
                                      sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <Typography
                                        sx={{
                                          color: "background: #000",
                                          fontFamily: "Poppins",
                                          fontWeight: "600",
                                          fontSize: {
                                            lg: "16px",
                                            md: "12px",
                                            sm: "10px",
                                            xs: "8px",
                                          },
                                          textAlign: "left",
                                        }}
                                      >
                                        {e?.productName}
                                      </Typography>
                                      {typeof e?.IMEI == "object" ? (
                                        <View>
                                          {e?.IMEI?.map((it, ind) => {
                                            return (
                                              <View>
                                                <Text
                                                  style={{
                                                    fontFamily: "Poppins",
                                                    fontSize: 12,
                                                  }}
                                                >
                                                  {it},{" "}
                                                </Text>
                                              </View>
                                            );
                                          })}
                                        </View>
                                      ) : (
                                        <Text
                                          style={{
                                            fontFamily: "Poppins",
                                            fontSize: 12,
                                          }}
                                        >
                                          {e?.IMEI}
                                        </Text>
                                      )}
                                      <Typography
                                        sx={{
                                          color: "background: #939598",
                                          fontFamily: "Poppins",
                                          fontWeight: "500",
                                          fontSize: {
                                            lg: "12px",
                                            md: "10px",
                                            sm: "8px",
                                            xs: "6px",
                                          },
                                          textAlign: "left",
                                        }}
                                      >
                                        Category: {e?.category}
                                      </Typography>
                                    </Box>
                                  </Box>
                                </Grid>

                                <Grid
                                  item
                                  xl={1.5}
                                  lg={2}
                                  md={2}
                                  sm={1.5}
                                  xs={1.5}
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <Box
                                    sx={{
                                      display: "flex",
                                      //   justifyContent: "space-between",
                                      width: "100%",
                                      //   border: "1px solid red",
                                    }}
                                  >
                                    {/* <button
                                                        onClick={() => handleDecreaseProduct(e, "exchange")}
                                                        style={{
                                                            width: width < 600 ? "25px" : "35px",
                                                            padding: "0px 0px 0px 0px",
                                                            height: width < 600 ? "25px" : "35px",
                                                            borderRadius: "5px",
                                                            marginRight: "10px",
                                                            backgroundColor: Colors.white,
                                                            fontFamily: "Poppins",
                                                            fontWeight: "bold",
                                                            border: `1px solid ${Colors?.border}`,
                                                        }}
                                                    >
                                                        -
                                                    </button> */}

                                    {/* <Box
                                                        sx={{
                                                            width: width < 600 ? "25px" : "35px",

                                                            height: width < 600 ? "25px" : "35px",
                                                            marginRight: "10px",
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            border: `1px solid ${Colors?.border}`,
                                                            alignItems: "center",
                                                        }}
                                                    >
                                                        {e?.DamageQty ? e?.DamageQty : e?.saleQty}
                                                    </Box> */}

                                    <TextField
                                      variant="standard"
                                      margin="normal"
                                      required
                                      // onChange={(e) =>
                                      //     changeDamageQty(e.target.value, i, "exchange")
                                      // }
                                      value={
                                        e?.DamageQty
                                          ? `-${e?.DamageQty}`
                                          : `-${e?.saleQty}`
                                      }
                                      fullWidth
                                      InputProps={{
                                        disableUnderline: true,
                                        fontSize: "12px",
                                        style: {
                                          textAlign: "center",
                                          fontSize: "16px",
                                          alignSelf: "center",
                                        },
                                      }}
                                      inputProps={{
                                        disableUnderline: true,
                                        fontSize: "12px",
                                        style: {
                                          textAlign: "center",
                                          fontSize: "16px",
                                          alignSelf: "center",
                                        },
                                      }}
                                      placeholder="Quantity"
                                      sx={{
                                        width: width < 600 ? "25px" : "35px",
                                        height: width < 600 ? "25px" : "35px",
                                        fontSize: "12px",
                                        padding: 0,
                                        border: `1px solid ${Colors.border}`,
                                        borderRadius: "5px",
                                        textAlign: "center", // Move textAlign to sx

                                        fontFamily: "Poppins",
                                        fontWeight: "bold",
                                        margin: 0,
                                      }}
                                    />
                                    {/* <button
                                                        style={{
                                                            width: width < 600 ? "25px" : "35px",
                                                            height: width < 600 ? "25px" : "35px",
                                                            padding: "0px 0px 0px 0px",
                                                            borderRadius: "5px",
                                                            color: Colors.button,
                                                            backgroundColor: Colors.white,
                                                            fontFamily: "Poppins",
                                                            fontWeight: "bold",
                                                            border: `1px solid ${Colors?.button}`,
                                                        }}
                                                        onClick={() => handleIncreaseProduct(e)}
                                                    >
                                                        +
                                                    </button> */}
                                  </Box>
                                </Grid>

                                {/* <Grid
                        item
                        xl={1.5}
                        lg={1.5}
                        md={1}
                        sm={2}
                        xs={2}
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <BasicSelect
                          value={e?.warranty ? "Yes" : "No"}
                          status="Select"
                          id={warrantyData}
                          width={{ lg: "80%", md: "60%", xs: "50%" }}
                          onChange={(e) => changeWarranty(e, i)}
                        />
                      </Grid> */}

                                <Grid
                                  item
                                  xl={1.5}
                                  lg={1.5}
                                  md={1}
                                  sm={1.5}
                                  xs={2}
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <TextField
                                    variant="standard" // <== changed this
                                    margin="normal"
                                    value={
                                      selectedInvoice.customerDetails[0]
                                        ?.priceLevel[0]?.id == 1
                                        ? e?.current_tradeprice
                                        : selectedInvoice.customerDetails[0]
                                            ?.priceLevel[0]?.id == 2
                                        ? e?.current_warehouseprice
                                        : selectedInvoice.customerDetails[0]
                                            ?.priceLevel[0]?.id == 4
                                        ? e?.current_diamond
                                        : e?.current_retailprice
                                    }
                                    required
                                    fullWidth
                                    InputProps={{
                                      // startAdornment: <AccountCircle />, // <== adjusted this
                                      disableUnderline: true,
                                      fontSize: "12px",

                                      // <== added this
                                      // fontSize: "2px"
                                    }}
                                    placeholder="Search Current Price..."
                                    sx={{
                                      width: "90%",
                                      fontSize: "12px",
                                      padding: 0,
                                      fontFamily: "Poppins",
                                      fontWeight: "bold",
                                      margin: 0,
                                    }}
                                  />
                                </Grid>

                                <Grid
                                  item
                                  xl={1.5}
                                  lg={1.5}
                                  md={1}
                                  sm={1.5}
                                  xs={2}
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <Box
                                    sx={{
                                      color: Colors.text,
                                      fontFamily: "Poppins",
                                      fontWeight: "600",
                                      fontSize: width < 600 ? "10px" : "12px",
                                      border: `1px solid ${Colors.border}`,
                                      padding: "4px",
                                      width: width < 600 ? "70px" : "100px",
                                      display: "flex",
                                    }}
                                  >
                                    <TextField
                                      variant="standard" // <== changed this
                                      margin="normal"
                                      value={`-${
                                        Number(e?.discountPrice)
                                          ? e?.discountPrice
                                          : selectedInvoice.customerDetails[0]
                                              ?.priceLevel[0]?.id == 1
                                          ? e?.trade_price
                                          : selectedInvoice.customerDetails[0]
                                              ?.priceLevel[0]?.id == 2
                                          ? e?.warehouse_price
                                          : selectedInvoice.customerDetails[0]
                                              ?.priceLevel[0]?.id == 4
                                          ? e?.diamond
                                          : e?.retail_price
                                      }`}
                                      onChange={(text) =>
                                        handleDiscountPrice(
                                          text.target.value,
                                          e
                                        )
                                      }
                                      required
                                      fullWidth
                                      InputProps={{
                                        // startAdornment: <AccountCircle />, // <== adjusted this
                                        disableUnderline: true,
                                        fontSize: "12px",

                                        // <== added this
                                        // fontSize: "2px"
                                      }}
                                      placeholder="Search Product/Customer/Invoice"
                                      sx={{
                                        width: "90%",
                                        fontSize: "12px",
                                        padding: 0,
                                        fontFamily: "Poppins",
                                        fontWeight: "bold",
                                        margin: 0,
                                      }}
                                    />
                                  </Box>
                                </Grid>
                                <Grid
                                  item
                                  xl={3}
                                  lg={3}
                                  md={3}
                                  sm={4}
                                  xs={3.5}
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                    onClick={() =>{
                                      e.selected = false
                                      RemoveProduct(selectedInvoice?.invoiceNumber,e._id,false)
                                    }}
                                  >
                                    <img
                                      src={require("../Images/delete.png")}
                                      style={{ height: "25px" }}
                                    />
                                  </Box>
                                  {userData?.show_price && (
                                    <Box>
                                      {refHover?.hover &&
                                        refHover.ind ==
                                          i +
                                            selectedInvoice?.productDetails
                                              ?.length && (
                                          <Typography
                                            sx={{ textAlign: "center" }}
                                          >
                                            {e?.current_costprice}.00
                                          </Typography>
                                        )}

                                      <Button
                                        onMouseEnter={() =>
                                          setRefHover({
                                            hover: true,
                                            ind:
                                              i +
                                              selectedInvoice?.productDetails
                                                ?.length,
                                          })
                                        }
                                        onMouseLeave={() =>
                                          setRefHover({
                                            hover: false,
                                          })
                                        }
                                        sx={{
                                          fontFamily: "Poppins",
                                          fontSize: "12px",
                                          marginLeft: 1,
                                          display: { xs: "none", sm: "block" },
                                          border: `1px solid ${Colors.border}`,
                                          borderRadius: 1,
                                        }}
                                      >
                                        Ref
                                      </Button>
                                    </Box>
                                  )}

                                  {/* <Checkbox onClick={() => handleSelectProduct(e)} color={e.selected ? Colors.white : Colors.black} style={{ backgroundColor: e.selected ? Colors.button : Colors.white, marginLeft: 10 }} data={e} /> */}
                                </Grid>
                              </Grid>
                            );
                          })
                        : ""}
                    </Box>
                  </Box>
                )}

            {selectedInvoice &&
              selectedSearch?.toLowerCase() !== "checkout" && (
                <Box
                  sx={{
                    width: "100%",
                    backgroundColor: Colors.white,
                    marginTop: "10px",
                    padding: "20px",
                    borderRadius: "5px",
                  }}
                >
                  <Grid container xs={12} sm={12} md={12}>
                    <Grid item xs={12} sm={12} md={7}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "10px",
                          borderBottom: `1px solid ${Colors.border}`,
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: "Poppins",
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: Colors.text,
                          }}
                        >
                          Invoice Number
                        </Typography>

                        <Typography
                          sx={{
                            fontFamily: "Poppins",
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: Colors.text,
                          }}
                        >
                          #{selectedInvoice.invoiceNumber}
                        </Typography>
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "10px",
                          borderBottom: `1px solid ${Colors.border}`,
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: "Poppins",
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: Colors.text,
                          }}
                        >
                          Total Products
                        </Typography>

                        <Typography
                          sx={{
                            fontFamily: "Poppins",
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: Colors.text,
                          }}
                        >
                          {selectedInvoice.totalItems}
                        </Typography>
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "10px",
                          borderBottom: `1px solid ${Colors.border}`,
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: "Poppins",
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: Colors.text,
                          }}
                        >
                          Total Quantity
                        </Typography>

                        <Typography
                          sx={{
                            fontFamily: "Poppins",
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: Colors.text,
                          }}
                        >
                          {selectedInvoice.productDetails.reduce(
                            (previous, current) =>
                              previous + Number(current.saleQty),
                            0
                          )}
                        </Typography>
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "10px",
                          borderBottom: `1px solid ${Colors.border}`,
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: "Poppins",
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: Colors.text,
                          }}
                        >
                          Subtotal
                        </Typography>

                        <Typography
                          sx={{
                            fontFamily: "Poppins",
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: Colors.text,
                          }}
                        >
                          £{Number(selectedInvoice.total).toFixed(2)}
                        </Typography>
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "10px",
                          borderBottom: `1px solid ${Colors.border}`,
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: "Poppins",
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: Colors.text,
                          }}
                        >
                          Discount
                        </Typography>

                        <Typography
                          sx={{
                            fontFamily: "Poppins",
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: Colors.text,
                          }}
                        >
                          £
                          {selectedInvoice.discount
                            ? Number(selectedInvoice.discount).toFixed(2)
                            : 0}
                        </Typography>
                      </Box>

                      {selectedInvoice?.SDAmount&& <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "10px",
                          borderBottom: `1px solid ${Colors.border}`,
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: "Poppins",
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: Colors.text,
                          }}
                        >
                          Special Discount
                        </Typography>

                        <Typography
                          sx={{
                            fontFamily: "Poppins",
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: Colors.text,
                          }}
                        >
                          - £
                          {selectedInvoice.SDAmount
                            ? Number(selectedInvoice.SDAmount).toFixed(2)
                            : 0}
                        </Typography>
                      </Box>}

                      {selectedInvoice?.discount &&
                      selectedInvoice?.vatAmount ? (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "10px",
                            borderBottom: `1px solid ${Colors.border}`,
                          }}
                        >
                          <Typography
                            sx={{
                              fontFamily: "Poppins",
                              fontSize: "14px",
                              fontWeight: "bold",
                              color: Colors.text,
                            }}
                          >
                            Subtotal After Discount
                          </Typography>

                          <Typography
                            sx={{
                              fontFamily: "Poppins",
                              fontSize: "14px",
                              fontWeight: "bold",
                              color: Colors.text,
                            }}
                          >
                            £
                            {Number(
                              Number(selectedInvoice?.total) -
                                Number(selectedInvoice?.discount)?.toFixed(2)
                            )}
                          </Typography>
                        </Box>
                      ) : (
                        ""
                      )}

                      {selectedInvoice.vatAmount ? (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "10px",
                            borderBottom: `1px solid ${Colors.border}`,
                          }}
                        >
                          <Typography
                            sx={{
                              fontFamily: "Poppins",
                              fontSize: "14px",
                              fontWeight: "bold",
                              color: Colors.text,
                            }}
                          >
                            VAT
                          </Typography>

                          <Typography
                            sx={{
                              fontFamily: "Poppins",
                              fontSize: "14px",
                              fontWeight: "bold",
                              color: Colors.text,
                            }}
                          >
                            £{Number(selectedInvoice.vatAmount).toFixed(2)}
                          </Typography>
                        </Box>
                      ) : (
                        ""
                      )}

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "10px",
                          borderBottom: `1px solid ${Colors.border}`,
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: "Poppins",
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: Colors.button,
                          }}
                        >
                          Total
                        </Typography>

                        <Typography
                          sx={{
                            fontFamily: "Poppins",
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: Colors.button,
                          }}
                        >
                          £{Number(selectedInvoice.subtotal).toFixed(2)}
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid item xs={12} sm={12} md={5}>
                      {/* <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "180px",
                                    width: "100%",
                                }}
                            >


                                <Button
                                    onClick={() => handleGenerateNewInvoice()}
                                    sx={{
                                        backgroundColor: Colors.button,
                                        color: Colors.white,
                                        marginTop: "15px",
                                        fontFamily: "Poppins",
                                        fontSize: "12px",
                                        padding: "5px",
                                        borderRadius: "20px",
                                        border: `1px solid ${Colors.button}`,
                                        width: "150px",
                                    }}
                                >
                                    Generate Sale Return Invoice
                                </Button>
                            </Box> */}
                    </Grid>
                  </Grid>
                </Box>
              )}

            {selectedInvoice &&
              selectedInvoice.productDetails.some((e, i) => e.selected) && (
                <Box
                  sx={{
                    width: "100%",
                    backgroundColor: Colors.white,
                    marginTop: "10px",
                    padding: "20px",
                    borderRadius: "5px",
                  }}
                >
                  {selectedSearch?.toLowerCase() !== "checkout" && (
                    <Grid container xs={12} sm={12} md={12}>
                      <Grid item xs={12} sm={12} md={7}>
                        <Box>
                          <Typography
                            sx={{
                              fontFamily: "Poppins",
                              fontSize: "18px",
                              fontWeight: "bold",
                              color: Colors.text,
                              marginBottom: 2,
                            }}
                          >
                            Sale Return Details:
                          </Typography>
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "10px",
                            borderBottom: `1px solid ${Colors.border}`,
                          }}
                        >
                          <Typography
                            sx={{
                              fontFamily: "Poppins",
                              fontSize: "14px",
                              fontWeight: "bold",
                              color: Colors.text,
                            }}
                          >
                            Total Products
                          </Typography>

                          <Typography
                            sx={{
                              fontFamily: "Poppins",
                              fontSize: "14px",
                              fontWeight: "bold",
                              color: Colors.text,
                            }}
                          >
                            {damageItems}
                          </Typography>
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "10px",
                            borderBottom: `1px solid ${Colors.border}`,
                          }}
                        >
                          <Typography
                            sx={{
                              fontFamily: "Poppins",
                              fontSize: "14px",
                              fontWeight: "bold",
                              color: Colors.text,
                            }}
                          >
                            Total Quantity
                          </Typography>

                          <Typography
                            sx={{
                              fontFamily: "Poppins",
                              fontSize: "14px",
                              fontWeight: "bold",
                              color: Colors.text,
                            }}
                          >
                            {damageQty}
                          </Typography>
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "10px",
                            borderBottom: `1px solid ${Colors.border}`,
                          }}
                        >
                          <Typography
                            sx={{
                              fontFamily: "Poppins",
                              fontSize: "14px",
                              fontWeight: "bold",
                              color: Colors.text,
                            }}
                          >
                            Subtotal
                          </Typography>

                          <Typography
                            sx={{
                              fontFamily: "Poppins",
                              fontSize: "14px",
                              fontWeight: "bold",
                              color: Colors.text,
                            }}
                          >
                            £ {Number(damagetotal).toFixed(2)}
                          </Typography>
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "10px",
                            borderBottom: `1px solid ${Colors.border}`,
                          }}
                        >
                          <Typography
                            sx={{
                              fontFamily: "Poppins",
                              fontSize: "14px",
                              fontWeight: "bold",
                              color: Colors.text,
                            }}
                          >
                            Discount
                          </Typography>

                          <Typography
                            sx={{
                              fontFamily: "Poppins",
                              fontSize: "14px",
                              fontWeight: "bold",
                              color: Colors.text,
                            }}
                          >
                            £
                            {damageDiscount
                              ? Number(damageDiscount)?.toFixed(2)
                              : 0}{" "}
                          </Typography>
                        </Box>
{selectedInvoice?.SDAmount&& <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "10px",
                          borderBottom: `1px solid ${Colors.border}`,
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: "Poppins",
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: Colors.text,
                          }}
                        >
                          Special Discount
                        </Typography>

                        <Typography
                          sx={{
                            fontFamily: "Poppins",
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: Colors.text,
                          }}
                        >
                          - £
                          {
     ( (((damagetotal)) * ((selectedInvoice?.SDAmount / ((selectedInvoice?.total)-(selectedInvoice?.discount||0))) * 100)) / 100).toFixed(2)
     }
                        </Typography>
                      </Box>}
                        {damageDiscount && damageVat ? (
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              padding: "10px",
                              borderBottom: `1px solid ${Colors.border}`,
                            }}
                          >
                            <Typography
                              sx={{
                                fontFamily: "Poppins",
                                fontSize: "14px",
                                fontWeight: "bold",
                                color: Colors.text,
                              }}
                            >
                              Subtotal After Discount
                            </Typography>

                            <Typography
                              sx={{
                                fontFamily: "Poppins",
                                fontSize: "14px",
                                fontWeight: "bold",
                                color: Colors.text,
                              }}
                            >
                              £
                              {Number(
                                (damagetotal - damageDiscount).toFixed(2)
                              )}{" "}
                            </Typography>
                          </Box>
                        ) : (
                          ""
                        )}

                        {selectedInvoice.vatAmount ? (
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              padding: "10px",
                              borderBottom: `1px solid ${Colors.border}`,
                            }}
                          >
                            <Typography
                              sx={{
                                fontFamily: "Poppins",
                                fontSize: "14px",
                                fontWeight: "bold",
                                color: Colors.text,
                              }}
                            >
                              VAT
                            </Typography>

                            <Typography
                              sx={{
                                fontFamily: "Poppins",
                                fontSize: "14px",
                                fontWeight: "bold",
                                color: Colors.text,
                              }}
                            >
                              £{Number(damageVat).toFixed(2)}
                            </Typography>
                          </Box>
                        ) : (
                          ""
                        )}

                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "10px",
                            borderBottom: `1px solid ${Colors.border}`,
                          }}
                        >
                          <Typography
                            sx={{
                              fontFamily: "Poppins",
                              fontSize: "14px",
                              fontWeight: "bold",
                              color: Colors.button,
                            }}
                          >
                            Total
                          </Typography>

                          <Typography
                            sx={{
                              fontFamily: "Poppins",
                              fontSize: "14px",
                              fontWeight: "bold",
                              color: Colors.button,
                            }}
                          >
                            £{Number(damageSubtotal).toFixed(2)}
                          </Typography>
                        </Box>
                      </Grid>

                      <Grid item xs={12} sm={12} md={5}>
                        {/* <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "180px",
                            width: "100%",
                          }}
                        >
                          <CustomButton
                            onClick={() => handleOpenConfimModal()}
                            sx={{
                              backgroundColor: Colors.button,
                              color: Colors.white,
                              marginTop: "15px",
                              fontFamily: "Poppins",
                              fontSize: "12px",
                              padding: "8px",
                              borderRadius: "5px",
                              border: `1px solid ${Colors.button}`,
                              width: "150px",
                            }}
                            text={
                             
                              "Add In Return"
                            }
                          />
                        </Box> */}
                      </Grid>
                    </Grid>
                  )}
                </Box>
              )}

            {selectedSearch?.toLowerCase() == "checkout" &&
              allReturnProducts &&
              allReturnProducts?.length > 0 && (
                <Grid
                  container
                  xs={12}
                  sm={12}
                  md={12}
                  style={{ marginTop: 30 }}
                >
                  <Grid item xs={12} sm={12} md={7}>
                    <Box>
                      <Typography
                        sx={{
                          fontFamily: "Poppins",
                          fontSize: "18px",
                          fontWeight: "bold",
                          color: Colors.text,
                          marginBottom: 2,
                        }}
                      >
                        Sale Return Details:
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "10px",
                        borderBottom: `1px solid ${Colors.border}`,
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: "Poppins",
                          fontSize: "14px",
                          fontWeight: "bold",
                          color: Colors.text,
                        }}
                      >
                        Total Products
                      </Typography>

                      <Typography
                        sx={{
                          fontFamily: "Poppins",
                          fontSize: "14px",
                          fontWeight: "bold",
                          color: Colors.text,
                        }}
                      >
                        {allReturnProducts &&
                          allReturnProducts?.length > 0 &&
                          allReturnProducts?.reduce((pre, curr) => {
                            return (
                              (Number(pre) || 0) + Number(curr?.totalItems || 0)
                            );
                          }, 0)}
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "10px",
                        borderBottom: `1px solid ${Colors.border}`,
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: "Poppins",
                          fontSize: "14px",
                          fontWeight: "bold",
                          color: Colors.text,
                        }}
                      >
                        Total Quantity
                      </Typography>

                      <Typography
                        sx={{
                          fontFamily: "Poppins",
                          fontSize: "14px",
                          fontWeight: "bold",
                          color: Colors.text,
                        }}
                      >
                        {allReturnProducts &&
                          allReturnProducts?.length > 0 &&
                          allReturnProducts?.reduce((pre, curr) => {
                            return (
                              (Number(pre) || 0) + Number(curr?.totalQty || 0)
                            );
                          }, 0)}
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "10px",
                        borderBottom: `1px solid ${Colors.border}`,
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: "Poppins",
                          fontSize: "14px",
                          fontWeight: "bold",
                          color: Colors.text,
                        }}
                      >
                        Total
                      </Typography>

                      <Typography
                        sx={{
                          fontFamily: "Poppins",
                          fontSize: "14px",
                          fontWeight: "bold",
                          color: Colors.text,
                        }}
                      >
                        £
                        {Number(
                          allReturnProducts &&
                            allReturnProducts?.length > 0 &&
                            allReturnProducts?.reduce((pre, curr) => {
                              return (
                                (Number(pre) || 0) + Number(curr?.total || 0)
                              );
                            }, 0)
                        ).toFixed(2)}
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "10px",
                        borderBottom: `1px solid ${Colors.border}`,
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: "Poppins",
                          fontSize: "14px",
                          fontWeight: "bold",
                          color: Colors.text,
                        }}
                      >
                        Discount
                      </Typography>

                      <Typography
                        sx={{
                          fontFamily: "Poppins",
                          fontSize: "14px",
                          fontWeight: "bold",
                          color: Colors.text,
                        }}
                      >
                        £
                        {Number(
                          allReturnProducts &&
                            allReturnProducts?.length > 0 &&
                            allReturnProducts?.reduce((pre, curr) => {
                              return (
                                (Number(pre) || 0) + Number(curr?.discount || 0)
                              );
                            }, 0)
                        ).toFixed(2)}
                      </Typography>
                    </Box>
{ <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "10px",
                          borderBottom: `1px solid ${Colors.border}`,
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: "Poppins",
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: Colors.text,
                          }}
                        >
                          Special Discount
                        </Typography>

                        <Typography
                          sx={{
                            fontFamily: "Poppins",
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: Colors.text,
                          }}
                        >
                          - £
                          {
     (allReturnProducts?.reduce((pre, curr) => {
        return (pre || 0) + (Number(curr?.SDAmount) || 0);
      }, 0))?.toFixed(2)||0
     }
                        </Typography>
                      </Box>}
                      <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "10px",
                        borderBottom: `1px solid ${Colors.border}`,
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: "Poppins",
                          fontSize: "14px",
                          fontWeight: "bold",
                          color: Colors.button,
                        }}
                      >
                        Subtotal
                      </Typography>

                      <Typography
                        sx={{
                          fontFamily: "Poppins",
                          fontSize: "14px",
                          fontWeight: "bold",
                          color: Colors.button,
                        }}
                      >
                        £
                        {Number(
                          allReturnProducts &&
                            allReturnProducts?.length > 0 &&
                            allReturnProducts?.reduce((pre, curr) => {
                              return (
                                (Number(pre) || 0) + (Number(curr?.total || 0)-Number(curr?.SDAmount))
                              );
                            }, 0)
                        ).toFixed(2)}
                      </Typography>
                    </Box>
                    { (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "10px",
                          borderBottom: `1px solid ${Colors.border}`,
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: "Poppins",
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: Colors.text,
                          }}
                        >
                          VAT
                        </Typography>

                        <Typography
                          sx={{
                            fontFamily: "Poppins",
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: Colors.text,
                          }}
                        >
                          £
                          {Number(
                            allReturnProducts &&
                              allReturnProducts?.length > 0 &&
                              allReturnProducts?.reduce((pre, curr) => {
                                return (
                                  (Number(pre) || 0) +
                                  Number(curr?.vatAmount || 0)
                                );
                              }, 0)
                          ).toFixed(2)}
                        </Typography>
                      </Box>
                    )}

                    

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "10px",
                        borderBottom: `1px solid ${Colors.border}`,
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: "Poppins",
                          fontSize: "14px",
                          fontWeight: "bold",
                          color: Colors.button,
                        }}
                      >
                        Total
                      </Typography>

                      <Typography
                        sx={{
                          fontFamily: "Poppins",
                          fontSize: "14px",
                          fontWeight: "bold",
                          color: Colors.button,
                        }}
                      >
                        £
                        {Number(
                          allReturnProducts &&
                            allReturnProducts?.length > 0 &&
                            allReturnProducts?.reduce((pre, curr) => {
                              return (
                                (Number(pre) || 0) + Number(curr?.subtotal || 0)
                              );
                            }, 0)
                        ).toFixed(2)}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={5}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        // height: "200px",
                        width: "100%",
                        // border: "1px solid red"
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          mb: 1,
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "14px",
                            fontFamily: "Poppins",
                            width: 200,
                            fontWeight: "bold",
                          }}
                        >
                          Credit Note on Account
                        </Typography>

                        <Checkbox
                          data={deductCreditBalance}
                          onClick={() => handleSelectReturnOption("credit")}
                          style={{
                            marginLeft: "5px",
                            backgroundColor: deductCreditBalance.selected
                              ? Colors.button
                              : Colors.white,
                          }}
                          color={
                            deductCreditBalance.selected
                              ? Colors.white
                              : Colors.black
                          }
                        />
                      </Box>

                      {deductCreditBalance?.selected && (
                        <BasicSelect
                          id={deductBalanceOptions}
                          value={selectedDeductBalanceOption}
                          width={"150px"}
                          style={{ marginBottom: "10px", marginTop: "8px" }}
                          onChange={(e) => setSelectedDeductBalanceOption(e)}
                        />
                      )}
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography
                          sx={{
                            fontSize: "14px",
                            fontFamily: "Poppins",
                            width: 200,
                            fontWeight: "bold",
                          }}
                        >
                          Refund Cash
                        </Typography>

                        <Checkbox
                          data={refundCash}
                          onClick={() => handleSelectReturnOption("cash")}
                          style={{
                            marginLeft: "5px",
                            backgroundColor: refundCash.selected
                              ? Colors.button
                              : Colors.white,
                          }}
                          color={
                            refundCash.selected ? Colors.white : Colors.black
                          }
                        />
                      </Box>

                      <Box
                        sx={{ display: "flex", alignItems: "center", mt: 1 }}
                      >
                        <Typography
                          sx={{
                            fontSize: "14px",
                            fontFamily: "Poppins",
                            width: 200,
                            fontWeight: "bold",
                          }}
                        >
                          Refund Card
                        </Typography>

                        <Checkbox
                          data={refundCard}
                          onClick={() => handleSelectReturnOption("card")}
                          style={{
                            marginLeft: "5px",
                            backgroundColor: refundCard.selected
                              ? Colors.button
                              : Colors.white,
                          }}
                          color={
                            refundCard.selected ? Colors.white : Colors.black
                          }
                        />
                      </Box>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        // justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <CustomButton
                        onClick={() =>
                          refundCash || refundCard || deductCreditBalance
                            ? setConfirmModalVisible(true)
                            : message.info("Please Select option")
                        }
                        style={{
                          backgroundColor: Colors.button,
                          color: Colors.white,
                          // marginTop: "15px",
                          fontFamily: "Poppins",
                          marginBottom: "10px",
                          // mt: 3,
                          // border:"1px solid red",
                          fontSize: "12px",
                          padding: "8px",
                          borderRadius: "5px",
                          border: `1px solid ${Colors.button}`,
                          // width: "150px",
                        }}
                        text={"Return Invoice"}
                      />

                      <CustomButton
                        onClick={() => handleGoForExchange()}
                        style={{
                          backgroundColor: Colors.button,
                          color: Colors.white,
                          // marginTop: "15px",
                          fontFamily: "Poppins",
                          fontSize: "12px",
                          padding: "8px",
                          borderRadius: "5px",
                          border: `1px solid ${Colors.button}`,
                          // width: "150px",
                        }}
                        text={"Exchange Products"}
                      />
                    </Box>
                  </Grid>
                </Grid>
              )}

            {successfulTransactionModal && (
              <CustomModal
                heading={`Transaction Successfull`}
                loading={loading}
                emailbutton={true}
                emailInvoice={emailInvoice}
                emailLoading={emailLoading}
                text={"Do You want to print the Return invoice?"}
                open={successfulTransactionModal}
                closeModal={() => cancelModal()}
                confirm={() => setPdfDownloadView(true)}
              />
            )}

            <CustomModal
              heading={`Sale Return`}
              loading={loading}
              text={
                refundCash?.selected
                  ? "Are you sure you want to refund cash?"
                  : refundCard?.selected
                  ? "Are you sure you want to refund by card?"
                  : "Are you sure you want to Credit Note on Account?"
              }
              open={confirmModalVisible}
              closeModal={() => setConfirmModalVisible(false)}
              confirm={() => !loading && handleGenerateNewInvoice()}
            />
          </Box>
        )}
      </Modal>
    </div>
  );
}
